import { Component, OnInit, Inject, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject, forkJoin } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';
import { ManagementComponent } from '../management.component';
import { GridApi, ColumnApi, ColDef } from 'ag-grid-community';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-purchase-orders',
  templateUrl: './purchase-orders.component.html',
  styleUrls: ['./purchase-orders.component.css'],
    providers: [
      // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
      // application's root module. We provide it at the component level here, due to limitations of
      // our example generation script.
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },

      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})
export class PurchaseOrdersComponent implements OnInit {

  constructor(private parent:ManagementComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {
      translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
      translate.setDefaultLang('en');

      const browserLang = this.parent.getLanguage();
      translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };

       // Debounce search.
       this.searchMainOrders.pipe(
        debounceTime(750),
        distinctUntilChanged())
        .subscribe(value => {
          this.LoadingMainSearchTerm = true;

          this.InitializeFilter();
          this.DisablePeriod();
          this.ClearPeriod();

          this.Filter.SearchTerm = value;
          // Call appropriate method based on active tab
          if (this.showOffersTab) {
            this.GetOrdersFiltered(1);
          } else {
            this.GetProductsFiltered(1);
          }
        });

        // Debounce search.
        this.searchB2BUser.pipe(
          debounceTime(400),
          distinctUntilChanged())
          .subscribe(value => {
            this.GetUserClientsFiltered(value);
          });

            // Debounce search.
       this.searchUserManagerUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUserManagersFiltered(value);
        });

       // Debounce search.
       this.searchPartnerUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetPartnersFiltered(value, null, true);
        });

       // Debounce search.
       this.searchTermUpdate.pipe(
        debounceTime(500),
        distinctUntilChanged())
        .subscribe(value => {
          this.Filter.SearchTerm = value;

          if(this.Filter.SearchTerm?.length > 2){
            this.applyFilter(1);
          }
        });

       // Debounce brand search.
       this.brandSearchTermUpdate.pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetBrandsFiltered(value);
          }
        });

       // Debounce supplier search (100ms - faster like cell popup).
       this.searchSupplierUpdate.pipe(
        debounceTime(100),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetSuppliersFiltered(value);
          }
        });

       // Debounce partner popup search (header overlay).
       this.partnerPopupSearchUpdate.pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetPartnersFilteredPopup(value);
          }
        });
    }

    @ViewChild('autosize') autosize: CdkTextareaAutosize;
    searchTermUpdate = new Subject<string>();
    searchPartnerUpdate = new Subject<string>();
    partnerPopupSearchUpdate = new Subject<string>();
    searchUserManagerUpdate = new Subject<string>();
    searchB2BUser = new Subject<string>();
    searchMainOrders = new Subject<string>();
    brandSearchTermUpdate = new Subject<string>();
    searchSupplierUpdate = new Subject<string>();

    LoadingMainSearchTerm:boolean = false;

    // Brand filter properties
    BrandFilter: {[k: string]: any} = {};
    Brands: any[] = [];
    showBrandDropdown: boolean = false;
    showBrandPopup: boolean = false;
    brandSearchTerm: string = '';
    loadingBrands: boolean = false;

    // Supplier filter properties
    SupplierFilter: {[k: string]: any} = {};
    Suppliers: any[] = [];
    showSupplierDropdown: boolean = false;
    showSupplierPopup: boolean = false;
    supplierSearchTerm: string = '';
    loadingSuppliers: boolean = false;

    // Partner filter properties (header overlay)
    showPartnerPopup: boolean = false;
    partnerSearchTerm: string = '';
    loadingPartners: boolean = false;

    // Grid header widths for custom overlay
    gridHeaderWidths: any[] = [];

    searchMainOrdersSearchTerm:string;

    // Convert to Order - Send Email dropdown (default false)
    sendEmailOnConvert: boolean = false;
    showSendEmailResults: boolean = false;
    sendEmailOptions = [
      { value: true, label: 'Send Email' },
      { value: false, label: 'Do Not Send Email' }
    ];

    // Generate PO confirmation popup
    ShowGeneratePOConfirmation: boolean = false;

    // ✅ Purchase Currency dropdown properties
    showPurchaseCurrencyDropdown: boolean = false;
    purchaseCurrencyDropdownPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '60px' };
    purchaseCurrencyRowIndex: number = -1;

    // ✅ Sell Currency (SC) popup properties
    ShowChangeSellCurrencyPopup: boolean = false;
    selectedSellCurrency: any = null;
    showSellCurrencyResults: boolean = false;
    selectedOfferDBIDForCurrency: number = 0;

    // ✅ EditContainer Partner & Currency Management
    editContainerPartnerSearchTerm: string = '';
    editContainerPartnerSearchTermUpdate = new Subject<string>();
    editContainerSearchedPartners: any[] = [];
    editContainerLoadingPartners: boolean = false;
    showEditContainerPartnerResults: boolean = false;
    showEditContainerCurrencyResults: boolean = false;

    ngOnInit(): void {
      this.loadAutoSaveDelay();
      this.InitializeFilter();
      this.GetOfferMasterData();
      this.GetShippingMasterData();
      this.initProductsGrid();
      this.initUndoDatabase();

      // ✅ EditContainer Partner search debounce
      this.editContainerPartnerSearchTermUpdate.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(() => {
        this.GetEditContainerPartnersFiltered();
      });
    }

    // Initialize Products tab grid - same as offer grid but with extra Offer/Partner columns
    initProductsGrid(): void {
      // Copy offer column defs (exclude last 2: datasheet/delete and save buttons, we'll add save at the end)
      const baseColumns = this.offerColumnDefs.slice(0, -2).map((col: ColDef) => {
        return { ...col };
      });
      // Get the save column to add at the end
      const saveColumn = { ...this.offerColumnDefs[this.offerColumnDefs.length - 1] };

      // Delete column
      const deleteColumn: ColDef = {
        headerName: '',
        field: 'delete',
        editable: false,
        width: 25,
        minWidth: 25,
        maxWidth: 25,
        suppressMenu: true,
        sortable: false,
        resizable: false,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' },
        cellRenderer: () => {
          return `<i class="material-icons" style="font-size: 14px; color: #d32f2f; cursor: pointer;" title="Delete">close</i>`;
        },
        onCellClicked: (params: any) => {
          // Check if there are selected rows for multi-delete
          if (this.hasSelectedCartItems()) {
            this.IsMultiDelete = true;
          } else {
            this.IsMultiDelete = false;
            this.DeleteCartItemParams = params;
          }
          this.ShowDeleteCartItemConfirmation = true;
        }
      };

      // Put index and status columns first (index at position 0, status at position 1 in offerColumnDefs)
      const indexCol = { ...baseColumns[0], headerClass: 'products-index-header' }; // index column with products-specific headerClass
      const statusCol = {
        ...baseColumns[1],
        headerClass: 'products-status-header',
        // Override cellRenderer to set progressStatusPopupIsProductsGrid = true for products grid
        cellRenderer: (params: any) => {
          const alias = params.data?.CartItem?.ProgressStatus?.Alias ?? '';
          // Create element with right-click handler
          const container = document.createElement('div');
          container.style.cssText = 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;';
          container.innerHTML = `<span style="font-size: 9px; font-weight: 600;">${alias}</span>`;

          // Add right-click (context menu) handler
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            const cartItem = params.data?.CartItem;
            if (!cartItem) return;

            // Set popup position near the click
            this.progressStatusPopupPosition = {
              top: (event.clientY) + 'px',
              left: (event.clientX) + 'px'
            };

            // Store clicked row info
            this.progressStatusPopupCartItem = cartItem;
            this.progressStatusPopupRowIndex = params.rowIndex;
            this.progressStatusPopupIsProductsGrid = true; // This is the products grid

            // Show the popup
            this.showProgressStatusCellPopup = true;
          });

          return container;
        },
        onCellDoubleClicked: (params: any) => {
          this.handleProgressStatusDoubleClick(params, true);
        }
      };
      const restColumns = baseColumns.slice(2); // all other columns (skip index and status)

      // Delivery Preference column (DP): P=Partial(green), F=Full(red)
      const deliveryPrefCol: ColDef = {
        headerName: 'DP',
        field: 'deliveryPreference',
        editable: false,
        minWidth: 30,
        maxWidth: 35,
        width: 33,
        suppressMenu: true,
        cellStyle: (params: any) => {
          const dpId = params.data?.CartItem?.DeliveryPreference?.ID;
          const bg = dpId === 1 ? 'rgba(253, 79, 87, 0.6)' : 'rgba(50, 170, 58, 0.6)';
          return { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0', cursor: 'pointer', backgroundColor: bg, color: '#fff' };
        },
        cellRenderer: (params: any) => {
          const dpId = params.data?.CartItem?.DeliveryPreference?.ID;
          const alias = dpId === 1 ? 'FD' : 'PD';
          const container = document.createElement('div');
          container.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;';
          container.innerHTML = `<span style="font-size:9px;font-weight:700;color:#fff;">${alias}</span>`;
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            const cartItem = params.data?.CartItem;
            if (!cartItem) return;
            this.deliveryPreferencePopupPosition = { top: event.clientY + 'px', left: event.clientX + 'px' };
            this.deliveryPreferencePopupCartItem = cartItem;
            this.deliveryPreferencePopupRowIndex = params.rowIndex;
            this.showDeliveryPreferencePopup = true;
          });
          return container;
        }
      };

      // Consolidation Type column (CT): C=Consolidated(green), D=DispatchImmediately(red)
      const consolidationTypeCol: ColDef = {
        headerName: 'CT',
        field: 'consolidationType',
        editable: false,
        minWidth: 30,
        maxWidth: 35,
        width: 33,
        suppressMenu: true,
        cellStyle: (params: any) => {
          const ctId = params.data?.CartItem?.ConsolidationType?.ID;
          const bg = ctId === 1 ? 'rgba(253, 79, 87, 0.6)' : 'rgba(50, 170, 58, 0.6)';
          return { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0', cursor: 'pointer', backgroundColor: bg, color: '#fff' };
        },
        cellRenderer: (params: any) => {
          const ctId = params.data?.CartItem?.ConsolidationType?.ID;
          const alias = ctId === 1 ? 'I' : 'GR';
          const container = document.createElement('div');
          container.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;';
          container.innerHTML = `<span style="font-size:9px;font-weight:700;color:#fff;">${alias}</span>`;
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            const cartItem = params.data?.CartItem;
            if (!cartItem) return;
            this.consolidationTypePopupPosition = { top: event.clientY + 'px', left: event.clientX + 'px' };
            this.consolidationTypePopupCartItem = cartItem;
            this.consolidationTypePopupRowIndex = params.rowIndex;
            this.showConsolidationTypePopup = true;
          });
          return container;
        }
      };

      this.productsColumnDefs = [
        indexCol,
        statusCol,
        {
          headerName: 'Supplier',
          field: 'partnerName',
          editable: false,
          minWidth: 60,
          flex: 1,
          suppressMenu: true,
          valueGetter: (params: any) => params.data?.PartnerName ?? '',
          onCellDoubleClicked: (params: any) => {
            const rowNode = params.node;
            const rowData = rowNode?.data;
            this.ProductsClickedRow = rowData;
            this.ProductsClickedRowIndex = params.rowIndex;
            this.loadChainHistory();
          }
        },
        {
          headerName: 'Offer',
          field: 'offerRef',
          editable: false,
          minWidth: 72,
          flex: 1.2,
          suppressMenu: true,
          cellRenderer: (params: any) => {
            const refNum = params.data?.ReferenceNumber ?? '';
            const debatorPO = params.data?.DebatorPO ?? '';
            let html = `<div style="display: flex; flex-direction: column; line-height: 1.2;">`;
            html += `<span class="OfferRefLink" style="color: #1976d2; cursor: pointer; text-decoration: underline; font-size: 11px;">${refNum}</span>`;
            if (debatorPO) {
              html += `<span style="color: #f60; text-decoration: underline; font-size: 10px; cursor: pointer;">${debatorPO}</span>`;
            }
            html += `</div>`;
            return html;
          },
          onCellDoubleClicked: (params: any) => {
            const offerID = params.data?.OfferID;
            if (offerID) {
              this.GetOffer(offerID);
            }
          }
        },
        deliveryPrefCol,
        consolidationTypeCol,
        ...restColumns,
        saveColumn,
        deleteColumn
      ];

      this.productsDefaultColDef = {
        ...this.offerDefaultColDef,
        cellStyle: { fontSize: '10px' }
      };

      this.productsGridOptions = {
        rowHeight: 32,
        headerHeight: 32,
        enableRangeSelection: true,
        suppressClipboardApi: true,
        enableFillHandle: true,
        enableClipboard: true,
        suppressClipboardPaste: false,
        suppressLastEmptyLineOnPaste: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        stopEditingWhenCellsLoseFocus: true,
        singleClickEdit: false,
        undoRedoCellEditing: true,
        tooltipShowDelay: 0,
        tooltipHideDelay: 10000,
        enableBrowserTooltips: true,
        context: { componentParent: this },
        undoRedoCellEditingLimit: 20,
        domLayout: 'autoHeight',
        rowClassRules: {
          GridValid: (p: any) => {
            const isStock = p.data?.CartItem?.SelectedOffer?.IsStockOffer === true;
            const hasQty = p.data?.CartItem?.SelectedOffer?.StockQuantity > 0;
            const isNotMfgStock = p.data?.CartItem?.SelectedOffer?.IsManufacturerStockOffer !== true;
            return isStock && hasQty && isNotMfgStock;
          },
          GridAdminPriceEdit: (p: any) => p.data?.CartItem?.AdminPriceEdit === true,
          'reference-group-separator': (p: any) => {
            // ReferenceNumber is directly on row data (from GetOffersProductsFiltered mapping)
            const currentRef = p.data?.ReferenceNumber;
            const nextRowNode = p.api?.getDisplayedRowAtIndex(p.rowIndex + 1);
            const nextRef = nextRowNode?.data?.ReferenceNumber;
            // Add separator if there's a next row and ReferenceNumber differs
            return nextRowNode != null && currentRef != null && nextRef != null && currentRef !== nextRef;
          }
        },
        onGridReady: (params: any) => {
          this.productsGridApi = params.api;
          params.api.sizeColumnsToFit();
          // Inject header checkbox after grid is ready
          setTimeout(() => this.injectProductsHeaderCheckbox(), 100);
        },
        onCellEditingStarted: (event: any) => {
          const rowIndex = event.rowIndex;
          this.onCellEditingStarted(rowIndex, true);
        },
        onCellValueChanged: (event: any) => this.onProductsCellValueChanged(event),
        onRangeSelectionChanged: (event: any) => {
          if (event.finished) {
            const cellRanges = event.api.getCellRanges();
            if (cellRanges && cellRanges.length > 0) {
              const selectedRowIndices = new Set<number>();
              cellRanges.forEach((range: any) => {
                const startRow = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
                const endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
                for (let i = startRow; i <= endRow; i++) {
                  selectedRowIndices.add(i);
                }
              });
              // Only update IsSelected if more than 1 row is selected (actual multi-select)
              if (selectedRowIndices.size > 1) {
                selectedRowIndices.forEach((rowIndex: number) => {
                  const rowNode = event.api.getDisplayedRowAtIndex(rowIndex);
                  if (rowNode?.data?.CartItem) {
                    rowNode.data.CartItem.IsSelected = true;
                  }
                });
                event.api.refreshCells({ columns: ['index'], force: true });
              }
            }
          }
        },
        // ✅ Grid-level cell click: deselect all if clicking on an unselected row (not on checkbox)
        onCellClicked: (event: any) => {
          const target = event.event?.target as HTMLElement;
          // Don't interfere with checkbox clicks or button clicks
          if (target?.classList?.contains('cart-item-checkbox') ||
              target?.closest('button') ||
              target?.closest('.material-icons')) {
            return;
          }
          // If clicking on a row that is NOT selected, deselect all selected rows
          const clickedRowIsSelected = event.data?.CartItem?.IsSelected === true;
          if (!clickedRowIsSelected && this.hasSelectedCartItems()) {
            this.deselectAllProductItems();
          }
        },
        tabToNextCell: (params: any) => {
          const { previousCellPosition } = params;
          if (!previousCellPosition) return previousCellPosition;

          // If multiple rows are selected, suppress TAB navigation (stay on same row)
          const selectedItems = this.getSelectedProductItems();
          if (selectedItems.length > 1) {
            return previousCellPosition;
          }

          const rowIndex = previousCellPosition.rowIndex;
          const totalRows = params.api.getDisplayedRowCount();
          if (rowIndex >= totalRows - 1) return previousCellPosition;
          const nextRowNode = params.api.getDisplayedRowAtIndex(rowIndex + 1);
          if (!nextRowNode?.data?.CartItem) return previousCellPosition;
          return {
            rowIndex: rowIndex + 1,
            column: previousCellPosition.column,
            rowPinned: previousCellPosition.rowPinned
          };
        }
      };

    }

    countryID:number = null;
    Filter: {[k: string]: any} = {};
    MasterData: {[k: string]: any} = {};
    CurrentShippingAddress:any;
    activeFilters:{[k: string]: any} = [];
    Orders:{[k: string]: any} = [];
    Totals:{[k: string]: any} = [];
    searchTerm:string;
    Partners:any[];
    resultsLength:number = 0;
    partner:any;
    CurrentOrder:any;
    UserClientsSearchTerm:string;

    FromDate: FormControl;
    ToDate: FormControl;

    loadingOrders:boolean;
    showFilter:boolean;
    ShowExportBulkQuestion:boolean;
    AllSelected:boolean;
    ShowOrderCancelation:boolean;
    ShowOrderCopy:boolean;
    ShowEditContainer:boolean;

    // ✅ Discount Type dropdown state
    showDiscountTypeDropdown: boolean = false;

    // ✅ Payment Term dropdown state
    showPaymentTermDropdown: boolean = false;

    // ✅ Weight Type dropdown state
    showWeightTypeDropdown: boolean = false;

    // Custom dropdown states for filter container
    showStatusDropdown: boolean = false;
    showCurrencyDropdown: boolean = false;
    showUserManagerDropdown: boolean = false;
    showTranzactionTypeDropdown: boolean = false;

    // Country filter properties
    showCountryDropdown: boolean = false;
    countrySearchTerm: string = '';
    Countries: any[] = [];

    // Progress Status filter properties (for FilterContainer)
    showProgressStatusDropdown: boolean = false;

    SearchUserManager:string;
    UserManagers:any[];
    UserManagersLength:number = 0;
    UserManager:any;

    SearchUserUploader:string;
    UserClients:any[];
    UserClientsLength:number = 0;
    UserUploader:any;

    ShowOrderBillingInformation:boolean = false;
    ShowOrderShippingInformation:boolean = false;
    ShowOrderGeneralInformation:boolean = true;
    ShowOrderProductsInformation:boolean = true;

    // Shipping section dropdown states
    showShippingAddressDropdown: boolean = false;
    showShippingCountryDropdown: boolean = false;
    showShippingResponsabilityDropdown: boolean = false;
    showShippingServiceTypeDropdown: boolean = false;
    showShippingCompanyDropdown: boolean = false;

    // Shipping master data
    ShippingResponsabilities: any[] = [];
    ShippingServiceTypes: any[] = [];
    ShippingCompanies: any[] = [];

    // Tab state: true = Offers tab (default), false = Products tab
    showOffersTab: boolean = true;

    // Products tab data
    ProductItems: any[] = [];
    ProductsPager: any = { PageIndex: 1, PageSize: 50, TotalCount: 0, Pages: 0 };
    loadingProducts: boolean = false;
    productsGridApi: GridApi;

    // Products grid uses same column defs as offer grid - initialized in ngOnInit
    productsColumnDefs: ColDef[] = [];
    productsDefaultColDef: any = {};
    productsGridOptions: any = {};

    // Auto-save feature with 2-second delay
    AutoSave: boolean = true;
    OfferAutoSave: boolean = true;
    autoSaveDelay: number = 2.00;
    private readonly AUTO_SAVE_DELAY_KEY = 'purchaseOrders_autoSaveDelay';
    savingRow: boolean = false;
    savingGridRow: boolean = false; // Grid-specific saving indicator (minimalist spinner in pagination row)
    autoSaveTimer: any = null;
    autoSaveRowIndex: number = -1;
    autoSavePendingCartItem: any = null;
    autoSaveIsProductsGrid: boolean = true;
    autoSaveLastEditedColumn: string = '';

    // DeliveryPreference right-click popup
    showDeliveryPreferencePopup: boolean = false;
    deliveryPreferencePopupPosition: { top: string; left: string } = { top: '0px', left: '0px' };
    deliveryPreferencePopupCartItem: any = null;
    deliveryPreferencePopupRowIndex: number = -1;

    // ConsolidationType right-click popup
    showConsolidationTypePopup: boolean = false;
    consolidationTypePopupPosition: { top: string; left: string } = { top: '0px', left: '0px' };
    consolidationTypePopupCartItem: any = null;
    consolidationTypePopupRowIndex: number = -1;

    // DP/CT options
    deliveryPreferenceOptions = [
      { ID: -1, Name: 'Partial Delivery' },
      { ID: 1, Name: 'Full Delivery' }
    ];
    consolidationTypeOptions = [
      { ID: -1, Name: 'Consolidated' },
      { ID: 1, Name: 'Dispatch Immediately' }
    ];

    // IndexedDB Undo system - max 5 snapshots
    private undoDb: IDBDatabase | null = null;
    private readonly UNDO_DB_NAME = 'PurchaseOrdersUndoDB';
    private readonly UNDO_STORE_NAME = 'snapshots';
    private readonly MAX_UNDO_SNAPSHOTS = 5;
    undoSnapshotCount: number = 0;
    showSaveAfterUndo: boolean = false; // Show "Save All" button after undo to persist changes

    // Products grid popup state
    ShowProductsETAAlternatives: boolean = false;
    ShowProductsSupplierAlternatives: boolean = false;
    ShowProductsBrandCollateral: boolean = false;
    ProductsBrandCollateralList: any[] = [];
    ProductsSideOffers: any[] = [];
    ProductsClickedRow: any = null;
    ProductsClickedRowIndex: number = -1;
    ProductsBrandPopupPosition: any = {};
    ProductsSearchResultsPosition: any = {};
    ProductsSupplierPopupPosition: any = {};
    ProductsLoadingSideOffers: boolean = false;
    selectedProductsNamePopupTab: number = 1;
    ProductsSupplierPopupSearchTerm: string = '';

    // ✅ Chain History popup state
    ShowChainHistory: boolean = false;
    ChainHistoryLoading: boolean = false;
    ChainHistoryOrderChain: any[] = [];
    ChainHistoryItemChain: any[] = [];
    ProductsSupplierPopupSearchResults: any[] = [];

    // AG Grid for Offer Products
    offerGridApi: GridApi;
    offerColumnApi: ColumnApi;
    offerGridRowData: any[] = [];
    CartItemRows: any[] = [];

    // ✅ Excel Export Column Control - synced with ag-Grid column widths
    columnWidths: { [key: string]: number } = {};

    // ✅ Sync column widths from ag-Grid to ExcelExportControlRow
    syncColumnWidths(retryCount: number = 0): void {
      // Find the ag-grid element inside EditContainer
      const gridElement = document.querySelector('.EditContainer .ProductsAGGridContainer ag-grid-angular');
      if (!gridElement) {
        console.log('📏 ag-grid element not found, retry:', retryCount);
        if (retryCount < 20) {
          setTimeout(() => this.syncColumnWidths(retryCount + 1), 150);
        }
        return;
      }

      // Find all header cells - they can be nested in different containers
      const headerCells = gridElement.querySelectorAll('.ag-header-cell');
      if (!headerCells || headerCells.length === 0) {
        console.log('📏 No header cells found, retry:', retryCount);
        if (retryCount < 20) {
          setTimeout(() => this.syncColumnWidths(retryCount + 1), 150);
        }
        return;
      }

      const widths: { [key: string]: number } = {};
      headerCells.forEach((cell: Element) => {
        const colId = cell.getAttribute('col-id');
        const width = (cell as HTMLElement).offsetWidth;
        if (colId && width > 0) {
          widths[colId] = width;
        }
      });

      console.log('📏 Synced column widths from DOM:', widths, 'cell count:', headerCells.length);
      this.columnWidths = { ...widths };
      this.cdr.detectChanges();
    }

    // ✅ Get width style for ExcelExportControlRow cell
    getColumnWidth(field: string): { [key: string]: string } {
      const width = this.columnWidths[field];
      if (width) {
        return { 'width': width + 'px', 'min-width': width + 'px', 'max-width': width + 'px', 'flex': 'none' };
      }
      return {};
    }

    // ✅ Check if all export columns are selected
    get allExportColumnsSelected(): boolean {
      const pdf = this.CurrentOrder?.PDFColumns;
      if (!pdf) return false;
      return pdf.ListPrice && pdf.Discount && pdf.StandardDelivery && pdf.HSCode && pdf.COO && pdf.Weight;
    }

    // ✅ Toggle all export columns
    toggleAllExportColumns(checked: boolean): void {
      if (!this.CurrentOrder) return;
      if (!this.CurrentOrder.PDFColumns) {
        this.CurrentOrder.PDFColumns = { ID: 0, OrderDBID: 0, ListPrice: false, Discount: false, StandardDelivery: true, HSCode: true, COO: true, Weight: true };
      }
      this.CurrentOrder.PDFColumns.ListPrice = checked;
      this.CurrentOrder.PDFColumns.Discount = checked;
      this.CurrentOrder.PDFColumns.StandardDelivery = checked;
      this.CurrentOrder.PDFColumns.HSCode = checked;
      this.CurrentOrder.PDFColumns.COO = checked;
      this.CurrentOrder.PDFColumns.Weight = checked;
      this.savePDFColumns();
    }

    // ✅ Handle individual export column checkbox change
    onExportColumnChange(columnName: string, checked: boolean): void {
      if (!this.CurrentOrder) return;
      if (!this.CurrentOrder.PDFColumns) {
        this.CurrentOrder.PDFColumns = { ID: 0, OrderDBID: 0, ListPrice: false, Discount: false, StandardDelivery: true, HSCode: true, COO: true, Weight: true };
      }
      switch (columnName) {
        case 'ListPrice': this.CurrentOrder.PDFColumns.ListPrice = checked; break;
        case 'Discount': this.CurrentOrder.PDFColumns.Discount = checked; break;
        case 'ETA': this.CurrentOrder.PDFColumns.StandardDelivery = checked; break;
        case 'HSCode': this.CurrentOrder.PDFColumns.HSCode = checked; break;
        case 'COO': this.CurrentOrder.PDFColumns.COO = checked; break;
        case 'Weight': this.CurrentOrder.PDFColumns.Weight = checked; break;
      }
      this.savePDFColumns();
    }

    // ✅ Save PDFColumns to backend
    savePDFColumns(): void {
      if (!this.CurrentOrder?.DBID || !this.CurrentOrder?.PDFColumns) return;
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        OrderDBID: this.CurrentOrder.DBID,
        PDFColumns: this.CurrentOrder.PDFColumns,
        OrderType: 'PurchaseOrder'
      };
      this.managementService.UpdateOrderPDFColumns(request).subscribe((response: any) => {
        if (response.Status !== 1) {
          console.error('Failed to save PDF columns:', response.Message);
        }
      });
    }

    // ✅ Popup state variables (matching create-new-quotation)
    ShowSearchResultsAlternatives: boolean = false;
    ShowETAAlternatives: boolean = false;
    ShowSupplierAlternatives: boolean = false;
    ShowFallbackSelection: boolean = false;
    ShowBrandCollateral: boolean = false;
    ShowBrandCollateralNewProduct: boolean = false;
    ShowRedRowETAPopup: boolean = false;
    ShowWeightPopup: boolean = false;
    ShowRedRowEditPopup: boolean = false;
    ShowPartnerSearchPopup: boolean = false;
    ShowCOOSearchPopup: boolean = false;
    ShowDeleteCartItemConfirmation: boolean = false;
    DeleteCartItemParams: any = null;
    IsMultiDelete: boolean = false;
    IsMultiDeleteEditContainer: boolean = false;

    // Change Partner Confirmation
    ShowChangePartnerConfirmation: boolean = false;
    PendingPartnerChange: any = null;

    // Progress Status right-click popup
    showProgressStatusCellPopup: boolean = false;
    progressStatusPopupPosition: { top: string; left: string } = { top: '0px', left: '0px' };
    progressStatusPopupCartItem: any = null;
    progressStatusPopupRowIndex: number = -1;
    progressStatusPopupIsProductsGrid: boolean = false;

    SearchResultAlternatives: any[] = [];
    FallbackOffers: any[] = [];
    LeadTimeTypes: any[] = [];
    LeadTimeUnits: number[] = Array.from({ length: 31 }, (_, i) => i);
    SelectedLeadTimeType: any = null;
    SelectedLeadTimeUnits: number = 0;
    CurrentRedRowCartItem: any = null;
    CurrentRedRowIndex: number = -1;
    LeadTimeSmartInput: string = '';
    LeadTimeInlineSuggestion: string = '';
    LeadTimeSuggestions: any[] = [];

    // Position objects for popups
    SearchResultsPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };
    BrandPopupPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };
    SupplierPopupPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };
    COOPopupPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };

    ClickedRow: any;
    ClickedRowIndex: number;
    namePlaceholder: string = 'Search product or part number...';
    selectedNamePopupTab: number = 1;

    // Partner search popup
    PartnerSearchRowIndex: number = -1;
    PartnerSearchTerm: string = '';
    PartnerSearchResults: any[] = [];
    LoadingPartners: boolean = false;

    // COO search popup
    COOSearchRowIndex: number = -1;
    COOSearchTerm: string = '';
    COOSearchResults: any[] = [];

    // Loading states
    LoadingSideOffers: boolean = false;

    // ✅ Side offers for supplier alternatives popup
    SideOffers: any[] = [];
    OriginalSideOffers: any[] = [];
    SupplierPopupSearchTerm: string = '';
    SupplierPopupSearchResults: any[] = [];
    LoadingSupplierPopupSearch: boolean = false;

    // ✅ Brand collateral list
    BrandCollateralList: any[] = [];

    // ✅ Name column search properties
    private nameSearchSubject = new Subject<{ rowIndex: number; searchTerm: string; quantity: any }>();

    // ✅ Admin-specific column definitions (exact copy from create-new-quotation)
    // Track header checkbox state
    productsHeaderCheckboxSelected: boolean = false;
    offerHeaderCheckboxSelected: boolean = false;

    toggleAllProductsSelected(api: any) {
      console.log('🔄 ORDER-CONFIRMATIONS: toggleAllProductsSelected called');
      this.productsHeaderCheckboxSelected = !this.productsHeaderCheckboxSelected;
      console.log('   New state:', this.productsHeaderCheckboxSelected);

      let count = 0;
      api.forEachNode((node: any) => {
        if (node.data?.CartItem) {
          node.data.CartItem.IsSelected = this.productsHeaderCheckboxSelected;
          count++;
        }
      });
      console.log('   Updated', count, 'items');

      api.refreshCells({ columns: ['index'], force: true });
      // Update header checkbox
      this.updateHeaderCheckbox(api);
    }

    updateHeaderCheckbox(api: any) {
      const headerCheckbox = document.querySelector('.products-header-checkbox') as HTMLInputElement;
      console.log('🔍 ORDER-CONFIRMATIONS: updateHeaderCheckbox - found checkbox:', !!headerCheckbox);
      if (headerCheckbox) {
        headerCheckbox.checked = this.productsHeaderCheckboxSelected;
      }
    }

    /**
     * Inject the header checkbox into the products grid index column header
     */
    injectProductsHeaderCheckbox() {
      console.log('🔧 ORDER-CONFIRMATIONS: injectProductsHeaderCheckbox called');
      const headerCell = document.querySelector('.products-index-header');
      console.log('   Found header cell:', !!headerCell);

      if (headerCell) {
        // Try ag-header-cell-text first, fallback to ag-header-cell-comp-wrapper for empty headers
        let headerContent = headerCell.querySelector('.ag-header-cell-text') as HTMLElement;
        if (!headerContent) {
          headerContent = headerCell.querySelector('.ag-header-cell-comp-wrapper') as HTMLElement;
        }
        if (!headerContent) {
          // Fallback: use the header cell itself
          headerContent = headerCell as HTMLElement;
        }
        console.log('   Found header content:', !!headerContent);
        console.log('   Existing checkbox:', !!headerContent?.querySelector('.products-header-checkbox'));

        if (headerContent && !headerContent.querySelector('.products-header-checkbox')) {
          // Create checkbox element
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'products-header-checkbox';
          checkbox.checked = this.productsHeaderCheckboxSelected;
          checkbox.style.cursor = 'pointer';
          checkbox.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleAllProductsSelected(this.productsGridApi);
          });
          // Clear and append
          headerContent.innerHTML = '';
          headerContent.appendChild(checkbox);
          console.log('   ✅ Checkbox injected successfully');
        }
      } else {
        console.log('   ⚠️ Header cell not found - grid may not be ready');
      }
    }

    // ✅ Toggle all items in EditContainer grid
    toggleAllOfferSelected(api: any) {
      console.log('🔄 ORDER-CONFIRMATIONS: toggleAllOfferSelected called');
      this.offerHeaderCheckboxSelected = !this.offerHeaderCheckboxSelected;
      console.log('   New state:', this.offerHeaderCheckboxSelected);

      let count = 0;
      api.forEachNode((node: any) => {
        if (node.data?.CartItem) {
          node.data.CartItem.IsSelected = this.offerHeaderCheckboxSelected;
          count++;
        }
      });
      console.log('   Updated', count, 'items');

      api.refreshCells({ columns: ['index'], force: true });
      this.updateOfferHeaderCheckbox();
    }

    updateOfferHeaderCheckbox() {
      const headerCheckbox = document.querySelector('.offer-header-checkbox') as HTMLInputElement;
      console.log('🔍 ORDER-CONFIRMATIONS: updateOfferHeaderCheckbox - found checkbox:', !!headerCheckbox);
      if (headerCheckbox) {
        headerCheckbox.checked = this.offerHeaderCheckboxSelected;
      }
    }

    /**
     * Inject the header checkbox into the offer/EditContainer grid index column header
     */
    injectOfferHeaderCheckbox() {
      console.log('🔧 ORDER-CONFIRMATIONS: injectOfferHeaderCheckbox called');
      const headerCell = document.querySelector('.offer-index-header');
      console.log('   Found header cell:', !!headerCell);

      if (headerCell) {
        // Try ag-header-cell-text first, fallback to ag-header-cell-comp-wrapper for empty headers
        let headerContent = headerCell.querySelector('.ag-header-cell-text') as HTMLElement;
        if (!headerContent) {
          headerContent = headerCell.querySelector('.ag-header-cell-comp-wrapper') as HTMLElement;
        }
        if (!headerContent) {
          // Fallback: use the header cell itself
          headerContent = headerCell as HTMLElement;
        }
        console.log('   Found header content:', !!headerContent);
        console.log('   Existing checkbox:', !!headerContent?.querySelector('.offer-header-checkbox'));

        if (headerContent && !headerContent.querySelector('.offer-header-checkbox')) {
          // Create checkbox element
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'offer-header-checkbox';
          checkbox.checked = this.offerHeaderCheckboxSelected;
          checkbox.style.cursor = 'pointer';
          checkbox.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleAllOfferSelected(this.offerGridApi);
          });
          // Clear and append
          headerContent.innerHTML = '';
          headerContent.appendChild(checkbox);
          console.log('   ✅ Checkbox injected successfully');
        }
      } else {
        console.log('   ⚠️ Header cell not found - grid may not be ready');
      }
    }

    offerColumnDefs: ColDef[] = [
      {
        headerName: '',
        field: 'index',
        editable: false,
        minWidth: 45,
        maxWidth: 55,
        width: 50,
        suppressMenu: true,
        headerClass: 'offer-index-header',
        cellRenderer: (params: any) => {
          const rowIndex = params.rowIndex + 1;
          const isSelected = params.data?.CartItem?.IsSelected === true;
          return `<div style="display: flex; align-items: center; width: 100%; height: 100%; padding: 0 4px 0 0; margin-left: -8px;">
                    <input type="checkbox" ${isSelected ? 'checked' : ''} class="cart-item-checkbox" data-row="${params.rowIndex}" />
                    <span style="cursor: pointer; margin-left: auto;">${rowIndex}</span>
                  </div>`;
        },
        onCellClicked: (params: any) => {
          // Only toggle IsSelected when clicking directly on the checkbox
          const target = params.event?.target as HTMLElement;
          console.log('📋 ORDER-CONFIRMATIONS: Index cell clicked, target:', target?.className);

          if (target?.classList?.contains('cart-item-checkbox')) {
            const cartItem = params.data?.CartItem;
            console.log('   Checkbox clicked, cartItem exists:', !!cartItem);
            if (cartItem) {
              cartItem.IsSelected = !cartItem.IsSelected;
              console.log('   New IsSelected state:', cartItem.IsSelected);
              params.api.refreshCells({ rowNodes: [params.node], columns: ['index'], force: true });

              // Update header checkbox state
              this.updateOfferHeaderCheckbox();
            }
          }
        }
      },
      {
        headerName: 'S',
        field: 'progressStatus',
        editable: false,
        minWidth: 35,
        maxWidth: 40,
        width: 38,
        suppressMenu: true,
        headerClass: 'offer-status-header',
        cellStyle: (params: any) => {
          const statusId = params.data?.CartItem?.ProgressStatus?.ID;
          let backgroundColor = 'transparent';
          let color = '#333';

          // ePurchaseOrderStatus enum values:
          // New = 0, Processing = 1, Acknowledged = 2, PickupInitiated = 6, Shipping = 7, PartiallyShipping = 8, Completed = 10, Canceled = 11
          switch (statusId) {
            case 0: // New
              backgroundColor = '#bbdefb';
              color = '#1565c0';
              break;
            case 1: // Processing
              backgroundColor = '#ffe0b2';
              color = '#e65100';
              break;
            case 2: // Acknowledged
              backgroundColor = '#c8e6c9';
              color = '#2e7d32';
              break;
            case 6: // PickupInitiated
              backgroundColor = '#e1bee7';
              color = '#7b1fa2';
              break;
            case 7: // Shipping
              backgroundColor = '#d1c4e9';
              color = '#4527a0';
              break;
            case 8: // PartiallyShipping
              backgroundColor = '#fff9c4';
              color = '#f57f17';
              break;
            case 10: // Completed
              backgroundColor = '#b2dfdb';
              color = '#00695c';
              break;
            case 11: // Canceled
              backgroundColor = '#ffc2b3';
              color = '#c62828';
              break;
          }

          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0',
            backgroundColor: backgroundColor,
            color: color,
            cursor: 'pointer'
          };
        },
        cellRenderer: (params: any) => {
          const alias = params.data?.CartItem?.ProgressStatus?.Alias ?? '';
          // Create element with right-click handler
          const container = document.createElement('div');
          container.style.cssText = 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;';
          container.innerHTML = `<span style="font-size: 9px; font-weight: 600;">${alias}</span>`;

          // Add right-click (context menu) handler
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            const cartItem = params.data?.CartItem;
            if (!cartItem) return;

            // Set popup position near the click
            this.progressStatusPopupPosition = {
              top: (event.clientY) + 'px',
              left: (event.clientX) + 'px'
            };

            // Store clicked row info
            this.progressStatusPopupCartItem = cartItem;
            this.progressStatusPopupRowIndex = params.rowIndex;
            this.progressStatusPopupIsProductsGrid = false; // This is the offer grid

            // Show the popup
            this.showProgressStatusCellPopup = true;
          });

          return container;
        },
        onCellDoubleClicked: (params: any) => {
          this.handleProgressStatusDoubleClick(params, false);
        }
      },
      {
        headerName: 'Brand',
        field: 'brand',
        // ✅ Brand not editable - treat all rows as CartItemStatus.ID === 1
        editable: false,
        singleClickEdit: true,
        minWidth: 87,
        flex: 0.52,
        suppressMenu: true,
        // ✅ Always use BrandCellRenderer - treat all rows as CartItemStatus.ID === 1
        cellRenderer: (params: any) => this.BrandCellRenderer(params),
        cellClassRules: {}
      },
      {
        headerName: 'PartNumber',
        field: 'partNumber',
        editable: true,
        minWidth: 70,
        flex: 1,
        suppressMenu: true,
        valueGetter: (params: any) => {
          const partNumber = params.data?.CartItem?.Product?.PartNumber;
          return partNumber ?? '';
        },
        valueSetter: (params: any) => {
          if (!params.data.CartItem) {
            params.data.CartItem = {};
          }
          if (!params.data.CartItem.Product) {
            params.data.CartItem.Product = {};
          }
          params.data.CartItem.Product.PartNumber = params.newValue;
          return true;
        }
      },
      {
        headerName: 'Name',
        field: 'name',
        editable: true,
        minWidth: 200,
        flex: 18,
        suppressMenu: true,
        cellRenderer: this.NameCellRenderer.bind(this),
        cellClassRules: {}
      },
      {
        headerName: 'Qty',
        field: 'quantity',
        editable: true,
        singleClickEdit: false,
        type: 'numericColumn',
        valueParser: this.numberParser,
        minWidth: 40,
        maxWidth: 55,
        flex: 0.4,
        suppressMenu: true,
        cellRenderer: (params: any) => {
          const qty = params.value ?? '';
          const offer = params.data?.CartItem?.SelectedOffer;
          const hasMOQ = offer?.MOQ != null && offer.MOQ > 1;
          const style = hasMOQ ? 'color:#d32f2f;font-weight:700;' : '';
          const title = hasMOQ ? ` title="MOQ: ${offer.MOQ}"` : '';
          return `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;${style}"${title}>${qty}</div>`;
        }
      },
      {
        headerName: 'List-Price',
        field: 'officialListPrice',
        editable: true,
        singleClickEdit: true,
        minWidth: 60,
        flex: 2,
        suppressMenu: true,
        cellRenderer: (p: any) => this.officialListPriceCellRenderer(p),
        cellClass: 'listprice-cell'
      },
      {
        headerName: '%Discount',
        field: 'officialDiscount',
        editable: true,
        singleClickEdit: true,
        minWidth: 65,
        maxWidth: 85,
        flex: 0.6,
        suppressMenu: true,
        type: 'rightAligned',
        cellRenderer: (p: any) => this.officialDiscountCellRenderer(p)
      },
      {
        headerName: 'Purchase-Price',
        field: 'price',
        editable: true,
        singleClickEdit: true,
        minWidth: 60,
        flex: 2,
        suppressMenu: true,
        cellRenderer: this.priceCellRenderer.bind(this),
        cellClass: 'yourprice-cell',
        cellStyle: (params: any) => {
          const priceStatusID = params.data?.CartItem?.CartItemPriceStatus?.ID;
          if (priceStatusID === 1) {
            return { color: '#32aa3a' };
          } else if (priceStatusID === -1) {
            return { color: '#d32f2f', fontWeight: 'bold' };
          }
          return null;
        }
      },
      {
        headerName: 'SC',
        field: 'sellCurrency',
        editable: false,
        minWidth: 40,
        maxWidth: 50,
        flex: 0.4,
        suppressMenu: true,
        cellStyle: { cursor: 'pointer', textAlign: 'center' },
        valueGetter: (params: any) => {
          const selectedOffer = params.data?.CartItem?.SelectedOffer;
          if (!selectedOffer) return '';
          return selectedOffer.Currency?.Symbol || '';
        },
        onCellClicked: (params: any) => {
          // Open the sell currency change popup - preselect from clicked row's SelectedOffer.Currency
          const rowCurrency = params.data?.CartItem?.SelectedOffer?.Currency;
          this.selectedSellCurrency = rowCurrency || this.CurrentOrder?.Cart?.Currency || null;
          // Store OfferDBID from row data (Products tab) or from CurrentOrder (Edit container)
          this.selectedOfferDBIDForCurrency = params.data?.OfferDBID || this.CurrentOrder?.DBID || 0;
          this.ShowChangeSellCurrencyPopup = true;
        }
      },
      {
        headerName: 'Total',
        field: 'total',
        editable: false,
        minWidth: 60,
        flex: 2,
        suppressMenu: true,
        cellClass: 'yourprice-cell'
      },
      {
        headerName: 'Delivery',
        field: 'eta',
        editable: true,
        singleClickEdit: true,
        minWidth: 50,
        flex: 1.3,
        suppressMenu: true,
        cellRenderer: this.ETACellRenderer.bind(this)
      },

      {
        headerName: 'HSCode',
        field: 'hscode',
        editable: true,
        singleClickEdit: true,
        minWidth: 70,
        maxWidth: 90,
        flex: 0.6,
        suppressMenu: true,
        valueGetter: (params: any) => {
          const hsCode = params.data?.CartItem?.Product?.Stats?.HSCode;
          return hsCode ?? '';
        },
        valueSetter: (params: any) => {
          if (!params.data.CartItem) {
            params.data.CartItem = {};
          }
          if (!params.data.CartItem.Product) {
            params.data.CartItem.Product = {};
          }
          if (!params.data.CartItem.Product.Stats) {
            params.data.CartItem.Product.Stats = {};
          }
          params.data.CartItem.Product.Stats.HSCode = params.newValue;
          return true;
        }
      },
      {
        headerName: 'COO',
        field: 'coo',
        editable: true,
        singleClickEdit: true,
        minWidth: 50,
        maxWidth: 70,
        flex: 0.5,
        suppressMenu: true,
        cellRenderer: (params: any) => this.COOCellRenderer(params)
      },
      {
        headerName: 'Weight',
        field: 'weight',
        editable: true,
        singleClickEdit: true,
        minWidth: 64,
        maxWidth: 88,
        flex: 0.56,
        suppressMenu: true
      },
      {
        headerName: '',
        field: 'datasheet',
        minWidth: 35,
        maxWidth: 50,
        flex: 0.4,
        suppressMenu: true,
        sortable: false,
        editable: false,
        suppressSizeToFit: true,
        cellRenderer: (params: any) => {
          const rowIndex = params.rowIndex;
          return `<div style="display: flex; align-items: center; justify-content: center; height: 100%;">
                    <i class="material-icons delete-row-button"
                       data-row="${rowIndex}"
                       style="font-size: 18px; color: #f44336; cursor: pointer;"
                       title="Delete row">close</i>
                  </div>`;
        }
      },
      {
        headerName: '',
        field: 'save',
        minWidth: 20,
        maxWidth: 25,
        width: 22,
        suppressMenu: true,
        sortable: false,
        editable: false,
        suppressSizeToFit: true,
        cellStyle: { padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellRenderer: (params: any) => {
          const cartItem = params.data?.CartItem;
          if (!cartItem) {
            return '';
          }
          return `<i class="material-icons" style="font-size: 12px; color: #2196F3; cursor: pointer;" title="Double-click to save">save</i>`;
        },
        onCellDoubleClicked: (params: any) => {
          this.AddUpdatePurchaseOrderCartItem(params);
        }
      }
    ];

    offerDefaultColDef = {
      resizable: true,
      flex: 1,
      minWidth: 100,
      cellClass: (params: any) => {
        return params.colDef.field === 'name' ? 'cell-white' : 'cell-gray';
      }
    };

    offerGridOptions = {
      rowHeight: 30,
      headerHeight: 30,
      enableRangeSelection: true,
      suppressClipboardApi: true,
      enableFillHandle: true,
      enableClipboard: true,
      suppressClipboardPaste: false,
      suppressLastEmptyLineOnPaste: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      stopEditingWhenCellsLoseFocus: true,
      singleClickEdit: false,
      undoRedoCellEditing: true,
      tooltipShowDelay: 0,
      tooltipHideDelay: 10000,
      enableBrowserTooltips: true,
      context: {
        componentParent: this
      },
      undoRedoCellEditingLimit: 20,
      domLayout: 'autoHeight',
      rowClassRules: {
        GridValid: (p) => {
          const isStock = p.data?.CartItem?.SelectedOffer?.IsStockOffer === true;
          const hasQty = p.data?.CartItem?.SelectedOffer?.StockQuantity > 0;
          const isNotMfgStock = p.data?.CartItem?.SelectedOffer?.IsManufacturerStockOffer !== true;
          return isStock && hasQty && isNotMfgStock;
        },
        GridAdminPriceEdit: p => p.data?.CartItem?.AdminPriceEdit === true
      },
      onGridReady: (params: any) => {
        this.offerGridApi = params.api;
        params.api.sizeColumnsToFit();
        // ✅ Inject header checkbox after grid is ready
        setTimeout(() => this.injectOfferHeaderCheckbox(), 100);
      },
      onCellEditingStarted: (event: any) => {
        const rowIndex = event.rowIndex;
        const colId = event.column?.getColId();
        this.onCellEditingStarted(rowIndex, false, colId);
      },
      onCellValueChanged: (event: any) => this.onOfferCellValueChanged(event),
      // ✅ Simple tab navigation - treat all rows the same (as CartItemStatus.ID === 1)
      tabToNextCell: (params: any) => {
        const { previousCellPosition } = params;
        if (!previousCellPosition) {
          return previousCellPosition;
        }

        // If multiple rows are selected, suppress TAB navigation (stay on same row)
        const selectedItems = this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];
        if (selectedItems.length > 1) {
          return previousCellPosition;
        }

        const rowIndex = previousCellPosition.rowIndex;
        const totalRows = params.api.getDisplayedRowCount();
        if (rowIndex >= totalRows - 1) {
          return previousCellPosition;
        }
        const nextRowNode = params.api.getDisplayedRowAtIndex(rowIndex + 1);
        if (!nextRowNode || !nextRowNode.data || !nextRowNode.data.CartItem) {
          return previousCellPosition;
        }
        return {
          rowIndex: rowIndex + 1,
          column: previousCellPosition.column,
          rowPinned: previousCellPosition.rowPinned
        };
      }
    };

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";
    this.Filter.MainSearchTerm = "";

    // Default to last 6 months for performance optimization
    this.Filter.FromDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
    this.Filter.ToDate = moment().format('YYYY-MM-DD');
    this.FromDate = new FormControl(moment().subtract(6, 'months'));
    this.ToDate = new FormControl(moment());

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Partner = {};
    this.Filter.Partner = null;

    this.Filter.UserUploader = {};
    this.Filter.UserUploader = null;

    this.Filter.UserManager = {};
    this.Filter.UserManager = null;

    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.Country = {};
    this.Filter.Country = null;

    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.IndividualStatus = {};
    this.Filter.IndividualStatus = null;

    this.Filter.Status = {};
    this.Filter.Status = null;

    this.Filter.TranzactionType = {};
    this.Filter.TranzactionType = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.Supplier = {};
    this.Filter.Supplier = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    // Initialize brand filter
    this.InitializeBrandFilter();
    // Initialize supplier filter
    this.InitializeSupplierFilter();
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 10;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  GetBrandsFiltered(searchTerm: string, page = 1){
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
    this.loadingBrands = true;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.BrandFilter
    };

    this.managementService.GetBrandsFiltered(request).subscribe(response => {
      this.loadingBrands = false;
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Brands = response["Brands"];

        if(this.Brands.length == 1){
          this.selectBrandFilter(this.Brands[0]);
          this.Brands = [];
          this.BrandFilter.SearchTerm = "";
          this.brandSearchTerm = "";
        }
      }
    });
  }

  selectBrandFilter(brand: any){
    this.Filter.Brand = brand;
    this.brandSearchTerm = brand?.Name || '';
    this.showBrandDropdown = false;
    this.showBrandPopup = false;
    this.Brands = [];

    // Add to active filters
    this.AddActiveFilter(brand.Name, 'Brand');

    // Apply filter immediately - reload products grid
    this.parent.loading = true;
    this.GetProductsFiltered(1);
  }

  clearBrandFilter(){
    this.Filter.Brand = null;
    this.brandSearchTerm = '';
    this.Brands = [];
    this.showBrandDropdown = false;
    this.showBrandPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Brand');

    // Reload grid without brand filter
    this.parent.loading = true;
    this.GetProductsFiltered(1);
  }

  openBrandPopup(){
    this.showBrandPopup = true;
    this.brandSearchTerm = '';
    this.Brands = [];
  }

  onBrandDropdownFocus(){
    this.showBrandDropdown = true;
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("", 1);
    }
  }

  onBrandSearchInput(value: string){
    // Clear current brand selection when user types something different
    if (this.Filter.Brand && value !== this.Filter.Brand.Name) {
      this.Filter.Brand = null;
      this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Brand');
    }
    // Open dropdown and trigger search
    this.showBrandDropdown = true;
    this.brandSearchTermUpdate.next(value);
  }

  InitializeSupplierFilter(){
    this.SupplierFilter = {};
    this.SupplierFilter.SearchTerm = "";
    this.SupplierFilter.Pager = {};
    this.SupplierFilter.Pager.PageIndex = 1;
    this.SupplierFilter.Pager.PageSize = 10;
    this.SupplierFilter.Pager.TotalCount = 0;
  }

  GetSuppliersFiltered(searchTerm: string, page = 1){
    this.SupplierFilter.Pager.PageIndex = page;
    this.SupplierFilter.SearchTerm = searchTerm;
    this.loadingSuppliers = true;

    var request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: page,
      PageSize: 10,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.service.GetPartnersFiltered(request).subscribe((response: any) => {
      this.loadingSuppliers = false;
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Suppliers = response["Partners"];

        // Auto-select if only 1 result
        if(this.Suppliers.length == 1){
          this.selectSupplierFilter(this.Suppliers[0]);
        }
      }
    });
  }

  selectSupplierFilter(supplier: any){
    this.Filter.Supplier = supplier;
    this.supplierSearchTerm = supplier?.Name || '';
    this.showSupplierPopup = false;
    this.showSupplierDropdown = false;
    this.Suppliers = [];

    // Add to active filters
    this.AddActiveFilter(supplier.Name, 'Supplier');

    // Apply filter immediately - reload products grid
    this.parent.loading = true;
    this.GetProductsFiltered(1);
  }

  clearSupplierFilter(){
    this.Filter.Supplier = null;
    this.supplierSearchTerm = '';
    this.Suppliers = [];
    this.showSupplierPopup = false;
    this.showSupplierDropdown = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Supplier');

    // Reload grid without supplier filter
    this.parent.loading = true;
    this.GetProductsFiltered(1);
  }

  openSupplierPopup(){
    this.showSupplierPopup = true;
    this.supplierSearchTerm = '';
    this.Suppliers = [];
  }

  // ✅ Partner filter popup methods (header overlay)
  openPartnerPopup(){
    this.showPartnerPopup = true;
    this.partnerSearchTerm = '';
    this.Partners = [];
  }

  GetPartnersFilteredPopup(searchTerm: string){
    const request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: 1,
      PageSize: 50,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.loadingPartners = true;
    this.service.GetPartnersFiltered(request).subscribe((response: any) => {
      this.loadingPartners = false;
      if(response["Status"] == 1){
        this.Partners = response["Partners"];
        // Auto-select if only 1 result
        if(this.Partners.length == 1){
          this.selectPartnerFilter(this.Partners[0]);
        }
      }
    });
  }

  selectPartnerFilter(partner: any){
    this.Filter.Partner = partner;
    this.partnerSearchTerm = partner?.Name || '';
    this.searchTerm = partner?.Name || '';
    this.partner = partner;
    this.showPartnerPopup = false;
    this.Partners = [];

    // Add to active filters
    this.AddActiveFilter(partner.Name, 'Partner');

    // Apply filter immediately - reload products grid
    this.parent.loading = true;
    this.GetProductsFiltered(1);
  }

  clearPartnerFilter(){
    this.Filter.Partner = null;
    this.partnerSearchTerm = '';
    this.searchTerm = '';
    this.partner = null;
    this.Partners = [];
    this.showPartnerPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Partner');

    // Reload grid without partner filter
    this.parent.loading = true;
    this.GetProductsFiltered(1);
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type != "Period");
  }

  GetOfferMasterData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.managementService.GetPurchaseOrderMasterData(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.MasterData = response;
        // Load data based on which tab is active
        if (this.showOffersTab) {
          this.GetOrdersFiltered(1);
        } else {
          this.GetProductsFiltered(1);
        }
      }

      this.parent.loading = false;
     });
  }

  // ✅ Select discount type for current order
  selectDiscountType(type: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    if (!this.CurrentOrder.Cart.Total) this.CurrentOrder.Cart.Total = {};
    if (!this.CurrentOrder.Cart.Total.Discount) {
      this.CurrentOrder.Cart.Total.Discount = { Type: null, Value: null };
    }
    this.CurrentOrder.Cart.Total.Discount.Type = type;
    this.showDiscountTypeDropdown = false;
  }

  // ✅ Select payment term for current order
  selectPaymentTerm(term: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.PaymentTerm = term;
    this.showPaymentTermDropdown = false;
  }

  // ✅ Select weight type for current order
  selectWeightType(wt: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.WeightMeasurementType = wt;
    this.showWeightTypeDropdown = false;
  }

  // ✅ Handle weight input change - set ForcedUIWeight flag
  onWeightChange(value: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};

    // If empty/null/undefined/0, set weight to 0 and ForcedUIWeight to false
    if (value === null || value === undefined || value === '' || value === 0) {
      this.CurrentOrder.Cart.Weight = 0;
      this.CurrentOrder.Cart.ForcedUIWeight = false;
    } else {
      // User entered a non-zero value, set ForcedUIWeight to true
      this.CurrentOrder.Cart.ForcedUIWeight = true;
    }
  }

  // ✅ Validate decimal input - only allow numbers, comma and dot
  validateDecimalInput(event: KeyboardEvent): boolean {
    const charCode = event.key;
    // Allow: numbers (0-9), comma (,) and dot (.)
    if (/^[0-9,.]$/.test(charCode)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  // ✅ Validate discount input - only allow numbers and comma
  validateDiscountInput(event: KeyboardEvent): boolean {
    const charCode = event.key;
    // Allow: numbers (0-9) and comma (,)
    if (/^[0-9,]$/.test(charCode)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  // ✅ Apply order discount - calls backend to recalculate Total with discount
  ApplyOrderDiscount(): void {
    if (!this.CurrentOrder?.Cart?.Total?.Discount?.Type || !this.CurrentOrder?.Cart?.Total?.Discount?.Value) {
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PurchaseOrder: JSON.parse(JSON.stringify(this.CurrentOrder))
    };

    this.parent.loading = true;

    this.managementService.ApplyPurchaseOrderDiscount(request).subscribe((response: any) => {
      if (response?.Status !== 1) {
        this.parent.openSnackBar(response?.Message || 'Error applying discount', 'OK', 'alert-info-snackbar');
      } else if (response?.Status === 1) {
        // Update CurrentOrder with the returned PurchaseOrder (which has updated Total)
        this.CurrentOrder = response.PurchaseOrder;
        // Update the corresponding order in the Orders list
        this.updateOrderInList(response.PurchaseOrder);
        this.parent.openSnackBar(response?.Message || 'Discount applied successfully', 'OK', 'light-info-snackbar');
      }
      this.parent.loading = false;
    });
  }

  // ✅ Clear order discount - nulls the discount and calls backend to recalculate Total
  ClearOrderDiscount(): void {
    // Create a copy with null Cart.Total.Discount to clear it
    const orderCopy = JSON.parse(JSON.stringify(this.CurrentOrder));
    if (orderCopy?.Cart?.Total) {
      orderCopy.Cart.Total.Discount = null;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PurchaseOrder: orderCopy
    };

    this.parent.loading = true;

    this.managementService.ApplyPurchaseOrderDiscount(request).subscribe((response: any) => {
      if (response?.Status !== 1) {
        this.parent.openSnackBar(response?.Message || 'Error clearing discount', 'OK', 'alert-info-snackbar');
      } else if (response?.Status === 1) {
        // Update CurrentOrder with the returned PurchaseOrder (which has updated Total without discount)
        this.CurrentOrder = response.PurchaseOrder;
        // Reset local discount fields
        if (this.CurrentOrder?.Cart?.Total) {
          this.CurrentOrder.Cart.Total.Discount = { Type: null, Value: null };
        }
        // Update the corresponding order in the Orders list
        this.updateOrderInList(response.PurchaseOrder);
        this.parent.openSnackBar('Discount cleared successfully', 'OK', 'light-info-snackbar');
      }
      this.parent.loading = false;
    });
  }

  // ✅ Update an order in the Orders list after discount changes
  updateOrderInList(updatedOrder: any): void {
    if (!updatedOrder?.DBID || !this.Orders) return;
    const index = this.Orders.findIndex((o: any) => o.DBID === updatedOrder.DBID);
    if (index !== -1) {
      this.Orders[index] = updatedOrder;
    }
  }

  // ✅ Get Shipping Master Data (responsabilities, service types)
  GetShippingMasterData() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage()
    };

    this.managementService.GetShippingMasterData(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.ShippingResponsabilities = response["ShippingResponsabilities"] || [];
        this.ShippingServiceTypes = response["ShippingServiceTypes"] || [];

        // ✅ Match ShippingResponsability ID with full object from master data
        if (this.CurrentOrder?.Cart?.ShippingResponsability?.ID !== undefined) {
          const matchedResp = this.ShippingResponsabilities.find(r => r.ID === this.CurrentOrder.Cart.ShippingResponsability.ID);
          if (matchedResp) {
            this.CurrentOrder.Cart.ShippingResponsability = JSON.parse(JSON.stringify(matchedResp));
          }
        }

        // ✅ Match ShippingServiceType ID with full object from master data
        if (this.CurrentOrder?.Cart?.ShippingServiceType?.ID !== undefined) {
          const matchedType = this.ShippingServiceTypes.find(t => t.ID === this.CurrentOrder.Cart.ShippingServiceType.ID);
          if (matchedType) {
            this.CurrentOrder.Cart.ShippingServiceType = JSON.parse(JSON.stringify(matchedType));
          }
        }

        // ✅ Get country-specific shipping companies based on shipping address
        this.GetCountryShippingOptions();
      }
    });
  }

  // ✅ Get Country-specific Shipping Options (shipping companies available for the destination country)
  GetCountryShippingOptions(): void {
    const country = this.CurrentOrder?.ShippingAddress?.Country || this.CurrentOrder?.Cart?.Partner?.BillingAddress?.Country;

    if (!country?.ID) {
      console.log('❌ No country available for shipping options');
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Country: country,
      PartnerID: this.CurrentOrder?.Cart?.Partner?.ID,
      DirectionID: 1 // export (sending to customer)
    };

    this.managementService.GetCountryShippingOptions(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.ShippingCompanies = response["ShippingCompanies"] || [];
        console.log('✅ Country Shipping Options loaded:', this.ShippingCompanies);

        // ✅ Match ShippingCompany ID with full object from country options
        if (this.CurrentOrder?.Cart?.ShippingCompany?.ID) {
          const matchedCompany = this.ShippingCompanies.find(c => c.ID === this.CurrentOrder.Cart.ShippingCompany.ID);
          if (matchedCompany) {
            this.CurrentOrder.Cart.ShippingCompany = JSON.parse(JSON.stringify(matchedCompany));
          }
        }
      }
    });
  }

  // ✅ Shipping section select methods
  selectShippingAddress(addr: any) {
    const previousCountryID = this.CurrentOrder?.ShippingAddress?.Country?.ID;
    this.CurrentOrder.ShippingAddress = JSON.parse(JSON.stringify(addr));
    this.showShippingAddressDropdown = false;

    // ✅ Refresh shipping companies if country changed
    if (addr?.Country?.ID && addr.Country.ID !== previousCountryID) {
      this.GetCountryShippingOptions();
    }
  }

  selectShippingCountry(c: any) {
    const previousCountryID = this.CurrentOrder?.ShippingAddress?.Country?.ID;
    this.CurrentOrder.ShippingAddress.Country = JSON.parse(JSON.stringify(c));
    this.showShippingCountryDropdown = false;

    // ✅ Refresh shipping companies if country changed
    if (c?.ID && c.ID !== previousCountryID) {
      this.GetCountryShippingOptions();
    }
  }

  selectShippingResponsability(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingResponsability = JSON.parse(JSON.stringify(item));
    this.showShippingResponsabilityDropdown = false;
  }

  selectShippingServiceType(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingServiceType = JSON.parse(JSON.stringify(item));
    this.showShippingServiceTypeDropdown = false;
  }

  selectShippingCompany(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingCompany = JSON.parse(JSON.stringify(item));
    this.showShippingCompanyDropdown = false;
  }

  ResetMainSearch(){
    this.searchMainOrders.next(null);
    this.Filter.SearchTerm = "";
  }

  // ✅ Helper method to apply filters based on active tab
  applyFilter(page = 1) {
    if (this.showOffersTab) {
      this.GetOrdersFiltered(page);
    } else {
      this.GetProductsFiltered(page);
    }
  }

  GetOrdersFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.loadingOrders = true;
    this.showFilter = false;

    this.managementService.GetPurchaseOrdersFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Orders = response["PurchaseOrders"];
        this.Totals = response["Totals"];
        // Pager with TotalCount is now returned from the main query
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));

        // Debug: Check if Total data is present
        if(this.Orders?.length > 0){
          console.log('📊 PURCHASE-ORDERS: Sample order total structure:', this.Orders[0]?.Cart?.Total);
        }
      }

      this.LoadingMainSearchTerm = false;
      this.loadingOrders = false;
    });

    // No need for separate COUNT call - it's included in the main response now
  }

  GetOrdersFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.managementService.GetPurchaseOrdersFilteredCOUNT(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }

    });
  }

  GetProductsFiltered(page = 1){
    this.Filter.Pager.PageIndex = page;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.loadingProducts = true;
    this.showFilter = false;

    this.managementService.GetPurchaseOrdersProductsFiltered(request).subscribe(response => {
      console.log('📥 PURCHASE-ORDERS: GetProductsFiltered response Status:', response["Status"]);
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        // Format items for AG Grid - response.CartItems is now List<CartItem> directly
        const items = response["CartItems"] || [];
        console.log('   CartItems count:', items.length);
        this.ProductItems = items.map((cartItem: any, index: number) => {
          const leadTime = cartItem?.SelectedOffer?.LeadTime;
          const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

          return {
            index: index + 1,
            brand: cartItem?.Product?.Brand?.Name || cartItem?.UserSelectedBrand?.Name || '',
            partNumber: cartItem?.Product?.PartNumber || '',
            name: cartItem?.UIProductValue || cartItem?.Product?.Name || '',
            quantity: cartItem?.Quantity || 0,
            officialListPrice: cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice || '',
            officialDiscount: cartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value || '',
            price: cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || '',
            total: cartItem?.Price?.UIQtyPrice ? `${cartItem.Price.UIQtyPrice}` : '',
            eta: etaDisplay,
            supplier: cartItem?.SelectedOffer?.Partner?.Name || '',
            purchase: cartItem?.SelectedOffer?.ListPrice || '',
            hscode: cartItem?.Product?.Stats?.HSCode || '',
            coo: cartItem?.Product?.Stats?.COO?.ShortName || '',
            weight: cartItem?.Product?.Stats?.Weight != null
              ? `${cartItem.Product.Stats.Weight} ${cartItem.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
              : '',
            CartItem: cartItem, // Keep reference to original CartItem
            // Extra offer context columns from CartItemOrderInfo
            OfferID: cartItem?.CartItemOrderInfo?.OrderID || '',
            OfferDBID: cartItem?.CartItemOrderInfo?.OrderDBID || 0,
            ReferenceNumber: cartItem?.CartItemOrderInfo?.ReferenceNumber || '',
            DebatorPO: cartItem?.CartItemOrderInfo?.DebatorPO || '',
            PartnerName: cartItem?.CartItemOrderInfo?.OrderPartner?.Name || '',
            OfferEventRegister: cartItem?.CartItemOrderInfo?.OrderEventRegister || null
          };
        });

        console.log('   ProductItems length:', this.ProductItems.length);

        this.ProductsPager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));

        // Resize grid columns and re-inject header checkbox
        if (this.productsGridApi) {
          console.log('   Resizing grid and injecting header checkbox');
          setTimeout(() => {
            this.productsGridApi.sizeColumnsToFit();
            this.injectProductsHeaderCheckbox();
          }, 100);
        } else {
          console.log('   ⚠️ productsGridApi not available');
        }

        // ✅ Save undo snapshot on page load / page change / page size change
        this.saveUndoSnapshot();
      }

      this.LoadingMainSearchTerm = false;
      this.loadingProducts = false;
      this.parent.loading = false;
    });
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };

    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.applyFilter();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "Status"){
      this.Filter.IndividualStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
      this.Filter.SearchTerm = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }
    else if(filterType == "InvoiceDocType"){
      this.Filter.InvoiceDocType = null;
    }
    else if(filterType == "UserManager"){
      this.Filter.UserManager = null;
    }
    else if(filterType == "UserUploader"){
      this.Filter.UserUploader = null;
    }
    else if(filterType == "Brand"){
      this.Filter.Brand = null;
      this.brandSearchTerm = '';
    }
    else if(filterType == "Supplier"){
      this.Filter.Supplier = null;
      this.supplierSearchTerm = '';
    }

    this.applyFilter();
  }

  // ✅ Custom Dropdown Methods for Filter Container
  closeAllFilterDropdowns() {
    this.showStatusDropdown = false;
    this.showCurrencyDropdown = false;
    this.showUserManagerDropdown = false;
    this.showBrandDropdown = false;
    this.showSupplierDropdown = false;
    this.showPartnerPopup = false;
    this.showTranzactionTypeDropdown = false;
    this.showCountryDropdown = false;
    this.showProgressStatusDropdown = false;
  }

  onStatusDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showStatusDropdown = true;
  }

  selectStatusFilter(status: any) {
    this.Filter.IndividualStatus = status;
    this.AddActiveFilter(status.Name, 'Status');
    this.showStatusDropdown = false;
  }

  onCurrencyDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showCurrencyDropdown = true;
  }

  selectCurrencyFilter(currency: any) {
    this.Filter.Currency = currency;
    this.AddActiveFilter(currency.Name, 'Currency');
    this.showCurrencyDropdown = false;
  }

  onUserManagerDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showUserManagerDropdown = true;
  }

  selectUserManagerFilter(userManager: any) {
    this.Filter.UserManager = userManager;
    this.AddActiveFilter(userManager.Email, 'UserManager');
    this.showUserManagerDropdown = false;
  }

  onSupplierDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showSupplierDropdown = true;
    if (this.Suppliers == null || this.Suppliers.length == 0) {
      this.GetSuppliersFiltered('', 1);
    }
  }

  onSupplierSearchInput(value: string) {
    // Clear current supplier selection when user types something different
    if (this.Filter.Supplier && value !== this.Filter.Supplier.Name) {
      this.Filter.Supplier = null;
      this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Supplier');
    }
    // Open dropdown and trigger search
    this.showSupplierDropdown = true;
    this.searchSupplierUpdate.next(value);
  }

  onTranzactionTypeDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showTranzactionTypeDropdown = true;
  }

  selectTranzactionTypeFilter(tranzactionType: any) {
    this.Filter.TranzactionType = tranzactionType;
    this.AddActiveFilter(tranzactionType.Name, 'TranzactionType');
    this.showTranzactionTypeDropdown = false;
  }

  // ✅ Country filter handlers
  onCountryDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showCountryDropdown = true;
    // Filter countries from MasterData if available
    if (!this.Countries || this.Countries.length === 0) {
      this.GetCountriesFiltered('');
    }
  }

  selectCountryFilter(country: any) {
    this.Filter.Country = country;
    this.countrySearchTerm = country?.Name || '';
    this.showCountryDropdown = false;
    this.Countries = [];
    this.AddActiveFilter(country.Name, 'Country');
  }

  onCountrySearchInput(searchTerm: string) {
    if (searchTerm?.length >= 1) {
      this.GetCountriesFiltered(searchTerm);
    } else {
      this.GetCountriesFiltered('');
    }
  }

  clearCountryFilter() {
    this.Filter.Country = null;
    this.countrySearchTerm = '';
    this.Countries = [];
    this.showCountryDropdown = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Country');
  }

  GetCountriesFiltered(searchTerm: string) {
    // Filter from MasterData.Countries if available
    if (this.MasterData?.Countries?.length > 0) {
      if (searchTerm && searchTerm.length > 0) {
        this.Countries = this.MasterData.Countries.filter((x: any) =>
          x.Name?.toLowerCase().startsWith(searchTerm.toLowerCase())
        );
      } else {
        this.Countries = [...this.MasterData.Countries];
      }
    } else if (this.parent?.masterData?.Countries?.length > 0) {
      // Fallback to parent.masterData.Countries
      if (searchTerm && searchTerm.length > 0) {
        this.Countries = this.parent.masterData.Countries.filter((x: any) =>
          x.Name?.toLowerCase().startsWith(searchTerm.toLowerCase())
        );
      } else {
        this.Countries = [...this.parent.masterData.Countries];
      }
    }
  }

  // ✅ Progress Status filter handlers (for FilterContainer dropdown)
  onProgressStatusDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showProgressStatusDropdown = true;
  }

  selectProgressStatusFilter(status: any) {
    this.Filter.CartItemProgressStatus = status;
    this.showProgressStatusDropdown = false;
    this.AddActiveFilter(status.Name, 'ProgressStatus');
  }

  AnyChecked:boolean;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Orders.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  SelectAll(){
    this.Orders.forEach(r => {
      r.IsSelected = this.AllSelected;
    });

    this.CheckIfAnyChecked();
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }

        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:50,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];

         if(this.Partners.length == 1){
          this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
          this.applyFilter(1);
         }
        }

        this.parent.loading = false;
      });
    }
  }

  InitializeUserManagersOnClick(searchTerm:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:searchTerm,
    };

    if((searchTerm.length >= 3) && (this.UserManagers == null || this.UserManagers.length == 0)){
      this.parent.loading = true;

      this.service.GetUsersFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.UserManagers = response["Users"];
          this.UserManagersLength = this.UserManagers.length;
        }

        this.parent.loading = false;
      });
    }
    else{
      this.UserManagers = [];
      this.UserManagersLength = 0;
    }
  }

  GetUserManagersFiltered(s:string){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
    };

    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {

      if(response["Status"] != 1){

      }
      else if(response["Status"] == 1){
        this.UserManagers = response["Users"];
        this.UserManagersLength = this.UserManagers.length;
      }

      this.parent.loading = false;
    });

  }

  InitializeUserClientsOnClick(searchTerm:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:searchTerm,
    };

    if((searchTerm.length >= 3) && (this.UserClients == null || this.UserClients.length == 0)){
      this.parent.loading = true;

      this.B2BService.GetB2BUserClients(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.UserClients = response["Users"];
          this.UserClientsLength = this.UserClients.length;
        }

        this.parent.loading = false;
      });
    }
    else{
      this.UserClients = [];
      this.UserClientsLength = 0;
    }
  }

  GetUserClientsFiltered(s:string){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
    };

    this.parent.loading = true;

    this.B2BService.GetB2BUserClients(request).subscribe(response => {

      if(response["Status"] != 1){

      }
      else if(response["Status"] == 1){
        this.UserClients = response["Users"];
        this.UserClientsLength = this.UserClients.length;
      }

      this.parent.loading = false;
    });

  }

  ClearUserClients(){
    this.Filter.UserUploader = null;
    this.UserClientsSearchTerm = null;
    this.UserClients = [];
    this.UserClientsLength = 0;
   }

  // ✅ Toggle PO status dropdown for a specific order
  togglePOStatusDropdown(o: any, event: Event): void {
    event.stopPropagation();
    // Close all other dropdowns first
    this.Orders.forEach((order: any) => {
      if (order.DBID !== o.DBID) {
        order.showStatusDropdown = false;
      }
    });
    o.showStatusDropdown = !o.showStatusDropdown;
  }

  // ✅ Handle PO status change from dropdown
  OnPOStatusChange(o: any, newStatus: any): void {
    // Close dropdown
    o.showStatusDropdown = false;

    // Skip if same status selected
    if (newStatus.ID === o.POStatus?.ID) {
      return;
    }

    // For cancellation (status ID = 11), show confirmation popup
    if (newStatus.ID === 11) {
      this.OpenOrderCancelation(o);
      return;
    }

    // For all other status changes, call ChangePurchaseOrderStatus directly
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ID: o.ID,
      DBID: o.DBID,
      PurchaseOrderStatus: {
        ID: newStatus.ID,
      }
    };

    this.parent.loading = true;

    this.managementService.ChangePurchaseOrderStatus(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        o.POStatus = JSON.parse(JSON.stringify(response["PurchaseOrderStatus"]));
        this.parent.openSnackBar(response["Message"] || 'Status updated', "OK", "light-info-snackbar");
      }
      this.parent.loading = false;
    });
  }

  OpenOrderCancelation(o:any){
    this.CurrentOrder = JSON.parse(JSON.stringify(o));
    this.ShowOrderCancelation = true;
  }

  CancelOrder(o:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DBID:o.DBID,
    };

    this.parent.loading = true;

    this.managementService.CancelPurchaseOrder(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Orders.forEach(order => {
          if(order.DBID == o.DBID){
            order.ProcessingStatus = response["ProcessingStatus"];
            order.OfferStatus = response["OfferStatus"];
          }
        });
      }

      this.parent.loading = false;
    });
  }

  OpenCopyOrder(o:any){
    this.CurrentOrder = JSON.parse(JSON.stringify(o));
    this.ShowOrderCopy = true;
  }

  CopyOrder(o:any){
    this.GetOffer(o.ID);
  }

  GetOffer(OfferID:string){
    console.log('📥 PURCHASE-ORDERS: GetOffer called with ID:', OfferID);

    var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    PurchaseOrderID:OfferID,
    GetCartItems:true,
    WithLogs:true,
  };

  this.parent.loading = true;

  this.managementService.GetPurchaseOrder(request).subscribe(response => {
    console.log('📥 PURCHASE-ORDERS: GetPurchaseOrder response Status:', response["Status"]);

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentOrder = response["PurchaseOrder"];
      console.log('   CurrentOrder set:', !!this.CurrentOrder);
      console.log('   Cart.Items count:', this.CurrentOrder?.Cart?.Items?.length);

      // ✅ Initialize ShippingCost if not present
      if (!this.CurrentOrder.Cart) {
        this.CurrentOrder.Cart = {};
      }
      if (!this.CurrentOrder.Cart.ShippingCost) {
        this.CurrentOrder.Cart.ShippingCost = { UIUnitPrice: null };
      }

      // ✅ Initialize PDFColumns if not present (with correct defaults)
      if (!this.CurrentOrder.PDFColumns) {
        this.CurrentOrder.PDFColumns = {
          ID: 0,
          OrderDBID: this.CurrentOrder.DBID || 0,
          ListPrice: false,
          Discount: false,
          StandardDelivery: true,
          HSCode: true,
          COO: true,
          Weight: true
        };
      }

      // ✅ Initialize Discount if not present
      if (!this.CurrentOrder.Discount) {
        this.CurrentOrder.Discount = { Type: null, Value: null };
      }

      // ✅ Collapse all sections, show only Products section
      this.ShowOrderBillingInformation = false;
      this.ShowOrderShippingInformation = false;
      this.ShowOrderGeneralInformation = true;
      this.ShowOrderProductsInformation = true;

      this.ShowEditContainer = true;
      console.log('   ShowEditContainer:', this.ShowEditContainer);

      // Load AG Grid data
      setTimeout(() => {
        this.loadOfferGridData();
      }, 100);

      // ✅ Reload shipping master data to match IDs with full objects
      this.GetShippingMasterData();
    }

    this.parent.loading = false;
  });

  }

  PrintOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
    };

    this.parent.loading = true;

    this.managementService.ExportPurchaseOrder(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.parent.loading = false;
    });
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  ExportOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
    };

    this.parent.loading = true;

    this.managementService.ExportPurchaseOrder(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.parent.loading = false;
    });
  }


  ExportOrderExcel(o:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
    };
    this.parent.loading = true;
    this.managementService.ExportPurchaseOrderExcel(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if(response["Status"] == 1){
        var Document = response["Document"];
        this.downloadExcel(Document.Name, Document.PDFStream);
      }
      this.parent.loading = false;
    });
  }

  downloadExcel(filename:string, base64:string) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

  var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

  var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
  newWindow.document.write(htmlPop);
  };

  ShowAllProductsDetails:boolean = false;

  ShowAllProductsDetailsFunction(e:boolean){
    this.ShowAllProductsDetails = e;
    this.CurrentOrder.Cart.Items.forEach(element => {
      element.Product.ShowDetails = e;
    });
  }

  AwknowledgeOrder(o:any){
    if(o.ProcessingStatus?.ID == 0){
      this.ChangeOrderStatus(o);
    }
  }

  ChangeOrderStatus(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DBID:o.DBID,
      ProcessingStatus:this.MasterData.OrderStatuses.filter(x => x.ID == 1)[0],
      Type:o.Type,
      ID:o.ID,
    };

    this.parent.loading = true;

    this.managementService.ChangeOrderStatus(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        o.ProcessingStatus = response["ProcessingStatus"];
      }

      this.parent.loading = false;
    });
  }

  AskClientStatusNotificationEmail:boolean;

  AddNewOffer(){
    if(this.parent.loading != true){

     console.log('📦 [PO-AddNewOffer] ====== SAVE BUTTON CLICKED ======');
     console.log('📦 [PO-AddNewOffer] Items BEFORE sync:', this.CurrentOrder?.Cart?.Items?.map((item: any, i: number) => ({
       idx: i, ID: item?.ID, PartNumber: item?.Product?.PartNumber, Qty: item?.Quantity,
       SellingPrice: item?.SelectedOffer?.SellingPrice, PriceUI: item?.Price?.UIUnitPrice
     })));

     // ✅ Sync CurrentOrder.Cart.Items from AG Grid to ensure all edits are captured
     this.syncGridItemsToCurrentOrder();

     console.log('📦 [PO-AddNewOffer] Items AFTER sync:', this.CurrentOrder?.Cart?.Items?.map((item: any, i: number) => ({
       idx: i, ID: item?.ID, PartNumber: item?.Product?.PartNumber, Qty: item?.Quantity,
       SellingPrice: item?.SelectedOffer?.SellingPrice, PriceUI: item?.Price?.UIUnitPrice
     })));

     // ✅ Filter out empty rows
     const offerToSave = JSON.parse(JSON.stringify(this.CurrentOrder));
     if (offerToSave?.Cart?.Items) {
       const beforeFilter = offerToSave.Cart.Items.length;
       offerToSave.Cart.Items = offerToSave.Cart.Items.filter((item: any) => {
         const hasValidStatus = item?.CartItemStatus?.ID === 1;
         const hasValidQuantity = item?.Quantity != null && item?.Quantity > 0;
         return hasValidStatus || hasValidQuantity;
       });
       console.log(`📦 [PO-AddNewOffer] Filtered: ${beforeFilter} → ${offerToSave.Cart.Items.length}`);
     }

     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       PurchaseOrder:offerToSave,
       SendEmail:this.sendEmailOnConvert
     };

     this.parent.loading = true;

     this.managementService.AddNewPurchaseOrder(request).subscribe(response => {

       if(response["Status"] != 1){
         console.error('❌ [PO-AddNewOffer] FAILED:', response["Message"]);
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
        console.log('✅ [PO-AddNewOffer] SUCCESS');
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        var PurchaseOrder = JSON.parse(JSON.stringify(response["PurchaseOrder"]));

        if(PurchaseOrder.POStatus?.ID != this.CurrentOrder.POStatus?.ID){
          this.AskClientStatusNotificationEmail = true;
        }

        this.Orders.forEach(element => {
          if(element.DBID == PurchaseOrder.DBID){
            element.POStatus = PurchaseOrder.POStatus;
          }
        });

        // ✅ Only close on success
        this.ShowEditContainer = false;
       }

       this.parent.loading = false;
      });
    }
   }

   // Send Email Dropdown Methods
   onSendEmailFocus() {
    this.showSendEmailResults = true;
   }

   selectSendEmailOption(option: any) {
    this.sendEmailOnConvert = option.value;
    this.showSendEmailResults = false;
   }

   getSendEmailLabel(): string {
    const found = this.sendEmailOptions.find(o => o.value === this.sendEmailOnConvert);
    return found ? found.label : 'Select Option';
   }


   ChangeGridCellItem(item:any){
    console.log('💾 PURCHASE-ORDERS: ChangeGridCellItem called');
    console.log('   Item ID:', item?.ID);
    console.log('   CurrentOrder exists:', !!this.CurrentOrder);
    console.log('   Partner exists:', !!this.CurrentOrder?.Cart?.Partner);

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      item:item,
      Partner:this.CurrentOrder.Cart.Partner,
      Company:this.CurrentOrder.Company,
    };

    this.B2BService.ChangeGridCellItem(request).subscribe(response => {
      console.log('   Response Status:', response["Status"]);

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        console.log('   ✅ Item saved successfully');

        var Item = response["item"];

        this.CurrentOrder.Cart.Items.forEach((cell, index) => {
          if(cell.UIID == item.UIID){
            this.CurrentOrder.Cart.Items[index] = JSON.parse(JSON.stringify(Item));
          }
        });
      }
     });
  }

  ShowConfirmationQuestion:boolean = false;

  PreCheckOfferConfirmation(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Offer:o,
    };

    this.managementService.PreCheckPurchaseOrderConfirmation(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 60000);
      }
      else if(response["Status"] == 1){
        this.CurrentOrder = o;
        this.ShowConfirmationQuestion = true;
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 60000);
      }
     });
  }

  ConfirmOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
      DBID:o.DBID,
      PurchaseOrderStatus:{
        ID:12,
      }
    };

    this.managementService.ChangePurchaseOrderStatus(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        o.OCStatus = JSON.parse(JSON.stringify(response["PurchaseOrderStatus"]));
        this.SendClientRequestToPendingPurchaseOrder(o);
      }
     });
  }

  SendClientRequestToPendingPurchaseOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseOrderID:o.ID,
      GetCartItems:true,
      WithLogs:true,
      GetCartItemsPurchaseOfferData:true,
    };

    this.parent.loading = true;

    this.managementService.GetPurchaseOrder(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentOrder = response["PurchaseOrder"];

        var Sendrequest = {
          User:this.parent.User,
          Language:this.parent.getLanguage(),
          PurchaseOrder:JSON.parse(JSON.stringify(this.CurrentOrder)),
        };

        this.managementService.AcceptNewlyQuotedPricesPurchaseOrder(Sendrequest).subscribe(response => {

          if(response["Status"] != 1){
            this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 60000);
          }
          else if(response["Status"] == 1){

            var message = JSON.parse(JSON.stringify(response["Message"]));
            if(message?.length > 0){
              this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 60000);
            }

            var InjectionError = JSON.parse(JSON.stringify(response["InjectionError"]));

            this.Orders.forEach(order => {
              if(order.DBID == o.DBID){
                order.InjectionError = JSON.parse(JSON.stringify(InjectionError));
              }
            });
          }

          this.parent.loading = false;
         });
      }
    });
  }

  SelectItemSupplierVariants(item:any){
    this.CurrentOrder.Cart.Items.forEach(element => {
      if(element.UIID == item.UIID){
        element.IsSelected = !element.IsSelected;
      }
      else{
        element.IsSelected = false;
      }
    });
  }

  // Number parser for grid
  numberParser(params: any): number | null {
    const value = params.newValue;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  // MOQ Adjustment Tooltip
  MOQAdjustmentTooltip: string = 'Quantity adjusted to meet MOQ';

  // AG Grid Methods for Offer Products
  onOfferGridReady(params: any): void {
    console.log('🎯 ORDER-CONFIRMATIONS: onOfferGridReady called');
    this.offerGridApi = params.api;
    this.offerColumnApi = params.columnApi;
    console.log('   offerGridApi initialized:', !!this.offerGridApi);
    this.loadOfferGridData();
    params.api.sizeColumnsToFit();
    // ✅ Sync column widths for ExcelExportControlRow
    setTimeout(() => this.syncColumnWidths(), 200);
  }

  calculateGridHeaderWidths(): void {
    const gridContainer = document.querySelector('.ProductsAGGridContainer');
    console.log('Grid container:', gridContainer);
    if (!gridContainer) {
      console.log('Grid container not found!');
      return;
    }

    const headerCells = gridContainer.querySelectorAll('.ag-header-cell');
    console.log('Header cells found:', headerCells.length);
    const widths: any[] = [];
    let leftPosition = 0;

    headerCells.forEach((cell: any, index: number) => {
      const width = cell.offsetWidth;
      const colId = cell.getAttribute('col-id');

      console.log(`Column ${index}: field=${colId}, width=${width}, left=${leftPosition}`);

      widths.push({
        field: colId,
        width: width,
        left: leftPosition,
        index: index
      });

      leftPosition += width;
    });

    this.gridHeaderWidths = widths;
    console.log('Grid header widths:', this.gridHeaderWidths);
  }

  // Products Grid Ready Handler (for main Products tab)
  onProductsGridReady(params: any): void {
    console.log('🎯 ORDER-CONFIRMATIONS: onProductsGridReady called');
    this.productsGridApi = params.api;
    console.log('   productsGridApi initialized:', !!this.productsGridApi);
    params.api.sizeColumnsToFit();

    // Calculate header widths for custom overlay
    setTimeout(() => {
      this.calculateGridHeaderWidths();
    }, 500);

    // Recalculate on column resize
    params.api.addEventListener('columnResized', () => {
      this.calculateGridHeaderWidths();
    });
  }

  loadOfferGridData(): void {
    console.log('📊 ORDER-CONFIRMATIONS: loadOfferGridData called');
    console.log('   CurrentOrder exists:', !!this.CurrentOrder);
    console.log('   Cart.Items length:', this.CurrentOrder?.Cart?.Items?.length);

    if (!this.CurrentOrder?.Cart?.Items) {
      this.offerGridRowData = [];
      return;
    }

    this.offerGridRowData = this.CurrentOrder.Cart.Items.map((item: any, index: number) => {
      const leadTime = item?.SelectedOffer?.LeadTime;
      const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

      return {
        index: index + 1,
        brand: item?.Product?.Brand?.Name || item?.UserSelectedBrand?.Name || '',
        partNumber: item?.Product?.PartNumber || '',
        name: item?.UIProductValue || item?.Product?.Name || '',
        quantity: item?.Quantity || 0,
        // ✅ List-Price: Manufacturer's list price from Product.Stats.StandardListPrice.UIUnitPrice
        officialListPrice: item?.Product?.Stats?.StandardListPrice?.UIUnitPrice || '',
        officialDiscount: item?.Product?.Stats?.StandardListPrice?.Discount?.Value || '',
        // ✅ Final-Price: Sell price from SelectedOffer.SellingPrice (what we sell to customer)
        price: item?.SelectedOffer?.SellingPrice || item?.Price?.UIUnitPrice || '',
        total: item?.Price?.UIQtyPrice ? `${item.Price.UIQtyPrice} ${this.CurrentOrder.Cart.Currency?.Symbol}` : '',
        eta: etaDisplay,
        supplier: item?.SelectedOffer?.Partner?.Name || '',
        // ✅ Purchase: from SelectedOffer.ListPrice (what we buy from supplier)
        purchase: item?.SelectedOffer?.ListPrice || '',
        hscode: item?.Product?.Stats?.HSCode || '',
        coo: item?.Product?.Stats?.COO?.ShortName || '',
        weight: item?.Product?.Stats?.Weight != null
          ? `${item.Product.Stats.Weight} ${item.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
          : '',
        CartItem: item, // Keep reference to original item
        // Extra offer context columns (same as ProductItems)
        OfferID: this.CurrentOrder?.ID || '',
        OfferDBID: this.CurrentOrder?.DBID || 0,
        ReferenceNumber: this.CurrentOrder?.ReferenceNumber || '',
        DebatorPO: this.CurrentOrder?.DebatorPO || '',
        PartnerName: this.CurrentOrder?.Cart?.Partner?.Name || '',
        OfferEventRegister: this.CurrentOrder?.EventRegister || null
      };
    });

    this.CartItemRows = [...this.offerGridRowData];
    console.log('   offerGridRowData length:', this.offerGridRowData.length);
    console.log('   CartItemRows length:', this.CartItemRows.length);

    if (this.offerGridApi) {
      console.log('   Resizing grid and injecting header checkbox');
      this.offerGridApi.sizeColumnsToFit();
      // Re-inject header checkbox after data load
      setTimeout(() => this.injectOfferHeaderCheckbox(), 100);
    } else {
      console.log('   ⚠️ offerGridApi not available');
    }
  }

  onOfferCellValueChanged(event: any): void {
    const field = event.colDef.field;
    const newValue = event.newValue;
    const rowNode = event.node;
    const rowIndex = event.rowIndex;
    const cartItem = event.data?.CartItem;

    if (!cartItem) return;

    const currentOrderItem = this.CurrentOrder?.Cart?.Items?.[rowIndex];
    const refMatch = currentOrderItem === cartItem;
    console.log(`✏️ [PO-onOfferCellValueChanged] field="${field}" row=${rowIndex} newValue="${newValue}" CartItem.ID=${cartItem?.ID} refMatch=${refMatch}`);
    if (!refMatch) {
      console.warn(`⚠️ [PO-onOfferCellValueChanged] REFERENCE MISMATCH at row ${rowIndex}!`);
    }

    // ---------- QUANTITY changes ----------
    if (field === 'quantity') {
      const parsedQty = this.parseNumberFromAnyFormat(newValue);
      if (parsedQty === null || isNaN(parsedQty) || parsedQty < 0) {
        return;
      }
      cartItem.Quantity = parsedQty;
      rowNode.data.quantity = parsedQty;

      // ✅ Recalculate Total = FinalPrice × Quantity
      const finalPrice = cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || 0;
      if (finalPrice > 0 && parsedQty > 0) {
        const total = Math.round(finalPrice * parsedQty * 100) / 100;
        if (!cartItem.Price) cartItem.Price = {};
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'quantity');
      return;
    }

    // ---------- LIST-PRICE changes (recalculates Final-Price based on Discount) ----------
    if (field === 'officialListPrice') {
      const parsedListPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedListPrice === null || isNaN(parsedListPrice) || parsedListPrice < 0) {
        rowNode.setDataValue('officialListPrice', event.oldValue);
        return;
      }

      // ✅ Ensure Product.Stats.StandardListPrice exists
      if (!cartItem.Product) cartItem.Product = {};
      if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
      if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};

      // ✅ Store the list price
      cartItem.Product.Stats.StandardListPrice.UIUnitPrice = parsedListPrice;

      // ✅ Get current discount percentage
      const discountPercent = cartItem.Product?.Stats?.StandardListPrice?.Discount?.Value || 0;

      // ✅ Calculate new Final-Price based on List-Price and Discount
      const newFinalPrice = Math.round(parsedListPrice * (1 - discountPercent / 100) * 100) / 100;

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = newFinalPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = newFinalPrice;

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (newFinalPrice > 0 && qty > 0) {
        const total = Math.round(newFinalPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Update grid display fields
      rowNode.data.officialListPrice = parsedListPrice;
      rowNode.data.price = newFinalPrice;

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'officialListPrice');
      return;
    }

    // ---------- DISCOUNT changes (recalculates Final-Price based on List-Price) ----------
    if (field === 'officialDiscount') {
      const parsedDiscount = this.parseNumberFromAnyFormat(newValue);
      if (parsedDiscount === null || isNaN(parsedDiscount) || parsedDiscount < 0 || parsedDiscount > 100) {
        rowNode.setDataValue('officialDiscount', event.oldValue);
        return;
      }

      // ✅ Check if ListPrice exists
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice == null || listPrice <= 0) {
        this.parent.openSnackBar('Cannot calculate: List-Price is missing', 'OK', 'alert-info-snackbar');
        rowNode.setDataValue('officialDiscount', event.oldValue);
        return;
      }

      // ✅ Update the discount value in CartItem
      if (!cartItem.Product.Stats.StandardListPrice.Discount) {
        cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
      }
      cartItem.Product.Stats.StandardListPrice.Discount.Value = parsedDiscount;

      // ✅ Calculate new Final-Price based on List-Price and new Discount
      const newFinalPrice = Math.round(listPrice * (1 - parsedDiscount / 100) * 100) / 100;

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = newFinalPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = newFinalPrice;

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (newFinalPrice > 0 && qty > 0) {
        const total = Math.round(newFinalPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Update grid display fields
      rowNode.data.officialDiscount = parsedDiscount;
      rowNode.data.price = newFinalPrice;

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'officialDiscount');
      return;
    }

    // ---------- FINAL-PRICE changes (recalculates Discount based on List-Price) ----------
    if (field === 'price') {
      const parsedPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedPrice === null || isNaN(parsedPrice) || parsedPrice < 0) {
        rowNode.setDataValue('price', event.oldValue);
        return;
      }

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = parsedPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = parsedPrice;

      // ✅ Recalculate Discount if List-Price exists
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice != null && listPrice > 0) {
        const newDiscount = Math.round((1 - parsedPrice / listPrice) * 100 * 100) / 100;
        const clampedDiscount = Math.max(0, Math.min(100, newDiscount));

        // ✅ Ensure discount object exists
        if (!cartItem.Product) cartItem.Product = {};
        if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
        if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};
        if (!cartItem.Product.Stats.StandardListPrice.Discount) {
          cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
        }
        cartItem.Product.Stats.StandardListPrice.Discount.Value = clampedDiscount;
        rowNode.data.officialDiscount = clampedDiscount;
      }

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (parsedPrice > 0 && qty > 0) {
        const total = Math.round(parsedPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Update grid display fields
      rowNode.data.price = parsedPrice;

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'price');
      return;
    }

    // ---------- BRAND changes (Brand identification via backend) ----------
    if (field === 'brand') {
      const newBrand = (event.newValue ?? '').toString().trim();
      const oldBrand = (event.oldValue ?? '').toString().trim();

      if (!newBrand) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newBrand
      };

      this.managementService.IdentifyGridBrand(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (cartItem) {
            if (!cartItem.Product) cartItem.Product = {};
            cartItem.Product.Brand = response["Brand"];

            const brandDisplay = response["Brand"]?.Name ?? '';
            rowNode.data.brand = brandDisplay;

            this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.offerGridApi.stopEditing();
            this.startAutoSaveTimer(rowIndex, cartItem, false, 'brand');
          }
        } else {
          rowNode.data.brand = oldBrand;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify brand', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.brand = oldBrand;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Could not identify brand', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- ETA changes (Standard-Delivery - Lead time identification via backend) ----------
    if (field === 'eta') {
      const newETA = (event.newValue ?? '').toString().trim();
      const oldETA = (event.oldValue ?? '').toString().trim();

      if (!newETA || newETA === '------') return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newETA,
        IsProlonged: false
      };

      this.managementService.IdentifyGridLeadTime(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (response["LeadTime"] && cartItem) {
            if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};

            cartItem.SelectedOffer.LeadTime = JSON.parse(JSON.stringify(response["LeadTime"]));
            cartItem.SelectedOffer.IsStockOffer = response["IsStock"];

            const leadTime = cartItem.SelectedOffer.LeadTime;
            const etaDisplay = leadTime?.UIOutput ??
              (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

            rowNode.data.eta = etaDisplay;
            this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, false, 'eta');
          }
        } else {
          rowNode.data.eta = oldETA;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not parse lead time', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.eta = oldETA;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error parsing lead time', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- COO changes (Country identification via backend) ----------
    if (field === 'coo') {
      const newCOO = (event.newValue ?? '').toString().trim();
      const oldCOO = (event.oldValue ?? '').toString().trim();

      if (!newCOO) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newCOO
      };

      this.managementService.IdentifyGridCOO(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (cartItem) {
            if (!cartItem.Product) cartItem.Product = {};
            if (!cartItem.Product.Stats) cartItem.Product.Stats = {};

            cartItem.Product.Stats.COO = response["Country"];

            const cooDisplay = response["Country"]?.ShortName ?? '';
            rowNode.data.coo = cooDisplay;

            this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.offerGridApi.stopEditing();
            this.startAutoSaveTimer(rowIndex, cartItem, false, 'coo');
          }
        } else {
          rowNode.data.coo = oldCOO;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify country', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.coo = oldCOO;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error identifying country', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- WEIGHT changes (Weight identification via backend) ----------
    if (field === 'weight') {
      const newWeight = (event.newValue ?? '').toString().trim();
      const oldWeight = (event.oldValue ?? '').toString().trim();

      if (!newWeight) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newWeight
      };

      this.managementService.IdentifyGridWeight(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (cartItem) {
            if (!cartItem.Product) cartItem.Product = {};
            if (!cartItem.Product.Stats) cartItem.Product.Stats = {};

            cartItem.Product.Stats.Weight = response["Weight"];
            cartItem.Product.Stats.WeightMeasurementType = JSON.parse(JSON.stringify(response["WeightMeasurementType"]));

            const weight = cartItem.Product.Stats.Weight;
            const weightType = cartItem.Product.Stats.WeightMeasurementType;
            const weightDisplay = weight && weightType ? `${weight} ${weightType.Name}` : '';

            rowNode.data.weight = weightDisplay;
            this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, false, 'weight');
          }
        } else {
          rowNode.data.weight = oldWeight;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not parse weight', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.weight = oldWeight;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error parsing weight', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- HSCODE changes ----------
    if (field === 'hscode') {
      const newHSCode = (event.newValue ?? '').toString().trim();
      const oldHSCode = (event.oldValue ?? '').toString().trim();
      if (newHSCode === oldHSCode) return;

      // Update CartItem
      if (!cartItem.Product) cartItem.Product = {};
      if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
      cartItem.Product.Stats.HSCode = newHSCode;

      rowNode.data.hscode = newHSCode;
      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'hscode');
      return;
    }

    // ---------- PURCHASE (ListPrice) changes ----------
    if (field === 'purchase') {
      const newPurchase = parseFloat((event.newValue ?? '').toString().replace(',', '.')) || 0;
      const oldPurchase = parseFloat((event.oldValue ?? '').toString().replace(',', '.')) || 0;
      if (newPurchase === oldPurchase) return;

      // Update CartItem.SelectedOffer.ListPrice
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.ListPrice = newPurchase;

      // Also update ListPriceOffers[0] if exists
      if (cartItem.Product?.ListPriceOffers?.length > 0) {
        cartItem.Product.ListPriceOffers[0].ListPrice = newPurchase;
      }

      rowNode.data.purchase = newPurchase;
      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'purchase');
      return;
    }

    // ---------- NAME changes (Product search) ----------
    if (field === 'name') {
      const newName = (event.newValue ?? '').toString().trim();
      const oldName = (event.oldValue ?? '').toString().trim();

      // Skip if empty or unchanged
      if (!newName || newName === oldName) return;

      // Trigger product search
      this.searchOfferProduct(rowIndex, newName, cartItem?.Quantity || 1);
      return;
    }
  }

  // Products Grid Cell Value Changed Handler (same logic, uses productsGridApi)
  onProductsCellValueChanged(event: any): void {
    const field = event.colDef.field;
    const newValue = event.newValue;
    const rowNode = event.node;
    const rowIndex = event.rowIndex;
    const cartItem = event.data?.CartItem;

    if (!cartItem) return;

    // ---------- QUANTITY changes ----------
    if (field === 'quantity') {
      const parsedQty = this.parseNumberFromAnyFormat(newValue);
      if (parsedQty === null || isNaN(parsedQty) || parsedQty < 0) {
        return;
      }

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      if (isBulkUpdate) {
        // Apply Quantity to ALL selected items
        selectedItems.forEach((item: any) => {
          if (item.CartItem) {
            item.CartItem.Quantity = parsedQty;

            // Recalculate Total = FinalPrice × Quantity
            const itemFinalPrice = item.CartItem?.SelectedOffer?.SellingPrice || item.CartItem?.Price?.UIUnitPrice || 0;
            if (itemFinalPrice > 0 && parsedQty > 0) {
              const total = Math.round(itemFinalPrice * parsedQty * 100) / 100;
              if (!item.CartItem.Price) item.CartItem.Price = {};
              item.CartItem.Price.UIQtyPrice = total;
              item.total = `${total}`;
            }
            item.quantity = parsedQty;
          }
        });
        this.productsGridApi.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        // Single item update
        cartItem.Quantity = parsedQty;

        // ✅ Recalculate Total = FinalPrice × Quantity
        const finalPrice = cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || 0;
        if (finalPrice > 0 && parsedQty > 0) {
          const total = Math.round(finalPrice * parsedQty * 100) / 100;
          if (!cartItem.Price) cartItem.Price = {};
          cartItem.Price.UIQtyPrice = total;
          rowNode.data.total = `${total}`;
        }

        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true);
      }
      return;
    }

    // ---------- LIST-PRICE changes (recalculates Final-Price based on Discount) ----------
    if (field === 'officialListPrice') {
      const parsedListPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedListPrice === null || isNaN(parsedListPrice) || parsedListPrice < 0) {
        rowNode.setDataValue('officialListPrice', event.oldValue);
        return;
      }

      // ✅ Ensure Product.Stats.StandardListPrice exists
      if (!cartItem.Product) cartItem.Product = {};
      if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
      if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};

      // ✅ Store the list price
      cartItem.Product.Stats.StandardListPrice.UIUnitPrice = parsedListPrice;

      // ✅ Get current discount percentage
      const discountPercent = cartItem.Product?.Stats?.StandardListPrice?.Discount?.Value || 0;

      // ✅ Calculate new Final-Price based on List-Price and Discount
      const newFinalPrice = Math.round(parsedListPrice * (1 - discountPercent / 100) * 100) / 100;

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = newFinalPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = newFinalPrice;

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (newFinalPrice > 0 && qty > 0) {
        const total = Math.round(newFinalPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total}`;
      }

      // ✅ Update grid display fields
      rowNode.data.officialListPrice = parsedListPrice;
      rowNode.data.price = newFinalPrice;

      this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, true);
      return;
    }

    // ---------- DISCOUNT changes (recalculates Final-Price based on List-Price) ----------
    if (field === 'officialDiscount') {
      const parsedDiscount = this.parseNumberFromAnyFormat(newValue);
      if (parsedDiscount === null || isNaN(parsedDiscount) || parsedDiscount < 0 || parsedDiscount > 100) {
        rowNode.setDataValue('officialDiscount', event.oldValue);
        return;
      }

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      if (isBulkUpdate) {
        // Apply Discount to ALL selected items (each recalculates its own Final-Price based on its List-Price)
        selectedItems.forEach((item: any) => {
          if (item.CartItem) {
            const itemListPrice = item.CartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
            if (itemListPrice != null && itemListPrice > 0) {
              // Ensure discount object exists
              if (!item.CartItem.Product) item.CartItem.Product = {};
              if (!item.CartItem.Product.Stats) item.CartItem.Product.Stats = {};
              if (!item.CartItem.Product.Stats.StandardListPrice) item.CartItem.Product.Stats.StandardListPrice = {};
              if (!item.CartItem.Product.Stats.StandardListPrice.Discount) {
                item.CartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
              }
              item.CartItem.Product.Stats.StandardListPrice.Discount.Value = parsedDiscount;

              // Calculate new Final-Price
              const newFinalPrice = Math.round(itemListPrice * (1 - parsedDiscount / 100) * 100) / 100;
              if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
              item.CartItem.SelectedOffer.SellingPrice = newFinalPrice;
              if (!item.CartItem.Price) item.CartItem.Price = {};
              item.CartItem.Price.UIUnitPrice = newFinalPrice;

              // Recalculate Total
              const qty = item.CartItem.Quantity || 0;
              if (newFinalPrice > 0 && qty > 0) {
                const total = Math.round(newFinalPrice * qty * 100) / 100;
                item.CartItem.Price.UIQtyPrice = total;
                item.total = `${total}`;
              }

              item.officialDiscount = parsedDiscount;
              item.price = newFinalPrice;
            }
          }
        });
        this.productsGridApi.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        // Single item update
        const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
        if (listPrice == null || listPrice <= 0) {
          this.parent.openSnackBar('Cannot calculate: List-Price is missing', 'OK', 'alert-info-snackbar');
          rowNode.setDataValue('officialDiscount', event.oldValue);
          return;
        }

        // Update the discount value in CartItem
        if (!cartItem.Product.Stats.StandardListPrice.Discount) {
          cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
        }
        cartItem.Product.Stats.StandardListPrice.Discount.Value = parsedDiscount;

        // Calculate new Final-Price based on List-Price and new Discount
        const newFinalPrice = Math.round(listPrice * (1 - parsedDiscount / 100) * 100) / 100;

        // Update Final-Price in CartItem
        if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
        cartItem.SelectedOffer.SellingPrice = newFinalPrice;
        if (!cartItem.Price) cartItem.Price = {};
        cartItem.Price.UIUnitPrice = newFinalPrice;

        // Recalculate Total
        const qty = cartItem.Quantity || 0;
        if (newFinalPrice > 0 && qty > 0) {
          const total = Math.round(newFinalPrice * qty * 100) / 100;
          cartItem.Price.UIQtyPrice = total;
          rowNode.data.total = `${total}`;
        }

        // Update grid display fields
        rowNode.data.officialDiscount = parsedDiscount;
        rowNode.data.price = newFinalPrice;

        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true);
      }
      return;
    }

    // ---------- FINAL-PRICE changes (recalculates Discount based on List-Price) ----------
    if (field === 'price') {
      const parsedPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedPrice === null || isNaN(parsedPrice) || parsedPrice < 0) {
        rowNode.setDataValue('price', event.oldValue);
        return;
      }

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = parsedPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = parsedPrice;

      // ✅ Recalculate Discount if List-Price exists
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice != null && listPrice > 0) {
        const newDiscount = Math.round((1 - parsedPrice / listPrice) * 100 * 100) / 100;
        const clampedDiscount = Math.max(0, Math.min(100, newDiscount));

        // ✅ Ensure discount object exists
        if (!cartItem.Product) cartItem.Product = {};
        if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
        if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};
        if (!cartItem.Product.Stats.StandardListPrice.Discount) {
          cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
        }
        cartItem.Product.Stats.StandardListPrice.Discount.Value = clampedDiscount;
        rowNode.data.officialDiscount = clampedDiscount;
      }

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (parsedPrice > 0 && qty > 0) {
        const total = Math.round(parsedPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total}`;
      }

      // ✅ Update grid display fields
      rowNode.data.price = parsedPrice;

      this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, true);
      return;
    }

    // ---------- BRAND changes ----------
    if (field === 'brand') {
      const newBrand = (event.newValue ?? '').toString().trim();
      const oldBrand = (event.oldValue ?? '').toString().trim();
      if (!newBrand) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newBrand
      };

      this.managementService.IdentifyGridBrand(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (!cartItem.Product) cartItem.Product = {};
          cartItem.Product.Brand = response["Brand"];
          rowNode.data.brand = response["Brand"]?.Name ?? '';
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.productsGridApi.stopEditing();
          this.startAutoSaveTimer(rowIndex, cartItem, true);
        } else {
          rowNode.data.brand = oldBrand;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify brand', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.brand = oldBrand;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Could not identify brand', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- ETA changes ----------
    if (field === 'eta') {
      const newETA = (event.newValue ?? '').toString().trim();
      const oldETA = (event.oldValue ?? '').toString().trim();
      if (!newETA || newETA === '------') return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newETA,
        IsProlonged: false
      };

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      this.managementService.IdentifyGridLeadTime(request).subscribe(response => {
        if (response["Status"] === 1 && response["LeadTime"]) {
          const leadTime = JSON.parse(JSON.stringify(response["LeadTime"]));
          const isStock = response["IsStock"];
          const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

          if (isBulkUpdate) {
            // Apply LeadTime to ALL selected items
            selectedItems.forEach((item: any) => {
              if (item.CartItem) {
                if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
                item.CartItem.SelectedOffer.LeadTime = JSON.parse(JSON.stringify(leadTime));
                item.CartItem.SelectedOffer.IsStockOffer = isStock;
                item.eta = etaDisplay;
              }
            });
            this.productsGridApi.refreshCells({ force: true });
            this.BulkUpdateSelectedCartItems(selectedItems);
          } else {
            // Single item update
            if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
            cartItem.SelectedOffer.LeadTime = leadTime;
            cartItem.SelectedOffer.IsStockOffer = isStock;
            rowNode.data.eta = etaDisplay;
            this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, true);
          }
        } else {
          rowNode.data.eta = oldETA;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not parse lead time', "OK", "alert-info-snackbar");
        }
      }, () => {
        rowNode.data.eta = oldETA;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error parsing lead time', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- COO changes ----------
    if (field === 'coo') {
      const newCOO = (event.newValue ?? '').toString().trim();
      const oldCOO = (event.oldValue ?? '').toString().trim();
      if (!newCOO) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newCOO
      };

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      this.managementService.IdentifyGridCOO(request).subscribe(response => {
        if (response["Status"] === 1) {
          const country = response["Country"];
          const shortName = country?.ShortName ?? '';

          if (isBulkUpdate) {
            // Apply COO to ALL selected items
            selectedItems.forEach((item: any) => {
              if (item.CartItem) {
                if (!item.CartItem.Product) item.CartItem.Product = {};
                if (!item.CartItem.Product.Stats) item.CartItem.Product.Stats = {};
                item.CartItem.Product.Stats.COO = JSON.parse(JSON.stringify(country));
                item.coo = shortName;
              }
            });
            this.productsGridApi.refreshCells({ force: true });
            this.productsGridApi.stopEditing();
            this.BulkUpdateSelectedCartItems(selectedItems);
          } else {
            // Single item update
            if (!cartItem.Product) cartItem.Product = {};
            if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
            cartItem.Product.Stats.COO = country;
            rowNode.data.coo = shortName;
            this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.productsGridApi.stopEditing();
            this.startAutoSaveTimer(rowIndex, cartItem, true);
          }
        } else {
          rowNode.data.coo = oldCOO;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify country', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.coo = oldCOO;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error identifying country', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- WEIGHT changes ----------
    if (field === 'weight') {
      const newWeight = (event.newValue ?? '').toString().trim();
      const oldWeight = (event.oldValue ?? '').toString().trim();
      if (!newWeight) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newWeight
      };

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      this.managementService.IdentifyGridWeight(request).subscribe(response => {
        if (response["Status"] === 1) {
          const weight = response["Weight"];
          const weightType = JSON.parse(JSON.stringify(response["WeightMeasurementType"]));
          const weightDisplay = weight && weightType ? `${weight} ${weightType.Name}` : '';

          if (isBulkUpdate) {
            // Apply Weight to ALL selected items
            selectedItems.forEach((item: any) => {
              if (item.CartItem) {
                if (!item.CartItem.Product) item.CartItem.Product = {};
                if (!item.CartItem.Product.Stats) item.CartItem.Product.Stats = {};
                item.CartItem.Product.Stats.Weight = weight;
                item.CartItem.Product.Stats.WeightMeasurementType = JSON.parse(JSON.stringify(weightType));
                item.weight = weightDisplay;
              }
            });
            this.productsGridApi.refreshCells({ force: true });
            this.BulkUpdateSelectedCartItems(selectedItems);
          } else {
            // Single item update
            if (!cartItem.Product) cartItem.Product = {};
            if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
            cartItem.Product.Stats.Weight = weight;
            cartItem.Product.Stats.WeightMeasurementType = weightType;
            rowNode.data.weight = weightDisplay;
            this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, true);
          }
        } else {
          rowNode.data.weight = oldWeight;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not parse weight', "OK", "alert-info-snackbar");
        }
      }, () => {
        rowNode.data.weight = oldWeight;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error parsing weight', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- HSCODE changes ----------
    if (field === 'hscode') {
      const newHSCode = (event.newValue ?? '').toString().trim();
      const oldHSCode = (event.oldValue ?? '').toString().trim();
      if (newHSCode === oldHSCode) return;

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      if (selectedItems.length > 1) {
        // Apply HSCode to ALL selected items
        selectedItems.forEach((item: any) => {
          if (item.CartItem) {
            if (!item.CartItem.Product) item.CartItem.Product = {};
            if (!item.CartItem.Product.Stats) item.CartItem.Product.Stats = {};
            item.CartItem.Product.Stats.HSCode = newHSCode;
            item.hscode = newHSCode;
          }
        });
        this.productsGridApi.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        // Single item update
        if (!cartItem.Product) cartItem.Product = {};
        if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
        cartItem.Product.Stats.HSCode = newHSCode;
        rowNode.data.hscode = newHSCode;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true);
      }
      return;
    }

    // ---------- PURCHASE (ListPrice) changes ----------
    if (field === 'purchase') {
      const newPurchase = parseFloat((event.newValue ?? '').toString().replace(',', '.')) || 0;
      const oldPurchase = parseFloat((event.oldValue ?? '').toString().replace(',', '.')) || 0;
      if (newPurchase === oldPurchase) return;

      // Update CartItem.SelectedOffer.ListPrice
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.ListPrice = newPurchase;

      // Also update ListPriceOffers[0] if exists
      if (cartItem.Product?.ListPriceOffers?.length > 0) {
        cartItem.Product.ListPriceOffers[0].ListPrice = newPurchase;
      }

      rowNode.data.purchase = newPurchase;
      this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, true);
      return;
    }

    // ---------- NAME changes (Product search) ----------
    if (field === 'name') {
      const nameRowIndex = event.rowIndex;
      const newName = (event.newValue ?? '').toString().trim();
      const oldName = (event.oldValue ?? '').toString().trim();

      // Skip if empty or unchanged
      if (!newName || newName === oldName) return;

      // Trigger product search (use offerGridApi for EditContainer)
      this.searchOfferProduct(nameRowIndex, newName, cartItem?.Quantity || 1);
      return;
    }
  }

  // ========== Products Grid Button Click Handler ==========
  onProductsGridCellButtonClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const button = target.closest('[data-type]') as HTMLElement;
    if (!button) return;

    const type = button.getAttribute('data-type');
    const rowIndexStr = button.getAttribute('data-row');
    const rowIndex = rowIndexStr ? parseInt(rowIndexStr, 10) : -1;

    if (rowIndex < 0) return;

    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(rowIndex);
    const rowData = rowNode?.data;
    const cartItem = rowData?.CartItem;

    this.ProductsClickedRow = rowData;
    this.ProductsClickedRowIndex = rowIndex;

    switch (type) {
      case 'brand-collateral':
        this.ShowProductsBrandCollateral = true;
        this.calculateProductsPopupPosition(button, 'brand');
        if (cartItem) {
          this.SearchProductsBrands(cartItem);
        }
        break;

      case 'productalternatives':
        this.ShowProductsETAAlternatives = true;
        this.calculateProductsPopupPosition(button, 'name');
        // Check for Product.ID or IndustryProductID
        const productId1 = cartItem?.Product?.ID || cartItem?.IndustryProductID || cartItem?.SelectedOffer?.IndustryProductID;
        if (productId1) {
          const offerId1 = cartItem?.SelectedOffer?.ID || cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetProductsSideOffers(productId1, offerId1);
        }
        break;

      case 'supplierAlternatives':
        this.ShowProductsSupplierAlternatives = true;
        this.calculateProductsPopupPosition(button, 'supplier');
        // Check for Product.ID or IndustryProductID
        const productId2 = cartItem?.Product?.ID || cartItem?.IndustryProductID || cartItem?.SelectedOffer?.IndustryProductID;
        if (productId2) {
          const offerId2 = cartItem?.SelectedOffer?.ID || cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetProductsSideOffers(productId2, offerId2);
        }
        break;
    }
  }

  calculateProductsPopupPosition(element: HTMLElement, type: string): void {
    const gridContainer = document.querySelector('.ProductsAGGridContainer') as HTMLElement;
    if (!gridContainer) return;

    const containerRect = gridContainer.getBoundingClientRect();

    // Find the actual cell element (parent of button)
    const cellElement = element.closest('.ag-cell') as HTMLElement;
    const cellRect = cellElement ? cellElement.getBoundingClientRect() : element.getBoundingClientRect();

    const top = cellRect.bottom - containerRect.top;
    const left = cellRect.left - containerRect.left;

    switch (type) {
      case 'brand':
        this.ProductsBrandPopupPosition = { position: 'absolute', top: `${top}px`, left: `${left}px`, width: '250px' };
        break;
      case 'name':
        this.ProductsSearchResultsPosition = { position: 'absolute', top: `${top}px`, left: '0px', width: '100%' };
        break;
      case 'supplier':
        // Width from supplier column to end of grid
        const popupWidth = containerRect.width - left;
        this.ProductsSupplierPopupPosition = { position: 'absolute', top: `${top}px`, left: `${left}px`, width: `${popupWidth}px` };
        break;
    }
  }

  closeProductsPopups(): void {
    this.ShowProductsETAAlternatives = false;
    this.ShowProductsSupplierAlternatives = false;
    this.ShowProductsBrandCollateral = false;
    this.ProductsSupplierPopupSearchTerm = '';
    this.ProductsSupplierPopupSearchResults = [];
    this.selectedProductsNamePopupTab = 1;
    this.showPurchaseCurrencyDropdown = false;
    this.ShowChainHistory = false;
  }

  // ✅ Handle Products Name popup tab change (matching EditSectionProducts pattern)
  onProductsNamePopupTabChange(tabIndex: number): void {
    this.selectedProductsNamePopupTab = tabIndex;

    const cartItem = this.ProductsClickedRow?.CartItem;
    if (!cartItem) return;

    const productId = cartItem?.Product?.ID || cartItem?.IndustryProductID || cartItem?.SelectedOffer?.IndustryProductID;
    const offerId = cartItem?.SelectedOffer?.ID || cartItem?.Product?.ListPriceOffers?.[0]?.ID;

    if (tabIndex === 1) {
      // Tab 1: Other Offers - same product, different suppliers/configs
      if (productId) {
        this.GetProductsSideOffers(productId, offerId);
      }
    } else if (tabIndex === 2) {
      // Tab 2: Similar Products - alternative products from SearchResults
      const productIds = (cartItem?.SearchResults ?? []).map((s: any) => s.ProductID || s.IndustryProductID);
      if (productIds?.length > 0) {
        this.GetProductsSimilarProducts(productIds, offerId, cartItem?.Product?.Brand);
      } else if (productId) {
        // Fallback: use current product ID if no SearchResults
        this.GetProductsSimilarProducts([productId], offerId, cartItem?.Product?.Brand);
      }
    }
  }

  // ✅ Load chain history for the currently clicked cart item
  loadChainHistory(): void {
    const cartItem = this.ProductsClickedRow?.CartItem;
    if (!cartItem?.ID || cartItem.ID <= 0) { this.parent.openSnackBar('Item not saved yet — no chain history available', 'OK', 'alert-info-snackbar'); return; }
    this.ShowChainHistory = true; this.ChainHistoryLoading = true; this.ChainHistoryOrderChain = []; this.ChainHistoryItemChain = [];
    const request = { User: this.parent.User, Language: this.parent.getLanguage(), CartItemID: cartItem.ID, OrderTypeID: 1 };
    this.managementService.GetItemChainHistory(request).subscribe((response: any) => {
      this.ChainHistoryLoading = false;
      if (response['Status'] === 1) { this.ChainHistoryOrderChain = response['OrderChain'] || []; this.ChainHistoryItemChain = response['ItemChain'] || []; }
      else { this.ChainHistoryOrderChain = []; this.ChainHistoryItemChain = []; }
    }, () => { this.ChainHistoryLoading = false; this.ChainHistoryOrderChain = []; this.ChainHistoryItemChain = []; });
  }
  getChainItemQuantities(stepDBID: number): any {
    if (!this.ChainHistoryItemChain?.length) return null;
    return this.ChainHistoryItemChain.find(i => i.FKOrderGroupsDBID === stepDBID) || null;
  }
  getOrderTypeName(typeId: number): string { switch (typeId) { case 4: return 'Offer Request'; case 2: return 'Offer'; case -1: return 'Order Confirmation'; case 1: return 'Purchase Order'; default: return 'Unknown'; } }
  getOrderTypeIcon(typeId: number): string { switch (typeId) { case 4: return 'mail_outline'; case 2: return 'description'; case -1: return 'assignment_turned_in'; case 1: return 'local_shipping'; default: return 'help_outline'; } }
  getOrderTypeColor(typeId: number): string { switch (typeId) { case 4: return '#7c4dff'; case 2: return '#2196f3'; case -1: return '#4caf50'; case 1: return '#f60'; default: return '#999'; } }

  // ✅ Get similar products for Products grid popup (using collateral API)
  GetProductsSimilarProducts(productIds: number[], offerId: number, brand: any): void {
    this.ProductsLoadingSideOffers = true;
    this.ProductsSideOffers = [];

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      IndustryProductIDs: productIds,
      SelectedOfferID: offerId,
      UISelectedBrand: brand,
      BestOfferOnly: true,
      GetAlsoCollateralSpecialOffers: true,
      GetOnlySpecialOffers: false,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: null,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.B2BService.GetIndustryProductCalculatedSideOffersWithCollateral(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        const cartItems = JSON.parse(JSON.stringify(response["CartItems"] || []));
        this.ProductsSideOffers = cartItems;
      }
      this.ProductsLoadingSideOffers = false;
    });
  }

  SearchProductsBrands(cartItem: any): void {
    this.ProductsLoadingSideOffers = true;
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      SearchTerm: cartItem?.Product?.PartNumber || ''
    };

    this.B2BService.SearchIndustryProductB2BBrandsVersion2(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        this.ProductsBrandCollateralList = response["Brands"] || [];
      }
      this.ProductsLoadingSideOffers = false;
    });
  }

  GetProductsSideOffers(IndustryProductID: number, offerId: number): void {
    this.ProductsLoadingSideOffers = true;
    this.ProductsSupplierPopupSearchTerm = '';
    this.ProductsSupplierPopupSearchResults = [];

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      IndustryProductID: IndustryProductID,
      SelectedOfferID: offerId,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: null,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.B2BService.GetIndustryProductCalculatedSideOffers(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        const cartItems = JSON.parse(JSON.stringify(response["CartItems"] || []));
        // Sort by ListPrice ascending (best price first) - same as original
        this.ProductsSideOffers = cartItems.sort((a: any, b: any) => {
          const priceA = a?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          const priceB = b?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          return priceA - priceB;
        });
      }
      this.ProductsLoadingSideOffers = false;
    });
  }

  // Search suppliers in Products grid popup
  SearchProductsSupplierPopup(): void {
    if (!this.ProductsSupplierPopupSearchTerm || this.ProductsSupplierPopupSearchTerm.length < 2) {
      this.ProductsSupplierPopupSearchResults = [];
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      SearchTerm: this.ProductsSupplierPopupSearchTerm,
      PageIndex: 1,
      PageSize: 50
    };

    this.service.GetPartnersFiltered(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        this.ProductsSupplierPopupSearchResults = response["Partners"] || [];
      }
    });
  }

  // Select partner from search in Products grid
  SelectProductsPartnerFromSearch(partner: any): void {
    if (!this.ProductsClickedRow?.CartItem) return;

    // Check for multi-select bulk update - if multiple items are selected, apply to all
    const selectedItems = this.getSelectedProductItems();
    const cartItem = this.ProductsClickedRow.CartItem;
    const isBulkUpdate = selectedItems.length > 1;

    if (isBulkUpdate) {
      // Apply Supplier to ALL selected items
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
          item.CartItem.SelectedOffer.Partner = JSON.parse(JSON.stringify(partner));
          item.supplier = partner?.Name ?? '';
        }
      });
      this.productsGridApi?.refreshCells({ force: true });
      this.ShowProductsSupplierAlternatives = false;
      this.ProductsSupplierPopupSearchTerm = '';
      this.ProductsSupplierPopupSearchResults = [];
      this.BulkUpdateSelectedCartItems(selectedItems);
    } else {
      // Single item update
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.Partner = partner;

      this.ProductsClickedRow.supplier = partner?.Name ?? '';
      this.productsGridApi?.refreshCells({ force: true });
      this.ShowProductsSupplierAlternatives = false;
      this.ProductsSupplierPopupSearchTerm = '';
      this.ProductsSupplierPopupSearchResults = [];

      // ✅ Trigger 2-second auto-save timer
      this.startAutoSaveTimer(this.ProductsClickedRowIndex, cartItem, true);
    }
  }

  selectProductsBrand(brand: any): void {
    if (!this.ProductsClickedRow?.CartItem) return;

    const cartItem = this.ProductsClickedRow.CartItem;
    if (!cartItem.Product) cartItem.Product = {};
    cartItem.Product.Brand = brand;

    this.ProductsClickedRow.brand = brand?.Name ?? '';
    this.productsGridApi?.refreshCells({ force: true });
    this.ShowProductsBrandCollateral = false;
  }

  selectProductsSideOffer(item: any): void {
    if (!this.ProductsClickedRow?.CartItem) return;

    const cartItem = this.ProductsClickedRow.CartItem;

    // Get CartItem.ID for preserving after update
    const cartItemID = cartItem?.ID || 0;

    // Get the clicked item's currency for PrefferedCurrency
    const clickedItemCurrency = item?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;

    // ✅ Ensure CartItem.Product.ListPriceOffers has at least one element (backend requires this)
    if (!cartItem.Product) {
      cartItem.Product = {};
    }
    if (!cartItem.Product.ListPriceOffers || cartItem.Product.ListPriceOffers.length === 0) {
      cartItem.Product.ListPriceOffers = [cartItem.SelectedOffer || {}];
    }

    // ✅ Build request like create-new-quotation does
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      SelectedOffer: item.Product?.ListPriceOffers?.[0] || item.SelectedOffer,
      CartItem: cartItem,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: clickedItemCurrency,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.ProductsLoadingSideOffers = true;

    this.B2BService.SwitchGridProductOffer(request).subscribe(response => {
      if (response["Status"] == 1) {
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;

        // ✅ Preserve the original CartItem.ID
        c.ID = cartItemID;

        // Apply to row
        this.applyProductsSearchResultToRow(this.ProductsClickedRowIndex, c);
      } else {
        this.parent.openSnackBar(response["Message"] || 'Error switching offer', "OK", "alert-info-snackbar");
      }

      this.ShowProductsETAAlternatives = false;
      this.ShowProductsSupplierAlternatives = false;
      this.ProductsLoadingSideOffers = false;
    });
  }

  /**
   * Apply search result to Products tab row
   */
  applyProductsSearchResultToRow(rowIndex: number, resultCartItem: any): void {
    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    // Preserve original order info columns
    const originalOfferDBID = rowNode.data.OfferDBID;
    const originalOfferID = rowNode.data.OfferID;
    const originalReferenceNumber = rowNode.data.ReferenceNumber;
    const originalDebatorPO = rowNode.data.DebatorPO;
    const originalPartnerName = rowNode.data.PartnerName;
    const originalOfferEventRegister = rowNode.data.OfferEventRegister;
    const originalCartItemID = rowNode.data.CartItem?.ID;
    const originalUIID = rowNode.data.CartItem?.UIID;
    const originalCartItemOrderInfo = rowNode.data.CartItem?.CartItemOrderInfo;

    // Copy new product data from result
    const c = JSON.parse(JSON.stringify(resultCartItem));
    c.LoadingCell = false;
    c.ID = originalCartItemID;
    c.UIID = originalUIID;
    // Preserve CartItemOrderInfo from original row
    c.CartItemOrderInfo = originalCartItemOrderInfo;

    // Extract display values from CartItem (same as create-new-quotation)
    const brand = c?.Product?.Brand?.Name ?? '';
    const name = c?.Product?.Name ?? '';
    const partNumber = c?.Product?.PartNumber ?? '';
    const quantity = c?.Quantity ?? rowNode.data.quantity ?? '';
    const price = c?.Price?.UIUnitPrice ?? '';
    const total = c?.Price?.UIQtyPrice ?? '';
    const eta = c?.SelectedOffer?.LeadTime?.UIOutput ??
      (c?.SelectedOffer?.LeadTime?.Units > 0
        ? `${c.SelectedOffer.LeadTime.Units} ${c.SelectedOffer.LeadTime.Type?.Name || ''}`
        : '------');
    const supplier = c?.SelectedOffer?.Partner?.Name ?? '';
    const purchase = c?.SelectedOffer?.ListPrice ?? '';
    const hscode = c?.Product?.Stats?.HSCode ?? '';
    const coo = c?.Product?.Stats?.COO?.ShortName ?? '';
    const weight = c?.Product?.Stats?.Weight != null
      ? `${c.Product.Stats.Weight} ${c.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
      : '';

    // ✅ Use setData like quotations/new to properly update the row
    rowNode.setData({
      index: rowNode.data.index,
      brand,
      partNumber,
      name,
      quantity,
      price,
      total,
      eta,
      supplier,
      purchase,
      hscode,
      coo,
      weight,
      // Preserve order info columns
      OfferDBID: originalOfferDBID,
      OfferID: originalOfferID,
      ReferenceNumber: originalReferenceNumber,
      DebatorPO: originalDebatorPO,
      PartnerName: originalPartnerName,
      OfferEventRegister: originalOfferEventRegister,
      CartItem: c
    });

    // ✅ Trigger 2-second auto-save timer
    this.startAutoSaveTimer(rowIndex, c, true);
  }

  // Cell Renderers
  BrandCellRenderer(params: any): string {
    const brand = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;

    // ✅ Always show button - treat all rows as CartItemStatus.ID === 1
    const existingBtn = `<button class="dropdown-trigger dropdown-trigger-brand material-icon-trigger"
                   data-row="${rowIndex}"
                   data-type="brand-collateral"
                   title="View brand alternatives">
           <i class="material-icons">expand_more</i>
         </button>`;

    return `
      <span class="brand-cell-content">
        <span class="brand-text">${brand}</span>
        <span class="cell-actions">
          ${existingBtn}
        </span>
      </span>
    `;
  }

  NameCellRenderer(params: any): string {
    const name = params.value?.toString().trim() ?? '';
    const isEmpty = name.length === 0;
    const rowIndex = params.rowIndex;
    const placeholder = 'Search product or part number...';

    const displayText = isEmpty
      ? `<span class="name-placeholder">${placeholder}</span>`
      : `<span class="name-text">${name}</span>`;

    // Return text + button as siblings, no wrapper
    return `${displayText}<button class="dropdown-trigger material-icon-trigger" style="position: absolute; right: 5px; top: 2.5px;" data-row="${rowIndex}" data-type="productalternatives" title="View Product-Alternatives"><i class="material-icons">expand_more</i></button>`;
  }

  ETACellRenderer(params: any): string {
    const cartItem = params.data?.CartItem;
    const base = (params.data?.eta || '').toString().trim();
    const isStock = cartItem?.SelectedOffer?.IsStockOffer;
    const isManufacturerStock = cartItem?.SelectedOffer?.IsManufacturerStockOffer === true;
    const showStock = isStock && isManufacturerStock !== true;

    let stockSuffix = '';
    if (showStock) {
      const stockQty = cartItem?.SelectedOffer?.StockQuantity;
      // Show (S) for stock, then (X) for quantity if available
      stockSuffix = (base ? ' ' : '') + '(S)';
      if (stockQty != null && stockQty > 0) {
        stockSuffix += `(${stockQty})`;
      }
    }

    const etaText = (base + stockSuffix).trim() || '------';

    return `
      <span class="name-cell-content">
        <span class="${base ? 'eta-text' : 'eta-placeholder'}">${etaText}</span>
      </span>
    `;
  }

  SupplierCellRenderer(params: any): string {
    const supplier = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;

    // ✅ Always treat all rows as CartItemStatus.ID === 1 (green row) - clickable supplier cell
    return `<span class="supplier-cell-clickable-content"
                  data-row="${rowIndex}"
                  data-type="supplierAlternatives"
                  style="cursor: pointer; display: block; width: 100%; height: 100%;">
              ${supplier || ''}
            </span>`;
  }

  priceCellRenderer(params: any): string {
    const price = params.value ?? '';
    const cartItem = params.data?.CartItem;
    const rowIndex = params.rowIndex;

    let showTriangle = false;
    let tooltipText = '';
    let priceClass = '';

    if (Array.isArray(cartItem?.SearchResults)) {
      const special = cartItem.SearchResults.find((x: any) => x.SpecialOffer === true && x.MOQ > 1 && x.FKBrandID == cartItem?.Product?.Brand?.ID);
      if (special && special?.Price?.UIUnitPrice < cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice) {
        showTriangle = true;
        const unitPrice = special?.Price?.UIUnitPrice;
        const currencyName = special?.Price?.Currency?.Symbol ?? special?.Price?.Currency?.Name ?? '';
        const priceStr = typeof unitPrice === 'number' && isFinite(unitPrice) ? unitPrice.toFixed(2) : (unitPrice ?? '');
        tooltipText = `Special: ${priceStr} ${currencyName} - min. x${special?.MOQ ?? 0}`;
      }
    }

    const isSpecialList = cartItem?.SelectedOffer?.Configuration?.SpecialPriceList === true;
    if (isSpecialList) {
      showTriangle = true;
      if (!tooltipText) {
        tooltipText = 'Special price available';
      }
      priceClass = 'special-price-highlight';
    }

    const triangle = showTriangle
      ? `<button class="price-corner-triangle dropdown-trigger"
                 data-row="${rowIndex}"
                 data-type="productSpecials"
                 data-tooltip="${tooltipText}"
                 aria-label="${tooltipText}"></button>`
      : '';

    return `
      <div class="price-cell-wrapper">
        <span class="${priceClass}">${price}</span>
        ${triangle}
      </div>
    `;
  }

  officialListPriceCellRenderer(params: any): string {
    // ✅ List-Price: Manufacturer's list price from Product.Stats.StandardListPrice
    let amount = params.data?.officialListPrice;
    if (amount == null || amount === '') {
      // Fallback: Live product stats
      const olp = params.data?.CartItem?.Product?.Stats?.StandardListPrice;
      amount = olp?.UIUnitPrice;
    }

    if (amount == null || amount === '' || (typeof amount !== 'number' && isNaN(Number(amount)))) {
      return '';
    }

    const amtStr = typeof amount === 'number' ? amount.toFixed(2) : Number(amount).toFixed(2);
    return `<span class="official-list-price">${amtStr}</span>`;
  }

  officialDiscountCellRenderer(params: any): string {
    const cartItem = params.data?.CartItem;
    // ✅ First try row data field (set in loadOfferGridData), then fallback to nested CartItem path
    let discount = params.data?.officialDiscount;
    if (discount == null || discount === '') {
      discount = cartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value;
    }
    const adminPriceEdit = cartItem?.AdminPriceEdit === true;
    const rowIndex = params.rowIndex;

    if (discount == null || discount === '' || discount === 0) {
      return '';
    }

    const discountStr = typeof discount === 'number' ? discount.toFixed(2) : Number(discount).toFixed(2);
    const revertIcon = adminPriceEdit
      ? `<i class="material-icons revert-pencil"
            data-row="${rowIndex}"
            data-type="revert-discount"
            style="font-size: 14px; color: #f60; cursor: pointer; margin-left: 4px;"
            title="Revert to original">edit</i>`
      : '';

    return `<span class="discount-cell-content">${discountStr}%${revertIcon}</span>`;
  }

  // Open Red Row Edit Popup
  OpenRedRowEditPopup(cartItem: any, rowIndex: number): void {
    this.CurrentRedRowCartItem = cartItem;
    this.CurrentRedRowIndex = rowIndex;
    this.ShowRedRowEditPopup = true;
  }

  COOCellRenderer(params: any): string {
    const coo = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;

    // ✅ Always clickable - treat all rows as CartItemStatus.ID === 1
    return `
      <span class="coo-cell-clickable"
            data-row="${rowIndex}"
            data-type="coo-search"
            style="display: flex; align-items: center; width: 100%; height: 100%; cursor: pointer;"
            title="Click to select country of origin">
        <span class="coo-text">${coo}</span>
      </span>
    `;
  }

  // Add more rows functionality - adds to CurrentOrder.Cart.Items
  addMoreRows(count: number = 50): void {
    if (!this.offerGridApi) return;

    // ✅ Ensure CurrentOrder.Cart.Items exists
    if (!this.CurrentOrder) {
      this.CurrentOrder = {};
    }
    if (!this.CurrentOrder.Cart) {
      this.CurrentOrder.Cart = {};
    }
    if (!this.CurrentOrder.Cart.Items) {
      this.CurrentOrder.Cart.Items = [];
    }

    const currentCount = this.offerGridApi.getDisplayedRowCount();
    const newRows: any[] = [];

    // Pre-populate values from CurrentOrder
    const partnerName = this.CurrentOrder?.Cart?.Partner?.Name || '';
    const offerID = this.CurrentOrder?.ID || '';
    const offerDBID = this.CurrentOrder?.DBID || 0;
    const referenceNumber = this.CurrentOrder?.ReferenceNumber || '';
    const debatorPO = this.CurrentOrder?.DebatorPO || '';
    const cartID = this.CurrentOrder?.Cart?.ID || 0;
    const offerEventRegister = this.CurrentOrder?.EventRegister || null;

    for (let i = 0; i < count; i++) {
      // ✅ Create empty CartItem object (like create-new-quotation)
      const emptyCartItem: any = {
        Product: {
          Brand: {},
          Stats: {}
        },
        SelectedOffer: {
          LeadTime: {}
        },
        Quantity: null,
        Price: {},
        // ✅ Pre-populate CartItemOrderInfo for backend save operations
        CartItemOrderInfo: {
          OrderID: offerID,
          OrderDBID: offerDBID,
          ReferenceNumber: referenceNumber,
          DebatorPO: debatorPO,
          OrderPartner: this.CurrentOrder?.Cart?.Partner || {},
          OrderEventRegister: offerEventRegister
        }
      };

      const row = {
        index: currentCount + i + 1,
        brand: '',
        partNumber: '',
        name: '',
        quantity: null,
        officialListPrice: null,
        officialDiscount: null,
        price: null,
        total: null,
        eta: '',
        supplier: '',
        purchase: null,
        hscode: '',
        coo: '',
        weight: '',
        CartItem: emptyCartItem,
        // ✅ Pre-populate offer context columns (like existing rows)
        PartnerName: partnerName,
        OfferID: offerID,
        OfferDBID: offerDBID,
        ReferenceNumber: referenceNumber,
        DebatorPO: debatorPO,
        CartID: cartID,
        OfferEventRegister: offerEventRegister
      };

      // ✅ Add to CurrentOrder.Cart.Items
      this.CurrentOrder.Cart.Items.push(emptyCartItem);

      this.CartItemRows.push(row);
      newRows.push(row);
    }

    // 🔥 Update the grid
    this.offerGridApi.applyTransaction({ add: newRows });
    console.log('✅ Added', count, 'rows to grid and CurrentOrder.Cart.Items');
  }

  deleteRow(rowIndex: number): void {
    if (!this.offerGridApi) return;

    const rowNode = this.offerGridApi.getDisplayedRowAtIndex(rowIndex);
    if (rowNode) {
      this.offerGridApi.applyTransaction({ remove: [rowNode.data] });
    }
  }

  // Clear grid
  ClearGrid(): void {
    this.CartItemRows = [];
    this.offerGridRowData = [];
    if (this.offerGridApi) {
      this.offerGridApi.setRowData([]);
    }
  }

  // ✅ Update Offer Shipping Address and Shipping Settings
  UpdateOfferShippingAddress(): void {
    if (!this.CurrentOrder?.ShippingAddress) {
      this.parent.openSnackBar('No shipping address to save', 'OK', 'alert-info-snackbar');
      return;
    }

    if (!this.CurrentOrder?.DBID || this.CurrentOrder.DBID <= 0) {
      this.parent.openSnackBar('Offer not saved yet', 'OK', 'alert-info-snackbar');
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      // ✅ Pass PurchaseOrder structure as expected by backend
      PurchaseOrder: {
        DBID: this.CurrentOrder.DBID,
        ShippingAddress: this.CurrentOrder.ShippingAddress,
        Cart: {
          Partner: { ID: this.CurrentOrder.Cart?.Partner?.ID },
          ShippingResponsability: this.CurrentOrder.Cart?.ShippingResponsability,
          ShippingServiceType: this.CurrentOrder.Cart?.ShippingServiceType,
          ShippingCompany: this.CurrentOrder.Cart?.ShippingCompany,
          ShippingCost: this.CurrentOrder.Cart?.ShippingCost,
          HasInsurance: this.CurrentOrder.Cart?.HasInsurance,
          PaymentTerm: this.CurrentOrder.Cart?.PaymentTerm,
          Weight: this.CurrentOrder.Cart?.Weight,
          WeightMeasurementType: this.CurrentOrder.Cart?.WeightMeasurementType
        }
      }
    };

    this.parent.loading = true;
    this.managementService.UpdatePurchaseOrderShippingAddress(request).subscribe((response: any) => {
      this.parent.loading = false;
      if (response["Status"] === 1) {
        this.parent.openSnackBar(response["Message"] || 'Shipping information saved', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response["Message"] || 'Error saving shipping information', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.parent.loading = false;
      console.error('UpdatePurchaseOrderShippingAddress error:', error);
      this.parent.openSnackBar('Error saving shipping information', 'OK', 'alert-info-snackbar');
    });
  }

  // Grid cell button click handler
  onGridCellButtonClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const button = target.closest('[data-type]') as HTMLElement;
    if (!button) return;

    const type = button.getAttribute('data-type');
    const rowIndexStr = button.getAttribute('data-row');
    const rowIndex = rowIndexStr ? parseInt(rowIndexStr, 10) : -1;

    if (rowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(rowIndex);
    const rowData = rowNode?.data;
    const cartItem = rowData?.CartItem;

    this.ClickedRow = rowData;
    this.ClickedRowIndex = rowIndex;

    switch (type) {
      case 'delete-row':
        this.deleteRow(rowIndex);
        break;

      case 'brand-collateral':
        this.ShowBrandCollateral = true;
        this.calculatePopupPosition(button, 'brand');
        // ✅ Load brand collateral
        if (cartItem) {
          this.SearchIndustryProductB2BBrandsVersion2(rowIndex, cartItem);
        }
        break;

      case 'productalternatives':
        this.ShowETAAlternatives = true;
        this.ShowSearchResultsAlternatives = false;
        this.selectedNamePopupTab = 1;
        this.calculatePopupPosition(button, 'name');
        // ✅ Load side offers for Name popup Tab 1 (Other Offers)
        if (cartItem?.Product?.ID) {
          const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetIndustryProductCalculatedSideOffers(rowIndex, cartItem.Product.ID, offerId);
        }
        break;

      case 'fallback':
        this.ShowFallbackSelection = true;
        this.calculatePopupPosition(button, 'name');
        break;

      case 'supplierAlternatives':
        this.ShowSupplierAlternatives = true;
        this.calculatePopupPosition(button, 'supplier');
        // ✅ Load side offers for supplier alternatives
        if (cartItem?.Product?.ID) {
          const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetIndustryProductCalculatedSideOffers(rowIndex, cartItem.Product.ID, offerId);
        }
        break;

      case 'supplier-search':
        this.PartnerSearchRowIndex = rowIndex;
        this.ShowPartnerSearchPopup = true;
        this.calculatePopupPosition(button, 'supplier');
        break;

      case 'clear-supplier':
        if (cartItem?.SelectedOffer) {
          cartItem.SelectedOffer.Partner = null;
        }
        this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
        break;

      case 'coo-search':
        this.COOSearchRowIndex = rowIndex;
        this.ShowCOOSearchPopup = true;
        this.calculatePopupPosition(button, 'coo');
        break;

      case 'productSpecials':
        this.ShowSearchResultsAlternatives = true;
        this.selectedNamePopupTab = 1;
        this.calculatePopupPosition(button, 'name');
        break;

      case 'revert-discount':
        // Revert discount to original value
        if (cartItem) {
          cartItem.AdminPriceEdit = false;
          this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
        }
        break;
    }
  }

  // Calculate popup position relative to clicked element
  calculatePopupPosition(element: HTMLElement, type: string): void {
    const rect = element.getBoundingClientRect();

    // Find the closest ProductsAGGridContainer (works for both popup and Products tab grids)
    const gridContainer = element.closest('.ProductsAGGridContainer') || document.querySelector('.ProductsAGGridContainer');
    const containerRect = gridContainer?.getBoundingClientRect() || { top: 0, left: 0, width: 1000 };

    const top = rect.bottom - containerRect.top + 5;
    const left = rect.left - containerRect.left;

    switch (type) {
      case 'brand':
        this.BrandPopupPosition = { top: `${top}px`, left: `${left}px`, width: '250px' };
        break;
      case 'name':
        // ✅ Name popup spans full grid width
        this.SearchResultsPosition = { top: `${top}px`, left: '0px', width: '100%' };
        break;
      case 'supplier':
        this.SupplierPopupPosition = { top: `${top}px`, left: `${left}px`, width: '450px' };
        break;
      case 'coo':
        this.COOPopupPosition = { top: `${top}px`, left: `${left}px`, width: '250px' };
        break;
    }
  }

  // Close all popups
  closeAllPopups(): void {
    this.ShowSearchResultsAlternatives = false;
    this.ShowETAAlternatives = false;
    this.ShowSupplierAlternatives = false;
    this.ShowFallbackSelection = false;
    this.ShowBrandCollateral = false;
    this.ShowBrandCollateralNewProduct = false;
    this.ShowRedRowETAPopup = false;
    this.ShowWeightPopup = false;
    this.ShowRedRowEditPopup = false;
    this.ShowPartnerSearchPopup = false;
    this.ShowCOOSearchPopup = false;
  }

  // Select alternative offer
  selectAlternativeOffer(offer: any): void {
    if (!this.ClickedRow || this.ClickedRowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (cartItem) {
      cartItem.SelectedOffer = offer;
      cartItem.Price = offer.Price || offer.SellPrice;
    }

    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
    this.closeAllPopups();
  }

  // Select partner for red row
  selectPartner(partner: any): void {
    if (this.PartnerSearchRowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.PartnerSearchRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (cartItem) {
      if (!cartItem.SelectedOffer) {
        cartItem.SelectedOffer = {};
      }
      cartItem.SelectedOffer.Partner = partner;
    }

    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
    this.ShowPartnerSearchPopup = false;
    this.PartnerSearchRowIndex = -1;
  }

  // Select COO for row
  selectCOO(country: any): void {
    if (this.COOSearchRowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.COOSearchRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (cartItem) {
      if (!cartItem.Product) {
        cartItem.Product = {};
      }
      if (!cartItem.Product.Stats) {
        cartItem.Product.Stats = {};
      }
      cartItem.Product.Stats.COO = country;
    }

    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
    this.ShowCOOSearchPopup = false;
    this.COOSearchRowIndex = -1;
  }

  // ✅ Get side offers for supplier alternatives popup
  GetIndustryProductCalculatedSideOffers(rowIndex: number, IndustryProductID: number, offerId: number): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      IndustryProductID: IndustryProductID,
      SelectedOfferID: offerId,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: this.CurrentOrder?.Cart?.Currency,
        ConfigStatus: { ID: -9000 } // VisibleOnlyForAdminPurchases
      }
    };

    this.SideOffers = [];
    this.LoadingSideOffers = true;

    this.B2BService.GetIndustryProductCalculatedSideOffers(request).subscribe(response => {
      if (response["Status"] == 1) {
        const cartItems = JSON.parse(JSON.stringify(response["CartItems"]));
        // Sort by ListPrice ascending (best price first)
        this.SideOffers = cartItems.sort((a: any, b: any) => {
          const priceA = a?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          const priceB = b?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          return priceA - priceB;
        });
        this.OriginalSideOffers = JSON.parse(JSON.stringify(this.SideOffers));
        this.SupplierPopupSearchTerm = '';
        this.SupplierPopupSearchResults = [];
      }
      this.LoadingSideOffers = false;
    });
  }

  // ✅ Search partners in supplier popup
  SearchSupplierPopup(): void {
    const searchTerm = this.SupplierPopupSearchTerm?.trim() || '';

    if (searchTerm.length === 0) {
      this.SupplierPopupSearchResults = [];
      return;
    }

    if (searchTerm.length < 2) {
      this.SupplierPopupSearchResults = [];
      return;
    }

    const request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: 1,
      PageSize: 20,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: null
    };

    this.LoadingSupplierPopupSearch = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
      if (response["Status"] === 1) {
        this.SupplierPopupSearchResults = response["Partners"] ?? [];
      }
      this.LoadingSupplierPopupSearch = false;
    });
  }

  // ✅ Select a side offer from the Supplier Alternatives popup
  SelectSideOffer(selectedCartItem: any): void {
    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    // Update CartItem.SelectedOffer with the clicked popup row's SelectedOffer
    cartItem.SelectedOffer = JSON.parse(JSON.stringify(selectedCartItem.SelectedOffer));

    // Update CartItem.Product.ListPriceOffers[0] with the clicked popup row's SelectedOffer
    if (cartItem.Product && cartItem.Product.ListPriceOffers && cartItem.Product.ListPriceOffers.length > 0) {
      cartItem.Product.ListPriceOffers[0] = JSON.parse(JSON.stringify(selectedCartItem.SelectedOffer));
    }

    // Update row data fields
    rowNode.data.supplier = selectedCartItem.SelectedOffer?.Partner?.Name || '';
    rowNode.data.purchase = selectedCartItem.SelectedOffer?.ListPrice || '';
    const leadTime = selectedCartItem.SelectedOffer?.LeadTime;
    rowNode.data.eta = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

    // Refresh the grid row
    rowNode.setData(rowNode.data);
    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });

    // Close the popup
    this.ShowSupplierAlternatives = false;

    // ✅ Trigger 2-second auto-save timer
    this.startAutoSaveTimer(this.ClickedRowIndex, cartItem, false);
  }

  // ✅ Select partner from search results
  SelectPartnerFromSearch(partner: any): void {
    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    if (!cartItem.SelectedOffer) {
      cartItem.SelectedOffer = {};
    }
    cartItem.SelectedOffer.Partner = partner;

    // Update row data
    rowNode.data.supplier = partner?.Name || '';

    // Refresh the grid row
    rowNode.setData(rowNode.data);
    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });

    // Close the popup
    this.ShowSupplierAlternatives = false;

    // ✅ Trigger 2-second auto-save timer
    this.startAutoSaveTimer(this.ClickedRowIndex, cartItem, false);
  }

  // ✅ Get brand collateral for brand popup
  SearchIndustryProductB2BBrandsVersion2(rowIndex: number, cartItem: any): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      SearchTerm: cartItem?.UIProductValue || cartItem?.Product?.Name,
    };

    this.ShowBrandCollateral = true;
    this.LoadingSideOffers = true;

    this.B2BService.SearchIndustryProductB2BBrandsVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        this.BrandCollateralList = JSON.parse(JSON.stringify(response["Brands"] ?? []));
      }
      this.LoadingSideOffers = false;
    });
  }

  // ✅ Switch to selected brand
  SwitchGridBrandVersion2(brand: any): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CartItem: this.ClickedRow?.CartItem,
      Pager: { PageIndex: 1, PageSize: 25 },
      MaxRank: 100,
      UISelectedBrand: JSON.parse(JSON.stringify(brand)),
    };

    this.LoadingSideOffers = true;

    this.B2BService.SwitchGridBrandVersion2(request).subscribe(response => {
      if (response["Status"] == 1) {
        const c = JSON.parse(JSON.stringify(response["CartItem"]));
        const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
        if (rowNode) {
          console.log(`🔀 [PO-SwitchGridBrandVersion2] row=${this.ClickedRowIndex}. Replacing CartItem. OLD ID=${rowNode.data.CartItem?.ID}, NEW brand=${c?.Product?.Brand?.Name}`);
          rowNode.data.CartItem = c;
          rowNode.data.brand = c?.Product?.Brand?.Name || '';
          rowNode.data.name = c?.UIProductValue || c?.Product?.Name || '';
          rowNode.setData(rowNode.data);
          this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
        }
      }
      this.LoadingSideOffers = false;
      this.ShowBrandCollateral = false;
    });
  }

  // ✅ Handle Name popup tab change
  onNamePopupTabChange(tabIndex: number): void {
    this.selectedNamePopupTab = tabIndex;

    if (tabIndex === 1) {
      // Tab 1: Other Offers - reload side offers
      const cartItem = this.ClickedRow?.CartItem;
      if (cartItem?.Product?.ID) {
        const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
        this.GetIndustryProductCalculatedSideOffers(this.ClickedRowIndex, cartItem.Product.ID, offerId);
      }
    } else if (tabIndex === 2) {
      // Tab 2: Similar Products - placeholder for future implementation
      this.SideOffers = [];
    }
  }

  // ✅ Switch grid product offer (select from Name popup) - calls backend API like quotations/new
  SwitchGridProductOffer(item: any): void {
    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    // Get CartItem.ID for preserving after update
    const cartItemID = cartItem?.ID || 0;

    // Get the clicked item's currency for PrefferedCurrency
    const clickedItemCurrency = item?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;

    // ✅ Clone the CartItem and ensure Product.ListPriceOffers is populated (required by backend)
    const cartItemForRequest = JSON.parse(JSON.stringify(this.ClickedRow?.CartItem));
    if (cartItemForRequest?.Product && !cartItemForRequest.Product.ListPriceOffers) {
      // Backend requires ListPriceOffers - populate from SelectedOffer if missing
      cartItemForRequest.Product.ListPriceOffers = [cartItemForRequest.SelectedOffer];
    }

    // Build request like create-new-quotation does
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.CurrentOrder?.Cart?.Partner?.ID,
      SelectedOffer: item.Product?.ListPriceOffers?.[0] || item.SelectedOffer,
      CartItem: cartItemForRequest,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: clickedItemCurrency,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.LoadingSideOffers = true;

    this.B2BService.SwitchGridProductOffer(request).subscribe(response => {
      if (response["Status"] == 1) {
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;

        // ✅ Preserve the original CartItem.ID
        c.ID = cartItemID;

        // Apply to row
        this.applySearchResultToRow(this.ClickedRowIndex, c, this.offerGridApi);
      }

      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
    });
  }

  /**
   * Parse a number from any format (US, EU, or mixed).
   * Handles:
   * - "1029.99" → 1029.99 (US format)
   * - "1,029.99" → 1029.99 (US format with thousands)
   * - "1.029,99" → 1029.99 (EU format with thousands)
   * - "1029,99" → 1029.99 (EU format)
   */
  parseNumberFromAnyFormat(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Convert to string
    let str = String(value).trim();

    // Remove any whitespace
    str = str.replace(/\s+/g, '');

    // If empty after trimming, return null
    if (str === '') {
      return null;
    }

    // Count dots and commas
    const dotCount = (str.match(/\./g) || []).length;
    const commaCount = (str.match(/,/g) || []).length;

    // Determine format based on separators
    if (dotCount === 0 && commaCount === 0) {
      // No separators - just a number
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount === 1 && commaCount === 0) {
      // Only dot - assume decimal separator (US format)
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount === 0 && commaCount === 1) {
      // Only comma - could be thousands or decimal separator
      const commaPos = str.indexOf(',');
      const afterComma = str.substring(commaPos + 1);

      if (afterComma.length <= 2) {
        // Decimal separator (EU format)
        str = str.replace(',', '.');
      } else {
        // Thousands separator
        str = str.replace(',', '');
      }

      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount > 1 && commaCount === 0) {
      // Multiple dots - assume thousands separators (EU format)
      str = str.replace(/\./g, '');
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (commaCount > 1 && dotCount === 0) {
      // Multiple commas - assume thousands separators
      str = str.replace(/,/g, '');
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount >= 1 && commaCount >= 1) {
      // Both dots and commas - determine which is decimal separator
      const lastDotPos = str.lastIndexOf('.');
      const lastCommaPos = str.lastIndexOf(',');

      if (lastDotPos > lastCommaPos) {
        // Dot is decimal separator (US format)
        str = str.replace(/,/g, '');
      } else {
        // Comma is decimal separator (EU format)
        str = str.replace(/\./g, '');
        str = str.replace(',', '.');
      }

      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    }

    // Fallback
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  }

  // ✅ Select purchase currency for a row
  selectPurchaseCurrency(currency: any) {
    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(this.purchaseCurrencyRowIndex);
    if (!rowNode) {
      this.showPurchaseCurrencyDropdown = false;
      return;
    }

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) {
      this.showPurchaseCurrencyDropdown = false;
      return;
    }

    // Check for multi-select bulk update - if multiple items are selected, apply to all
    const selectedItems = this.getSelectedProductItems();
    const isBulkUpdate = selectedItems.length > 1;

    if (isBulkUpdate) {
      // Apply PurchaseCurrency to ALL selected items
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
          item.CartItem.SelectedOffer.PurchaseCurrency = JSON.parse(JSON.stringify(currency));
          if (item.CartItem.Product?.ListPriceOffers?.length > 0) {
            item.CartItem.Product.ListPriceOffers[0].PurchaseCurrency = JSON.parse(JSON.stringify(currency));
          }
        }
      });
      this.showPurchaseCurrencyDropdown = false;
      this.productsGridApi.refreshCells({ columns: ['purchaseCurrency'], force: true });
      this.BulkUpdateSelectedCartItems(selectedItems);
    } else {
      // Single item update
      if (!cartItem.SelectedOffer) {
        cartItem.SelectedOffer = {};
      }

      const currentPurchaseCurrencyId = cartItem.SelectedOffer.PurchaseCurrency?.ID;
      if (currentPurchaseCurrencyId === currency.ID) {
        this.showPurchaseCurrencyDropdown = false;
        return;
      }

      cartItem.SelectedOffer.PurchaseCurrency = currency;

      if (cartItem.Product?.ListPriceOffers?.length > 0) {
        cartItem.Product.ListPriceOffers[0].PurchaseCurrency = currency;
      }

      this.showPurchaseCurrencyDropdown = false;

      this.productsGridApi.refreshCells({
        rowNodes: [rowNode],
        columns: ['purchaseCurrency'],
        force: true
      });

      // ✅ Trigger 2-second auto-save timer
      this.startAutoSaveTimer(this.purchaseCurrencyRowIndex, cartItem, true);
    }
  }

  // ✅ Sell Currency (SC) popup methods
  selectSellCurrency(currency: any): void {
    this.selectedSellCurrency = currency;
    this.showSellCurrencyResults = false;
  }

  confirmChangeSellCurrency(): void {
    if (!this.selectedSellCurrency) {
      this.parent.openSnackBar('Please select a currency', 'OK', 'alert-info-snackbar');
      return;
    }
    if (!this.selectedOfferDBIDForCurrency || this.selectedOfferDBIDForCurrency <= 0) {
      this.parent.openSnackBar('Offer not saved yet', 'OK', 'alert-info-snackbar');
      return;
    }

    this.parent.loading = true;
    this.showSellCurrencyResults = false;

    const request = {
      PurchaseOrderDBID: this.selectedOfferDBIDForCurrency,
      CurrencyID: this.selectedSellCurrency.ID,
      NewCurrency: this.selectedSellCurrency,
      PurchaseOrder: this.CurrentOrder,
      Language: this.parent.getLanguage(),
      User: this.parent.User,
    };

    this.managementService.ChangePurchaseOrderCurrency(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1) {
          // Update CurrentOrder with the returned PurchaseOrder (with exchanged prices)
          if (response.PurchaseOrder) {
            this.CurrentOrder = response.PurchaseOrder;
            // Update the corresponding order in Orders array to refresh OrderCardRow
            const orderIndex = (this.Orders as any[]).findIndex((o: any) => o.ID === this.CurrentOrder.ID);
            if (orderIndex !== -1) {
              this.Orders[orderIndex] = response.PurchaseOrder;
              this.Orders = [...(this.Orders as any[])]; // Trigger Angular change detection
            }
          }
          // Reload offer items to get updated prices
          this.loadOfferGridData();
          this.ShowChangeSellCurrencyPopup = false;
          this.parent.openSnackBar('Currency updated with exchanged prices', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating currency', 'OK', 'alert-info-snackbar');
        }
      },
      error: (err: any) => {
        this.parent.loading = false;
        this.parent.openSnackBar('Error updating currency', 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ========== NAME COLUMN PRODUCT SEARCH ==========

  /**
   * Search for products to replace in an existing offer
   * Called when user edits the Name column - directly applies result like quotations/new
   */
  searchOfferProduct(rowIndex: number, searchTerm: string, quantity: number): void {
    if (!searchTerm || searchTerm.trim().length < 2) {
      return;
    }

    // Get the CartItem ID for this row (try EditContainer grid first, then Products tab grid)
    const gridApi = this.offerGridApi || this.productsGridApi;
    const rowNode = gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    // Get currency from the row's CartItem or current order
    const itemCurrency = rowNode?.data?.CartItem?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;

    // ✅ Use the same request format as quotations/new (SearchIndustryProductB2BOffersWithMasterData)
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      BrandID: null,
      SearchTerm: searchTerm,
      Quantity: quantity,
      Pager: { PageIndex: 1, PageSize: 10 },
      MaxRank: 10,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: itemCurrency,
        ConfigStatus: { ID: -9000 }
      },
      // ─── Pre-loaded data: eliminates sequential DB fetches per search ───
      PreloadedCurrencies: this.parent.CartMasterData?.Currencies || null,
      PreloadedDecimalPrecisions: this.parent.CartMasterData?.DecimalPrecisions || null,
      PreloadedUserB2BSettings: this.parent.User?.B2BSettings || null,
      PreloadedPartner: this.parent.B2BPartner || null,
      PreloadedIsBlocked: false,
    };

    // Show loading state on the row
    if (rowNode.data.CartItem) {
      rowNode.data.CartItem.LoadingCell = true;
    }
    gridApi.refreshCells({ rowNodes: [rowNode], force: true });

    // ✅ Use Combined endpoint - handles short search terms (< 5 chars) via parallel FTS + ExactMatch
    this.B2BService.SearchIndustryProductB2BOffersWithMasterDataCombined(request).subscribe({
      next: (response: any) => {
        if (response.Status === 1 || response.Status === -2) {
          const c = JSON.parse(JSON.stringify(response.CartItem));
          c.LoadingCell = false;

          // ✅ Apply the result directly to the row (like quotations/new)
          this.applySearchResultToRow(rowIndex, c, gridApi);
        } else {
          // No results - remove loading state
          if (rowNode.data.CartItem) {
            rowNode.data.CartItem.LoadingCell = false;
          }
          gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        }
      },
      error: () => {
        if (rowNode.data.CartItem) {
          rowNode.data.CartItem.LoadingCell = false;
        }
        gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error searching products', 'OK', 'alert-info-snackbar');
      }
    });
  }

  /**
   * Apply search result directly to the row (like quotations/new does)
   */
  applySearchResultToRow(rowIndex: number, resultCartItem: any, gridApi: any): void {
    const rowNode = gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data.CartItem;
    if (!cartItem) return;

    // ✅ PRESERVE the original CartItem.ID, UIID, and order info (for DB update)
    const originalCartItemID = cartItem.ID;
    const originalUIID = cartItem.UIID;
    const originalOfferDBID = rowNode.data.OfferDBID;
    const originalOfferID = rowNode.data.OfferID;
    const originalReferenceNumber = rowNode.data.ReferenceNumber;
    const originalDebatorPO = rowNode.data.DebatorPO;
    const originalPartnerName = rowNode.data.PartnerName;
    const originalOfferEventRegister = rowNode.data.OfferEventRegister;
    const originalCartItemOrderInfo = cartItem.CartItemOrderInfo;

    // Copy new product data from result
    const c = JSON.parse(JSON.stringify(resultCartItem));
    c.LoadingCell = false;

    // ✅ RESTORE the original IDs and order info
    c.ID = originalCartItemID;
    c.UIID = originalUIID;
    c.CartItemOrderInfo = originalCartItemOrderInfo;

    // Extract display values from CartItem (same as create-new-quotation)
    const brand = c?.Product?.Brand?.Name ?? '';
    const name = c?.UIProductValue ?? c?.Product?.Name ?? '';
    const partNumber = c?.Product?.PartNumber ?? '';
    const quantity = c?.Quantity ?? rowNode.data.quantity ?? '';

    // ✅ Price logic: use SellPrice like quotations/new
    const sellPrice = c?.SelectedOffer?.SellPrice?.UIUnitPrice;
    const showPrice = sellPrice > 0;
    const price = showPrice ? sellPrice : (c?.Price?.UIUnitPrice ?? '');
    const total = c?.Price?.UIQtyPrice ?? '';

    const eta = c?.SelectedOffer?.LeadTime?.UIOutput ??
      (c?.SelectedOffer?.LeadTime?.Units > 0
        ? `${c.SelectedOffer.LeadTime.Units} ${c.SelectedOffer.LeadTime.Type?.Name || ''}`
        : '------');
    const supplier = c?.SelectedOffer?.Partner?.Name ?? '';
    const purchase = c?.SelectedOffer?.ListPrice ?? '';
    const hscode = c?.Product?.Stats?.HSCode ?? '';
    const coo = c?.Product?.Stats?.COO?.ShortName ?? '';
    const weight = c?.Product?.Stats?.Weight != null
      ? `${c.Product.Stats.Weight} ${c.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
      : '';

    console.log('🔍 applySearchResultToRow - resultCartItem:', resultCartItem);
    console.log('🔍 applySearchResultToRow - extracted values:', { brand, partNumber, name, quantity, price, total, eta, supplier, purchase, hscode, coo, weight });

    const newRowData = {
      index: rowNode.data.index,
      brand,
      partNumber,
      name,
      quantity,
      price,
      total,
      eta,
      supplier,
      purchase,
      hscode,
      coo,
      weight,
      // Preserve order info columns
      OfferDBID: originalOfferDBID,
      OfferID: originalOfferID,
      ReferenceNumber: originalReferenceNumber,
      DebatorPO: originalDebatorPO,
      PartnerName: originalPartnerName,
      OfferEventRegister: originalOfferEventRegister,
      CartItem: c
    };

    // ✅ Use setData like quotations/new to properly update the row
    rowNode.setData(newRowData);

    // ✅ Also update ProductItems array (source data)
    if (this.ProductItems && rowIndex >= 0 && rowIndex < this.ProductItems.length) {
      this.ProductItems[rowIndex] = newRowData;
    }

    // ✅ Refresh the row after setData (like quotations/new does)
    gridApi.refreshCells({ rowNodes: [rowNode], force: true });

    // Save the change to backend using AddUpdatePurchaseOrderCartItem
    this.AddUpdatePurchaseOrderCartItem({ data: newRowData, node: rowNode, api: gridApi });
  }

  AddUpdatePurchaseOrderCartItem(params: any) {
    console.log('💾 AddUpdatePurchaseOrderCartItem called');
    console.log('   params.data:', params.data);

    const cartItem = params.data?.CartItem;

    // Debug: Check both sources for PurchaseOrderDBID
    console.log('   cartItem?.CartItemOrderInfo?.OrderDBID:', cartItem?.CartItemOrderInfo?.OrderDBID);
    console.log('   params.data?.PurchaseOrderDBID:', params.data?.PurchaseOrderDBID);
    console.log('   params.data?.OfferDBID:', params.data?.OfferDBID);
    console.log('   this.CurrentOrder?.DBID:', this.CurrentOrder?.DBID);

    // Try CartItemOrderInfo.OrderDBID first, fallback to row's PurchaseOrderDBID, then OfferDBID, then CurrentOrder.DBID
    const purchaseOrderDBID = cartItem?.CartItemOrderInfo?.OrderDBID || params.data?.PurchaseOrderDBID || params.data?.OfferDBID || this.CurrentOrder?.DBID;

    console.log('   cartItem exists:', !!cartItem);
    console.log('   cartItem.ID:', cartItem?.ID);
    console.log('   ✅ Final purchaseOrderDBID:', purchaseOrderDBID);

    if (!cartItem || !purchaseOrderDBID) {
      console.log('❌ Cannot save - missing data:');
      console.log('   cartItem:', cartItem);
      console.log('   purchaseOrderDBID:', purchaseOrderDBID);
      console.log('   params.data:', params.data);
      this.parent.openSnackBar('Cannot save: missing cart item or purchase order ID', 'OK', 'alert-info-snackbar');
      return;
    }

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItem: cartItem,
      PurchaseOrderDBID: purchaseOrderDBID
    };

    console.log('📤 Sending request to AddUpdatePurchaseOrderCartItem API:');
    console.log('   Language:', request.Language);
    console.log('   User.ID:', request.User?.ID);
    console.log('   CartItem.ID:', request.CartItem?.ID);
    console.log('   CartItem.Quantity:', request.CartItem?.Quantity);
    console.log('   CartItem.Price:', request.CartItem?.Price);
    console.log('   CartItem.SelectedOffer:', request.CartItem?.SelectedOffer);
    console.log('   PurchaseOrderDBID:', request.PurchaseOrderDBID);
    console.log('   Full CartItem object:', JSON.stringify(request.CartItem, null, 2));

    // Use savingGridRow for minimalist spinner (not parent.loading which blocks entire UI)
    this.savingGridRow = true;
    this.managementService.AddUpdatePurchaseOrderCartItem(request).subscribe((response: any) => {
      this.savingGridRow = false;
      console.log('📥 AddUpdatePurchaseOrderCartItem response:', response);
      console.log('   Status:', response.Status);
      console.log('   Message:', response.Message);

      if (response.Status === 1) {
        console.log(`✅ [PO-AddUpdateCartItem] SUCCESS. Response CartItem.ID=${response.CartItem?.ID}, Qty=${response.CartItem?.Quantity}`);
        // Success - no snackbar, just silently update the row
        if (response.CartItem) {
          params.data.CartItem = response.CartItem;
          // ✅ Also update CurrentOrder.Cart.Items to keep references in sync
          this.syncCartItemToCurrentOrder(response.CartItem);
          params.api.refreshCells({ rowNodes: [params.node], force: true });
        }
        // ✅ Save undo snapshot AFTER successful save
        this.saveUndoSnapshot();
      } else {
        console.log('❌ Save failed:', response.Message);
        this.parent.openSnackBar(response.Message || 'Error saving', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.savingGridRow = false;
      console.log('❌ API Error:', error);
      console.log('   Error status:', error.status);
      console.log('   Error message:', error.message);
      console.log('   Error details:', error.error);
      this.parent.openSnackBar('Error saving', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Auto-save delay localStorage methods
  private loadAutoSaveDelay(): void {
    const stored = localStorage.getItem(this.AUTO_SAVE_DELAY_KEY);
    if (stored) {
      const val = parseFloat(stored);
      if (!isNaN(val) && val >= 0.25 && val <= 2.00) {
        this.autoSaveDelay = val;
      }
    }
  }

  private saveAutoSaveDelay(): void {
    localStorage.setItem(this.AUTO_SAVE_DELAY_KEY, this.autoSaveDelay.toFixed(2));
  }

  increaseAutoSaveDelay(): void {
    if (this.autoSaveDelay < 2.00) {
      this.autoSaveDelay = Math.min(2.00, Math.round((this.autoSaveDelay + 0.25) * 100) / 100);
      this.saveAutoSaveDelay();
    }
  }

  decreaseAutoSaveDelay(): void {
    if (this.autoSaveDelay > 0.25) {
      this.autoSaveDelay = Math.max(0.25, Math.round((this.autoSaveDelay - 0.25) * 100) / 100);
      this.saveAutoSaveDelay();
    }
  }

  // ✅ Auto-save timer methods - configurable delay after cell edit
  startAutoSaveTimer(rowIndex: number, cartItem: any, isProductsGrid: boolean, columnField: string = ''): void {
    // Check the appropriate auto-save toggle for each grid
    if (isProductsGrid && !this.AutoSave) return;
    if (!isProductsGrid && !this.OfferAutoSave) return;

    // For the single-order popup grid, only auto-save if the order already exists (has a DBID)
    if (!isProductsGrid && (!this.CurrentOrder?.DBID || this.CurrentOrder.DBID <= 0)) return;

    // Cancel any existing timer
    this.cancelAutoSaveTimer();

    // Store pending save info
    this.autoSaveRowIndex = rowIndex;
    this.autoSavePendingCartItem = cartItem;
    this.autoSaveIsProductsGrid = isProductsGrid;
    this.autoSaveLastEditedColumn = columnField;

    const delayMs = Math.round(this.autoSaveDelay * 1000);
    console.log(`⏱️ AUTO-SAVE: Starting ${this.autoSaveDelay}s timer for row`, rowIndex, 'column', columnField);

    // Start configurable timer
    this.autoSaveTimer = setTimeout(() => {
      this.executeAutoSave();
    }, delayMs);
  }

  cancelAutoSaveTimer(): void {
    if (this.autoSaveTimer) {
      clearTimeout(this.autoSaveTimer);
      this.autoSaveTimer = null;
      console.log('⏱️ AUTO-SAVE: Timer cancelled');
    }
  }

  executeAutoSave(): void {
    if (!this.autoSavePendingCartItem) {
      console.log('⏱️ AUTO-SAVE: No pending cart item to save');
      return;
    }

    console.log('⏱️ AUTO-SAVE: 2 seconds passed, saving row', this.autoSaveRowIndex);

    const gridApi = this.autoSaveIsProductsGrid ? this.productsGridApi : this.offerGridApi;
    const rowNode = gridApi?.getDisplayedRowAtIndex(this.autoSaveRowIndex);

    if (rowNode && rowNode.data) {
      this.savingRow = true;
      this.AddUpdatePurchaseOrderCartItem({
        data: rowNode.data,
        node: rowNode,
        api: gridApi
      });
      this.savingRow = false;
    }

    // Clear pending save state
    this.autoSaveTimer = null;
    this.autoSaveRowIndex = -1;
    this.autoSavePendingCartItem = null;
  }

  // Check if the current cell being edited is on the same row as pending save
  onCellEditingStarted(rowIndex: number, isProductsGrid: boolean, colId?: string): void {
    // If editing same row that has pending save, cancel the timer (user still editing)
    // But only cancel if it's a DIFFERENT column (user moved to edit another field)
    if (this.autoSaveTimer && this.autoSaveRowIndex === rowIndex && this.autoSaveIsProductsGrid === isProductsGrid) {
      if (colId && this.autoSaveLastEditedColumn && colId !== this.autoSaveLastEditedColumn) {
        console.log('⏱️ AUTO-SAVE: Different column edit started on same row, cancelling timer');
        this.cancelAutoSaveTimer();
      } else {
        console.log('⏱️ AUTO-SAVE: Same column edit event ignored (likely from refreshCells)');
      }
    }
  }

  hasSelectedCartItems(): boolean {
    return this.ProductItems?.some((item: any) => item.CartItem?.IsSelected === true) || false;
  }

  // ✅ Check if EditContainer grid has selected items
  hasSelectedEditContainerItems(): boolean {
    return this.CartItemRows?.some((item: any) => item.CartItem?.IsSelected === true) || false;
  }

  // ✅ Get all selected cart items from Products grid
  getSelectedProductItems(): any[] {
    return this.ProductItems?.filter((item: any) => item.CartItem?.IsSelected === true) || [];
  }

  // ✅ Bulk update all selected cart items using the new bulk endpoint
  BulkUpdateSelectedCartItems(selectedItems?: any[]): void {
    const items = selectedItems || this.getSelectedProductItems();
    if (items.length === 0) return;

    // Get PurchaseOrderDBID from first item (all should be from same order)
    const firstItem = items[0];
    const purchaseOrderDBID = firstItem?.CartItem?.CartItemOrderInfo?.OrderDBID
      || firstItem?.PurchaseOrderDBID
      || firstItem?.OfferDBID
      || this.CurrentOrder?.DBID;

    if (!purchaseOrderDBID) {
      console.error('BulkUpdateSelectedCartItems: No PurchaseOrderDBID found');
      return;
    }

    // Extract CartItems from the row data
    const cartItems = items.map((item: any) => item.CartItem).filter((ci: any) => ci != null);
    if (cartItems.length === 0) return;

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItems: cartItems,
      PurchaseOrderDBID: purchaseOrderDBID
    };

    // Use savingGridRow for minimalist spinner
    this.savingGridRow = true;
    this.managementService.BulkUpdatePurchaseOrderCartItems(request).subscribe((response: any) => {
      this.savingGridRow = false;
      if (response.Status === 1) {
        // Success - no snackbar, just silently complete
        console.log(`✅ Bulk updated ${response.UpdatedCount} items`);
        // ✅ Save undo snapshot AFTER successful save
        this.saveUndoSnapshot();
      } else {
        console.error('❌ Bulk update failed:', response.Message);
        this.parent.openSnackBar(response.Message || 'Bulk update failed', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.savingGridRow = false;
      console.error('❌ Bulk update error:', error);
      this.parent.openSnackBar('Bulk update failed', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Deselect all items in Products grid (called by overlay click)
  deselectAllProductItems(): void {
    this.ProductItems?.forEach((item: any) => {
      if (item.CartItem) item.CartItem.IsSelected = false;
    });
    this.productsHeaderCheckboxSelected = false;
    this.productsGridApi?.refreshCells({ columns: ['index'], force: true });
    this.updateHeaderCheckbox(this.productsGridApi);
  }

  // ✅ Deselect all items in EditContainer grid (called by overlay click)
  deselectAllEditContainerItems(): void {
    this.CartItemRows?.forEach((item: any) => {
      if (item.CartItem) item.CartItem.IsSelected = false;
    });
    this.offerHeaderCheckboxSelected = false;
    this.offerGridApi?.refreshCells({ columns: ['index'], force: true });
    this.updateOfferHeaderCheckbox();
  }

  // ✅ Save all selected items in EditContainer grid
  SaveAllSelectedEditContainerItems() {
    console.log('💾 ORDER-CONFIRMATIONS: SaveAllSelectedEditContainerItems called');
    console.log('   CartItemRows:', this.CartItemRows?.length);

    const selectedItems = this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];
    console.log('   Selected items:', selectedItems.length);

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      return;
    }

    let savedCount = 0;
    let errorCount = 0;
    this.parent.loading = true;

    selectedItems.forEach((item: any) => {
      const cartItem = item.CartItem;
      // Try multiple sources for PurchaseOrderDBID
      const purchaseOrderDBID = cartItem?.CartItemOrderInfo?.OrderDBID || item.PurchaseOrderDBID || item.OfferDBID || this.CurrentOrder?.DBID;

      console.log('   Item:', item);
      console.log('   purchaseOrderDBID:', purchaseOrderDBID);

      if (!cartItem || !purchaseOrderDBID) {
        console.log('   ❌ Skipping item - missing cartItem or purchaseOrderDBID');
        errorCount++;
        return;
      }

      const request = {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItem: cartItem,
        PurchaseOrderDBID: purchaseOrderDBID
      };

      this.managementService.AddUpdatePurchaseOrderCartItem(request).subscribe((response: any) => {
        if (response.Status === 1) {
          savedCount++;
        } else {
          errorCount++;
        }

        // Check if all requests completed
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          // Deselect all cart items
          this.CartItemRows?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.offerGridApi?.refreshCells({ columns: ['index'], force: true });

          if (errorCount === 0) {
            this.parent.openSnackBar(`Saved ${savedCount} items`, 'OK', 'light-info-snackbar');
          } else {
            this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
          }
        }
      }, () => {
        errorCount++;
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          this.CartItemRows?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.offerGridApi?.refreshCells({ columns: ['index'], force: true });
          this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
        }
      });
    });
  }

  SaveAllSelectedCartItems() {
    // Get all selected rows from ProductItems
    const selectedItems = this.ProductItems?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      return;
    }

    let savedCount = 0;
    let errorCount = 0;
    this.parent.loading = true;

    selectedItems.forEach((item: any) => {
      const cartItem = item.CartItem;
      // Try multiple sources for PurchaseOrderDBID
      const purchaseOrderDBID = cartItem?.CartItemOrderInfo?.OrderDBID || item.PurchaseOrderDBID || item.OfferDBID;

      console.log('   Item:', item);
      console.log('   purchaseOrderDBID:', purchaseOrderDBID);

      if (!cartItem || !purchaseOrderDBID) {
        console.log('   ❌ Skipping item - missing cartItem or purchaseOrderDBID');
        errorCount++;
        return;
      }

      const request = {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItem: cartItem,
        PurchaseOrderDBID: purchaseOrderDBID
      };

      this.managementService.AddUpdatePurchaseOrderCartItem(request).subscribe((response: any) => {
        if (response.Status === 1) {
          savedCount++;
        } else {
          errorCount++;
        }

        // Check if all requests completed
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          // Deselect all cart items
          this.ProductItems?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.productsHeaderCheckboxSelected = false;
          this.productsGridApi?.refreshCells({ columns: ['index'], force: true });
          this.updateHeaderCheckbox(this.productsGridApi);

          // ✅ Save undo snapshot AFTER all saves completed successfully
          if (savedCount > 0) {
            this.saveUndoSnapshot();
          }

          if (errorCount === 0) {
            this.parent.openSnackBar(`Saved ${savedCount} items`, 'OK', 'light-info-snackbar');
          } else {
            this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
          }
        }
      }, () => {
        errorCount++;
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          // Deselect all cart items
          this.ProductItems?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.productsHeaderCheckboxSelected = false;
          this.productsGridApi?.refreshCells({ columns: ['index'], force: true });
          this.updateHeaderCheckbox(this.productsGridApi);

          this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
        }
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    if (this.offerGridApi) {
      this.offerGridApi.sizeColumnsToFit();
      setTimeout(() => this.syncColumnWidths(), 100);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    console.log('🔑 ORDER-CONFIRMATIONS: Key pressed:', event.key, 'Ctrl:', event.ctrlKey);

    if (event.ctrlKey && event.key === 's') {
      event.preventDefault();
      console.log('💾 ORDER-CONFIRMATIONS: Ctrl+S detected');
      console.log('   ShowEditContainer:', this.ShowEditContainer);
      console.log('   hasSelectedEditContainerItems:', this.hasSelectedEditContainerItems());
      console.log('   hasSelectedCartItems:', this.hasSelectedCartItems());
      console.log('   CartItemRows length:', this.CartItemRows?.length);
      console.log('   ProductItems length:', this.ProductItems?.length);

      // ✅ Check EditContainer first (if open), then Products tab
      if (this.ShowEditContainer && this.hasSelectedEditContainerItems()) {
        console.log('✅ ORDER-CONFIRMATIONS: Saving EditContainer items');
        this.SaveAllSelectedEditContainerItems();
      } else if (this.hasSelectedCartItems()) {
        console.log('✅ ORDER-CONFIRMATIONS: Saving Products tab items');
        this.SaveAllSelectedCartItems();
      } else {
        console.log('⚠️ ORDER-CONFIRMATIONS: No items selected to save');
        this.parent.openSnackBar('No items selected to save', 'OK', 'alert-info-snackbar');
      }
    }
    if (event.ctrlKey && event.key === 'd') {
      event.preventDefault();
      console.log('🗑️ ORDER-CONFIRMATIONS: Ctrl+D detected');
      // ✅ Check EditContainer first (if open), then Products tab
      if (this.ShowEditContainer && this.hasSelectedEditContainerItems()) {
        this.IsMultiDeleteEditContainer = true;
        this.ShowDeleteCartItemConfirmation = true;
      } else if (this.hasSelectedCartItems()) {
        this.IsMultiDelete = true;
        this.ShowDeleteCartItemConfirmation = true;
      }
    }
  }

  ConfirmDeleteCartItem() {
    if (this.IsMultiDeleteEditContainer) {
      this.DeleteAllSelectedEditContainerItems();
    } else if (this.IsMultiDelete) {
      this.DeleteAllSelectedCartItems();
    } else {
      this.DeleteSingleCartItem();
    }
  }

  DeleteSingleCartItem() {
    if (!this.DeleteCartItemParams) {
      this.ShowDeleteCartItemConfirmation = false;
      return;
    }

    const cartItem = this.DeleteCartItemParams.data?.CartItem;
    const cartItemID = cartItem?.ID;

    if (!cartItemID || cartItemID <= 0) {
      this.parent.openSnackBar('Cannot delete: missing cart item ID', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.DeleteCartItemParams = null;
      return;
    }

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItemID: cartItemID
    };

    this.parent.loading = true;
    this.managementService.DeletePurchaseOrderCartItem(request).subscribe((res: any) => {
      this.parent.loading = false;
      if (res.Status === 1) {
        this.parent.openSnackBar('Item deleted', 'OK', 'alert-info-snackbar');
        // Remove the item from the ProductItems array and refresh grid
        const rowIndex = this.DeleteCartItemParams.rowIndex;
        if (rowIndex >= 0 && this.ProductItems) {
          this.ProductItems.splice(rowIndex, 1);
          this.productsGridApi?.setRowData(this.ProductItems);
        }
      } else {
        this.parent.openSnackBar(res.Message || 'Error deleting', 'OK', 'alert-info-snackbar');
      }
      this.ShowDeleteCartItemConfirmation = false;
      this.DeleteCartItemParams = null;
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error deleting', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.DeleteCartItemParams = null;
    });
  }

  DeleteAllSelectedCartItems() {
    const selectedItems = this.ProductItems?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
      return;
    }

    const deleteRequests = selectedItems.map((item: any) => {
      const cartItemID = item.CartItem?.ID;
      if (!cartItemID || cartItemID <= 0) return null;
      return {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItemID: cartItemID
      };
    }).filter((req: any) => req !== null);

    if (deleteRequests.length === 0) {
      this.parent.openSnackBar('No valid items to delete', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
      return;
    }

    this.parent.loading = true;
    let deletedCount = 0;
    let errorCount = 0;
    const deletedIds: number[] = [];

    forkJoin(deleteRequests.map((req: any) => this.managementService.DeletePurchaseOrderCartItem(req))).subscribe((results: any[]) => {
      this.parent.loading = false;
      results.forEach((res: any, index: number) => {
        if (res.Status === 1) {
          deletedCount++;
          deletedIds.push(deleteRequests[index].CartItemID);
        } else {
          errorCount++;
        }
      });

      // Remove deleted items from ProductItems
      if (deletedIds.length > 0) {
        this.ProductItems = this.ProductItems.filter((item: any) => !deletedIds.includes(item.CartItem?.ID));
        this.productsGridApi?.setRowData(this.ProductItems);
      }

      // Deselect all and reset header checkbox
      this.ProductItems?.forEach((item: any) => {
        if (item.CartItem) item.CartItem.IsSelected = false;
      });
      this.productsHeaderCheckboxSelected = false;
      this.updateHeaderCheckbox(this.productsGridApi);
      this.productsGridApi?.refreshCells({ force: true });

      this.parent.openSnackBar(`Deleted ${deletedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error deleting items', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
    });
  }

  // ✅ Delete all selected items in EditContainer grid
  DeleteAllSelectedEditContainerItems() {
    const selectedItems = this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
      return;
    }

    const deleteRequests = selectedItems.map((item: any) => {
      const cartItemID = item.CartItem?.ID;
      if (!cartItemID || cartItemID <= 0) return null;
      return {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItemID: cartItemID
      };
    }).filter((req: any) => req !== null);

    if (deleteRequests.length === 0) {
      this.parent.openSnackBar('No valid items to delete', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
      return;
    }

    this.parent.loading = true;
    let deletedCount = 0;
    let errorCount = 0;
    const deletedIds: number[] = [];

    forkJoin(deleteRequests.map((req: any) => this.managementService.DeletePurchaseOrderCartItem(req))).subscribe((results: any[]) => {
      this.parent.loading = false;
      results.forEach((res: any, index: number) => {
        if (res.Status === 1) {
          deletedCount++;
          deletedIds.push(deleteRequests[index].CartItemID);
        } else {
          errorCount++;
        }
      });

      // Remove deleted items from CartItemRows and CurrentOrder.Cart.Items
      if (deletedIds.length > 0) {
        this.CartItemRows = this.CartItemRows.filter((item: any) => !deletedIds.includes(item.CartItem?.ID));
        this.offerGridApi?.setRowData(this.CartItemRows);
        // Also remove from CurrentOrder.Cart.Items
        if (this.CurrentOrder?.Cart?.Items) {
          this.CurrentOrder.Cart.Items = this.CurrentOrder.Cart.Items.filter((item: any) => !deletedIds.includes(item.ID));
        }
      }

      // Deselect all
      this.CartItemRows?.forEach((item: any) => {
        if (item.CartItem) item.CartItem.IsSelected = false;
      });
      this.offerGridApi?.refreshCells({ force: true });

      this.parent.openSnackBar(`Deleted ${deletedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error deleting items', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
    });
  }

  // ✅ Progress Status right-click popup methods
  closeProgressStatusCellPopup(): void {
    this.showProgressStatusCellPopup = false;
    this.progressStatusPopupCartItem = null;
    this.progressStatusPopupRowIndex = -1;
  }

  // ✅ Helper methods for ProgressStatus colors (used in filter popup)
  getProgressStatusBgColor(statusId: number): string {
    // ePurchaseOrderStatus enum values:
    // New = 0, Processing = 1, Acknowledged = 2, PickupInitiated = 6, Shipping = 7, PartiallyShipping = 8, Completed = 10, Canceled = 11
    switch (statusId) {
      case 0: // New
        return '#bbdefb';
      case 1: // Processing
        return '#ffe0b2';
      case 2: // Acknowledged
        return '#c8e6c9';
      case 6: // PickupInitiated
        return '#e1bee7';
      case 7: // Shipping
        return '#d1c4e9';
      case 8: // PartiallyShipping
        return '#fff9c4';
      case 10: // Completed
        return '#b2dfdb';
      case 11: // Canceled
        return '#ffc2b3';
      default:
        return 'transparent';
    }
  }

  getProgressStatusTextColor(statusId: number): string {
    // ePurchaseOrderStatus enum values:
    // New = 0, Processing = 1, Acknowledged = 2, PickupInitiated = 6, Shipping = 7, PartiallyShipping = 8, Completed = 10, Canceled = 11
    switch (statusId) {
      case 0: // New
        return '#1565c0';
      case 1: // Processing
        return '#e65100';
      case 2: // Acknowledged
        return '#2e7d32';
      case 6: // PickupInitiated
        return '#7b1fa2';
      case 7: // Shipping
        return '#4527a0';
      case 8: // PartiallyShipping
        return '#f57f17';
      case 10: // Completed
        return '#00695c';
      case 11: // Canceled
        return '#c62828';
      default:
        return '#333';
    }
  }

  selectProgressStatusForCartItem(status: any): void {
    if (!this.progressStatusPopupCartItem) {
      this.closeProgressStatusCellPopup();
      return;
    }

    // Check if we have multiple selected items (bulk update)
    const selectedItems = this.progressStatusPopupIsProductsGrid
      ? this.getSelectedProductItems()
      : this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length > 1) {
      // Apply ProgressStatus to ALL selected items
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          item.CartItem.ProgressStatus = JSON.parse(JSON.stringify(status));
        }
      });

      // Refresh the grid and bulk save
      if (this.progressStatusPopupIsProductsGrid) {
        this.productsGridApi?.refreshCells({ force: true });
        // Bulk update all selected items (Products grid)
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        this.offerGridApi?.refreshCells({ force: true });
        // ✅ Bulk update all selected items (Offers/EditContainer grid)
        if (this.AutoSave) {
          this.SaveAllSelectedEditContainerItems();
        }
      }
    } else {
      // Single item update (original behavior)
      this.progressStatusPopupCartItem.ProgressStatus = status;

      // Refresh the grid
      if (this.progressStatusPopupIsProductsGrid) {
        this.productsGridApi?.refreshCells({ force: true });
        // ✅ Trigger auto-save for single item (Products grid)
        this.startAutoSaveTimer(this.progressStatusPopupRowIndex, this.progressStatusPopupCartItem, true);
      } else {
        this.offerGridApi?.refreshCells({ force: true });
        // ✅ Trigger auto-save for single item (Offers grid)
        this.startAutoSaveTimer(this.progressStatusPopupRowIndex, this.progressStatusPopupCartItem, false);
      }
    }

    this.closeProgressStatusCellPopup();
  }

  // ✅ Progress Status double-click shortcut handler
  // Shortcuts: New -> Acknowledged -> PickupInitiated -> Shipping -> Completed
  // Canceled (-1) and Completed (5) are end states
  handleProgressStatusDoubleClick(params: any, isProductsGrid: boolean): void {
    const cartItem = params.data?.CartItem;
    if (!cartItem) return;

    // Check if we have multiple selected items (bulk update)
    const selectedItems = isProductsGrid
      ? this.getSelectedProductItems()
      : this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    // Get the next status based on current status
    const getNextStatus = (currentStatusId: number): any => {
      // ePurchaseOrderStatus enum values:
      // New = 0, Processing = 1, Acknowledged = 2, PickupInitiated = 6, Shipping = 7, PartiallyShipping = 8, Completed = 10, Canceled = 11
      let nextStatusId: number | null = null;

      switch (currentStatusId) {
        case 0: // New -> Processing
          nextStatusId = 1;
          break;
        case 1: // Processing -> Acknowledged
          nextStatusId = 2;
          break;
        case 2: // Acknowledged -> PickupInitiated
          nextStatusId = 6;
          break;
        case 6: // PickupInitiated -> Shipping
          nextStatusId = 7;
          break;
        case 7: // Shipping -> Completed
          nextStatusId = 10;
          break;
        case 8: // PartiallyShipping -> Shipping
          nextStatusId = 7;
          break;
        case 10: // Completed -> does nothing (end state)
          return null;
        case 11: // Canceled -> does nothing (end state)
          return null;
        default:
          return null;
      }

      // Find the status object from MasterData
      return this.MasterData?.PurchaseOrderStatuses?.find((s: any) => s.ID === nextStatusId) || null;
    };

    if (selectedItems.length > 1) {
      // Apply shortcut to ALL selected items individually
      let hasChanges = false;
      selectedItems.forEach((item: any) => {
        if (item.CartItem?.ProgressStatus) {
          const nextStatus = getNextStatus(item.CartItem.ProgressStatus.ID);
          if (nextStatus) {
            item.CartItem.ProgressStatus = JSON.parse(JSON.stringify(nextStatus));
            hasChanges = true;
          }
        }
      });

      if (hasChanges) {
        // Refresh the grid and bulk save
        if (isProductsGrid) {
          this.productsGridApi?.refreshCells({ force: true });
          // Bulk update all selected items (Products grid)
          this.BulkUpdateSelectedCartItems(selectedItems);
        } else {
          this.offerGridApi?.refreshCells({ force: true });
          // ✅ Bulk update all selected items (Offers/EditContainer grid)
          if (this.AutoSave) {
            this.SaveAllSelectedEditContainerItems();
          }
        }
      }
    } else {
      // Single item update
      const currentStatusId = cartItem.ProgressStatus?.ID;
      const nextStatus = getNextStatus(currentStatusId);

      if (nextStatus) {
        cartItem.ProgressStatus = nextStatus;

        // Refresh the grid and trigger auto-save
        if (isProductsGrid) {
          this.productsGridApi?.refreshCells({ force: true });
          // ✅ Trigger auto-save for single item (Products grid)
          this.startAutoSaveTimer(params.rowIndex, cartItem, true);
        } else {
          this.offerGridApi?.refreshCells({ force: true });
          // ✅ Trigger auto-save for single item (Offers grid)
          this.startAutoSaveTimer(params.rowIndex, cartItem, false);
        }
      }
    }
  }

  // ========== IndexedDB Undo System ==========

  // Initialize the IndexedDB database for undo snapshots
  private initUndoDatabase(): void {
    const request = indexedDB.open(this.UNDO_DB_NAME, 1);

    request.onerror = () => {
      console.error('❌ Failed to open IndexedDB for undo system');
    };

    request.onsuccess = (event: any) => {
      this.undoDb = event.target.result;
      console.log('✅ IndexedDB undo database opened');
      // ✅ Clear all existing snapshots on page load - always start fresh
      this.clearUndoHistory();
    };

    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(this.UNDO_STORE_NAME)) {
        const store = db.createObjectStore(this.UNDO_STORE_NAME, { keyPath: 'id', autoIncrement: true });
        store.createIndex('timestamp', 'timestamp', { unique: false });
        console.log('✅ IndexedDB undo store created');
      }
    };
  }

  // Save a snapshot of the current ProductItems before any change
  saveUndoSnapshot(): void {
    if (!this.undoDb || !this.ProductItems || this.ProductItems.length === 0) return;

    const snapshot = {
      timestamp: Date.now(),
      data: JSON.parse(JSON.stringify(this.ProductItems)) // Deep copy
    };

    const transaction = this.undoDb.transaction([this.UNDO_STORE_NAME], 'readwrite');
    const store = transaction.objectStore(this.UNDO_STORE_NAME);

    // Add the new snapshot
    const addRequest = store.add(snapshot);
    addRequest.onsuccess = () => {
      console.log('✅ Undo snapshot saved');
      // Cleanup old snapshots (keep only MAX_UNDO_SNAPSHOTS)
      this.cleanupOldSnapshots();
    };

    addRequest.onerror = () => {
      console.error('❌ Failed to save undo snapshot');
    };
  }

  // Remove old snapshots to keep only the latest MAX_UNDO_SNAPSHOTS
  private cleanupOldSnapshots(): void {
    if (!this.undoDb) return;

    const transaction = this.undoDb.transaction([this.UNDO_STORE_NAME], 'readwrite');
    const store = transaction.objectStore(this.UNDO_STORE_NAME);
    const index = store.index('timestamp');

    const getAllRequest = index.getAll();
    getAllRequest.onsuccess = () => {
      const snapshots = getAllRequest.result;
      if (snapshots.length > this.MAX_UNDO_SNAPSHOTS) {
        // Sort by timestamp ascending (oldest first)
        snapshots.sort((a: any, b: any) => a.timestamp - b.timestamp);
        // Delete oldest snapshots
        const toDelete = snapshots.slice(0, snapshots.length - this.MAX_UNDO_SNAPSHOTS);
        toDelete.forEach((snap: any) => {
          store.delete(snap.id);
        });
        console.log(`🗑️ Cleaned up ${toDelete.length} old undo snapshots`);
      }
      this.updateUndoSnapshotCount();
    };
  }

  // Update the count of available undo snapshots
  private updateUndoSnapshotCount(): void {
    if (!this.undoDb) {
      this.undoSnapshotCount = 0;
      return;
    }

    const transaction = this.undoDb.transaction([this.UNDO_STORE_NAME], 'readonly');
    const store = transaction.objectStore(this.UNDO_STORE_NAME);
    const countRequest = store.count();

    countRequest.onsuccess = () => {
      this.undoSnapshotCount = countRequest.result;
      console.log(`📊 Undo snapshots available: ${this.undoSnapshotCount}`);
    };
  }

  // Undo: restore the PREVIOUS snapshot (second-latest) and delete the CURRENT snapshot (latest)
  // This correctly implements undo - going back to the state BEFORE the last change
  undoLastChange(): void {
    if (!this.undoDb || this.undoSnapshotCount <= 1) {
      this.parent.openSnackBar('No undo history available', 'OK', 'alert-info-snackbar');
      return;
    }

    const transaction = this.undoDb.transaction([this.UNDO_STORE_NAME], 'readwrite');
    const store = transaction.objectStore(this.UNDO_STORE_NAME);
    const index = store.index('timestamp');

    // Get all snapshots sorted by timestamp
    const getAllRequest = index.getAll();
    getAllRequest.onsuccess = () => {
      const snapshots = getAllRequest.result;
      if (snapshots.length <= 1) {
        this.parent.openSnackBar('No undo history available', 'OK', 'alert-info-snackbar');
        return;
      }

      // Sort by timestamp descending (newest first)
      // snapshots[0] = current state (newest), snapshots[1] = previous state
      snapshots.sort((a: any, b: any) => b.timestamp - a.timestamp);
      const currentSnapshot = snapshots[0];  // The state we're undoing FROM (will be deleted)
      const previousSnapshot = snapshots[1]; // The state we're undoing TO (will be restored)

      // Restore the PREVIOUS state (go back one step)
      this.ProductItems = previousSnapshot.data;
      this.productsGridApi?.setRowData(this.ProductItems);
      console.log('↩️ Undo: restored snapshot from', new Date(previousSnapshot.timestamp).toLocaleTimeString());

      // Delete the CURRENT snapshot (we're abandoning this state)
      store.delete(currentSnapshot.id);
      this.updateUndoSnapshotCount();

      // ✅ Show "Save All" button to remind user to persist the undo to database
      this.showSaveAfterUndo = true;
    };

    getAllRequest.onerror = () => {
      console.error('❌ Failed to retrieve undo snapshot');
      this.parent.openSnackBar('Failed to undo', 'OK', 'alert-info-snackbar');
    };
  }

  // Clear all undo history (useful when loading new data)
  clearUndoHistory(): void {
    if (!this.undoDb) return;

    const transaction = this.undoDb.transaction([this.UNDO_STORE_NAME], 'readwrite');
    const store = transaction.objectStore(this.UNDO_STORE_NAME);
    store.clear();
    this.undoSnapshotCount = 0;
    console.log('🗑️ Undo history cleared');
  }

  // Save all cart items after undo - persists the restored state to the database using BULK API
  SaveAllCartItemsAfterUndo(): void {
    const allItems = this.ProductItems?.filter((item: any) => item.CartItem && item.CartItem.ID > 0) || [];

    if (allItems.length === 0) {
      this.parent.openSnackBar('No items to save', 'OK', 'alert-info-snackbar');
      this.showSaveAfterUndo = false;
      return;
    }

    // Get PurchaseOrderDBID from first item (all items should be from same order)
    const firstItem = allItems[0];
    const purchaseOrderDBID = firstItem?.CartItem?.CartItemOrderInfo?.OrderDBID
      || firstItem?.PurchaseOrderDBID
      || firstItem?.OfferDBID
      || this.CurrentOrder?.DBID;

    if (!purchaseOrderDBID) {
      this.parent.openSnackBar('Cannot save: missing order reference', 'OK', 'alert-info-snackbar');
      this.showSaveAfterUndo = false;
      return;
    }

    // Extract CartItems from the row data
    const cartItems = allItems.map((item: any) => item.CartItem).filter((ci: any) => ci != null);
    if (cartItems.length === 0) {
      this.parent.openSnackBar('No items to save', 'OK', 'alert-info-snackbar');
      this.showSaveAfterUndo = false;
      return;
    }

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItems: cartItems,
      PurchaseOrderDBID: purchaseOrderDBID
    };

    this.savingGridRow = true;
    this.managementService.BulkUpdatePurchaseOrderCartItems(request).subscribe((response: any) => {
      this.savingGridRow = false;
      this.showSaveAfterUndo = false;

      if (response.Status === 1) {
        this.parent.openSnackBar(`All ${response.UpdatedCount || cartItems.length} items saved successfully`, 'OK', 'alert-info-snackbar');
        // Save a new snapshot after persisting to DB
        this.saveUndoSnapshot();
      } else {
        this.parent.openSnackBar(response.Message || 'Bulk save failed', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.savingGridRow = false;
      this.showSaveAfterUndo = false;
      console.error('❌ Bulk save error:', error);
      this.parent.openSnackBar('Bulk save failed', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Lock Shipping Settings toggle handler
  onLockShippingSettingsChange() {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PurchaseOrderDBID: this.CurrentOrder?.DBID,
      LockShippingSettings: this.CurrentOrder?.Cart?.LockShippingSettings
    };

    this.managementService.UpdatePurchaseOrderCartLockShippingSettings(request).subscribe();
  }

  // ✅ Get project discount amount (OriginalTotal - Total after discount)
  getProjectDiscountAmount(): string {
    const originalTotal = this.CurrentOrder?.Cart?.OriginalTotal?.TotalQtyPriceNOVAT || 0;
    const discountedTotal = this.CurrentOrder?.Cart?.Total?.TotalQtyPriceNOVAT || 0;
    const discountAmount = originalTotal - discountedTotal;
    return discountAmount.toFixed(2);
  }

  // ✅ Get absolute total (Subtotal after discount + Shipping Cost)
  getAbsoluteTotal(): string {
    const subtotalAfterDiscount = this.CurrentOrder?.Cart?.Total?.TotalQtyPriceNOVAT || 0;
    const shippingCost = this.CurrentOrder?.Cart?.ShippingCost?.UIUnitPrice || 0;
    const absoluteTotal = subtotalAfterDiscount + shippingCost;
    return absoluteTotal.toFixed(2);
  }

  // ✅ Recalculate cart-level totals after quantity/price/discount changes in AG-Grid
  recalculateCartTotals(): void {
    if (!this.CurrentOrder?.Cart) return;

    // Sum all cart item totals (UIQtyPrice = FinalPrice × Quantity)
    let subtotalNOVAT = 0;
    const items = this.CurrentOrder.Cart.Items || [];
    for (const item of items) {
      subtotalNOVAT += item?.Price?.UIQtyPrice || 0;
    }
    subtotalNOVAT = Math.round(subtotalNOVAT * 100) / 100;

    // Store in OriginalTotal (before discount)
    if (!this.CurrentOrder.Cart.OriginalTotal) {
      this.CurrentOrder.Cart.OriginalTotal = {};
    }
    this.CurrentOrder.Cart.OriginalTotal.TotalQtyPriceNOVAT = subtotalNOVAT;

    // Apply project discount if exists
    let discountedTotal = subtotalNOVAT;
    const discount = this.CurrentOrder.Cart.Total?.Discount;
    if (discount && discount.Value > 0 && discount.Type) {
      if (discount.Type.ID === 1) {
        // Percentage discount
        discountedTotal = subtotalNOVAT * (1 - discount.Value / 100);
      } else if (discount.Type.ID === 2) {
        // Absolute value discount
        discountedTotal = subtotalNOVAT - discount.Value;
      }
      discountedTotal = Math.round(discountedTotal * 100) / 100;
    }

    // Store in Total (after discount)
    if (!this.CurrentOrder.Cart.Total) {
      this.CurrentOrder.Cart.Total = {};
    }
    this.CurrentOrder.Cart.Total.TotalQtyPriceNOVAT = discountedTotal;
  }

  // ✅ Sync all CartItems from the AG Grid back to CurrentOrder.Cart.Items
  syncGridItemsToCurrentOrder(): void {
    if (!this.offerGridApi || !this.CurrentOrder?.Cart) return;
    const gridItems: any[] = [];
    let mismatchCount = 0;
    const oldItems = this.CurrentOrder.Cart.Items || [];
    this.offerGridApi.forEachNode((node: any, nodeIndex: number) => {
      if (node.data?.CartItem) {
        gridItems.push(node.data.CartItem);
        const oldItem = oldItems[nodeIndex];
        if (oldItem && oldItem !== node.data.CartItem) {
          mismatchCount++;
          console.warn(`🔗 [PO-syncGridItems] ROW ${nodeIndex} MISMATCH! Grid CartItem.ID=${node.data.CartItem?.ID} (Qty=${node.data.CartItem?.Quantity}) vs CurrentOrder CartItem.ID=${oldItem?.ID} (Qty=${oldItem?.Quantity})`);
        }
      }
    });
    console.log(`🔗 [PO-syncGridItems] Grid nodes: ${gridItems.length}, Old items: ${oldItems.length}, Mismatches fixed: ${mismatchCount}`);
    if (gridItems.length > 0) {
      this.CurrentOrder.Cart.Items = gridItems;
    }
  }

  // ✅ Sync a single CartItem back to CurrentOrder.Cart.Items by matching ID
  syncCartItemToCurrentOrder(updatedCartItem: any): void {
    if (!this.CurrentOrder?.Cart?.Items || !updatedCartItem) return;
    const idx = this.CurrentOrder.Cart.Items.findIndex((item: any) =>
      item.ID && updatedCartItem.ID && item.ID === updatedCartItem.ID
    );
    if (idx !== -1) {
      this.CurrentOrder.Cart.Items[idx] = updatedCartItem;
      console.log(`🔗 [PO-syncCartItem] Synced CartItem.ID=${updatedCartItem?.ID} at index ${idx}`);
    } else {
      console.warn(`🔗 [PO-syncCartItem] CartItem.ID=${updatedCartItem?.ID} NOT FOUND in CurrentOrder.Cart.Items`);
    }
  }


  // ========== EDITCONTAINER PARTNER & CURRENCY MANAGEMENT ==========

  onEditContainerPartnerSearchFocus(): void {
    this.showEditContainerPartnerResults = true;
    if (this.editContainerSearchedPartners.length === 0) {
      this.GetEditContainerPartnersFiltered();
    }
  }

  GetEditContainerPartnersFiltered(): void {
    const request = {
      SearchTerm: this.editContainerPartnerSearchTerm,
      PageIndex: 1,
      PageSize: 20,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.editContainerLoadingPartners = true;
    this.service.GetPartnersFiltered(request).subscribe((response: any) => {
      this.editContainerLoadingPartners = false;
      if (response["Status"] == 1) {
        this.editContainerSearchedPartners = response["Partners"] || [];
      }
    });
  }

  selectEditContainerPartner(partner: any): void {
    // If order is already saved, show confirmation popup
    if (this.CurrentOrder?.DBID && this.CurrentOrder.DBID > 0 && this.CurrentOrder?.Cart?.ID > 0) {
      this.PendingPartnerChange = partner;
      this.ShowChangePartnerConfirmation = true;
      this.showEditContainerPartnerResults = false;
      this.editContainerPartnerSearchTerm = '';
      this.editContainerSearchedPartners = [];
    } else {
      // Order not saved yet, just update locally
      if (this.CurrentOrder?.Cart) {
        this.CurrentOrder.Cart.Partner = partner;
      }
      this.showEditContainerPartnerResults = false;
      this.editContainerPartnerSearchTerm = '';
      this.editContainerSearchedPartners = [];
    }
  }

  confirmChangePartner(): void {
    if (!this.PendingPartnerChange || !this.CurrentOrder?.Cart?.ID) {
      this.ShowChangePartnerConfirmation = false;
      this.PendingPartnerChange = null;
      return;
    }

    this.parent.loading = true;
    this.ShowChangePartnerConfirmation = false;

    const request = {
      CartID: this.CurrentOrder.Cart.ID,
      NewPartner: this.PendingPartnerChange,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
    };

    this.managementService.ChangePurchaseOrderPartner(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1) {
          // Update CurrentOrder with the new partner
          this.CurrentOrder.Cart.Partner = this.PendingPartnerChange;
          // Reload offer items to refresh data
          setTimeout(() => {
            this.loadOfferGridData();
          }, 0);
          this.parent.openSnackBar('Partner updated successfully', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating partner', 'OK', 'alert-info-snackbar');
        }
        this.PendingPartnerChange = null;
      },
      error: (err: any) => {
        this.parent.loading = false;
        this.parent.openSnackBar('Error updating partner', 'OK', 'alert-info-snackbar');
        this.PendingPartnerChange = null;
      }
    });
  }

  cancelChangePartner(): void {
    this.ShowChangePartnerConfirmation = false;
    this.PendingPartnerChange = null;
  }

  openPartnerInNewTab(): void {
    if (this.CurrentOrder?.Cart?.Partner?.ID) {
      const url = `/management/partners/data?partnerID=${encodeURIComponent(this.CurrentOrder.Cart.Partner.ID)}`;
      window.open(url, '_blank');
    }
  }

  clearEditContainerPartnerSearch(): void {
    this.editContainerPartnerSearchTerm = '';
    this.editContainerSearchedPartners = [];
    this.showEditContainerPartnerResults = false;
  }

  toggleEditContainerCurrencyDropdown(): void {
    this.showEditContainerCurrencyResults = !this.showEditContainerCurrencyResults;
  }

  selectEditContainerCurrency(currency: any): void {
    if (!this.CurrentOrder?.DBID || this.CurrentOrder.DBID <= 0) {
      this.parent.openSnackBar('Order not saved yet', 'OK', 'alert-info-snackbar');
      return;
    }

    this.parent.loading = true;
    this.showEditContainerCurrencyResults = false;

    const request = {
      PurchaseOrderDBID: this.CurrentOrder.DBID,
      CurrencyID: currency.ID,
      NewCurrency: currency,
      PurchaseOrder: this.CurrentOrder,
      Language: this.parent.getLanguage(),
      User: this.parent.User,
    };

    this.managementService.ChangePurchaseOrderCurrency(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1) {
          // Update CurrentOrder with the returned PurchaseOrder (with exchanged prices)
          if (response.PurchaseOrder) {
            this.CurrentOrder = response.PurchaseOrder;
          } else {
            this.CurrentOrder.Cart.Currency = currency;
          }
          // Reload offer items to get updated prices
          this.loadOfferGridData();
          this.parent.openSnackBar('Currency updated with exchanged prices', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating currency', 'OK', 'alert-info-snackbar');
        }
      },
      error: (err: any) => {
        this.parent.loading = false;
        this.parent.openSnackBar('Error updating currency', 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ✅ DeliveryPreference right-click popup methods
  closeDeliveryPreferencePopup(): void {
    this.showDeliveryPreferencePopup = false;
    this.deliveryPreferencePopupCartItem = null;
    this.deliveryPreferencePopupRowIndex = -1;
  }

  selectDeliveryPreferenceForCartItem(pref: any): void {
    if (!this.deliveryPreferencePopupCartItem) { this.closeDeliveryPreferencePopup(); return; }
    const selectedItems = this.getSelectedProductItems();
    if (selectedItems.length > 1) {
      selectedItems.forEach((item: any) => { if (item.CartItem) item.CartItem.DeliveryPreference = JSON.parse(JSON.stringify(pref)); });
      this.productsGridApi?.refreshCells({ force: true });
      this.BulkUpdateSelectedCartItems(selectedItems);
    } else {
      this.deliveryPreferencePopupCartItem.DeliveryPreference = pref;
      this.productsGridApi?.refreshCells({ force: true });
      this.startAutoSaveTimer(this.deliveryPreferencePopupRowIndex, this.deliveryPreferencePopupCartItem, true);
    }
    this.closeDeliveryPreferencePopup();
  }

  // ✅ ConsolidationType right-click popup methods
  closeConsolidationTypePopup(): void {
    this.showConsolidationTypePopup = false;
    this.consolidationTypePopupCartItem = null;
    this.consolidationTypePopupRowIndex = -1;
  }

  selectConsolidationTypeForCartItem(ct: any): void {
    if (!this.consolidationTypePopupCartItem) { this.closeConsolidationTypePopup(); return; }
    const selectedItems = this.getSelectedProductItems();
    if (selectedItems.length > 1) {
      selectedItems.forEach((item: any) => { if (item.CartItem) item.CartItem.ConsolidationType = JSON.parse(JSON.stringify(ct)); });
      this.productsGridApi?.refreshCells({ force: true });
      this.BulkUpdateSelectedCartItems(selectedItems);
    } else {
      this.consolidationTypePopupCartItem.ConsolidationType = ct;
      this.productsGridApi?.refreshCells({ force: true });
      this.startAutoSaveTimer(this.consolidationTypePopupRowIndex, this.consolidationTypePopupCartItem, true);
    }
    this.closeConsolidationTypePopup();
  }

}
